var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 374.32 96.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1180c4;}.cls-2{fill:#8cb7dd;}.cls-3{fill:#a4c3e2;}.cls-4{fill:#c0d3e9;}.cls-5{fill:#ccdaec;}.cls-6{fill:#d1dfed;}.cls-7{fill:#99bbde;}.cls-8{fill:#bbd0e7;}.cls-9{fill:#dae1ee;}.cls-10{fill:#98bee0;}.cls-11{fill:#cee5e2;}.cls-12{fill:#9cd2d1;}.cls-13{fill:#a9d6d5;}.cls-14{fill:#c8e2e1;}.cls-15{fill:#93cdcc;}.cls-16{fill:#90c5cb;}.cls-17{fill:#9cc0e1;}.cls-18{fill:#91b9df;}.cls-19{fill:#82b0da;}.cls-20{fill:#7baad7;}.cls-21{fill:#6ca3d5;}.cls-22{fill:#b5cce5;}.cls-23{fill:#b5dde8;}.cls-24{fill:#84c1c7;}.cls-25{fill:#b4d3dd;}.cls-26{fill:#81bcc5;}.cls-27{fill:#8ec5ca;}.cls-28{fill:#84c0c9;}.cls-29{fill:#81bbc7;}.cls-30{fill:#93bade;}.cls-31{fill:#81bfc5;}.cls-32{fill:#4f99d1;}.cls-33{fill:#0f86c5;}.cls-34{fill:#1181c0;}.cls-35{fill:#1881c1;}.cls-36{fill:#088ab8;}.cls-37{fill:#2e9ab3;}.cls-38{fill:#40a6b2;}.cls-39{fill:#64b7bc;}.cls-40{fill:#6cc0bd;}.cls-41{fill:#82c3c5;}.cls-42{fill:#b2cbe4;}.cls-43{fill:#619ed1;}.cls-44{fill:#fff;}.cls-45{fill:#99bddf;}.cls-46{fill:#a5c3e1;}.cls-47{fill:#b9d0e5;}.cls-48{fill:#1386c6;}.cls-49{fill:#7aa9d6;}.cls-50{fill:#ccdbea;}.cls-51{fill:#cde5e1;}.cls-52{fill:#9dd2cf;}.cls-53{fill:#a7d5d4;}.cls-54{fill:#bad0e7;}.cls-55{fill:#d9e1ed;}.cls-56{fill:#bfd3e7;}.cls-57{fill:#519ad0;}.cls-58{fill:#81c4c5;}.cls-59{fill:#91bade;}.cls-60{fill:#0888b6;}.cls-61{fill:#91c5c9;}.cls-62{fill:#81bac6;}.cls-63{fill:#42a5b2;}.cls-64{fill:#b4d3dc;}.cls-65{fill:#8ec7ca;}.cls-66{fill:#84c2c9;}.cls-67{fill:#6985bb;}.cls-68{fill:#1870ab;}.cls-69{fill:#5181b7;}.cls-70{fill:#1a619e;}.cls-71{fill:#216faa;}.cls-72{fill:#025ea0;}.cls-73{fill:#036396;}.cls-74{fill:#0a5495;}.cls-75{fill:#adc5e2;}.cls-76{fill:#319cae;}.cls-77{fill:#9fbcde;}.cls-78{fill:#7cb5c1;}.cls-79{fill:#7badbf;}.cls-80{fill:#78aebf;}.cls-81{fill:#74a1d3;}.cls-82{fill:#2b97ab;}.cls-83{fill:#1c91a8;}.cls-84{fill:#58a8ad;}.cls-85{fill:#4ea1ab;}.cls-86{fill:#04919b;}.cls-87{fill:#289da1;}.cls-88{fill:#048c98;}.cls-89{fill:#098997;}.cls-90{fill:#098595;}.cls-91{fill:#b6cedd;}.cls-92{fill:#8cc6c8;}.cls-93{fill:#97cbd7;}.cls-94{fill:#a9d1d3;}.cls-95{fill:#73b6bc;}.cls-96{fill:#a1c2d7;}.cls-97{fill:#bbcee2;}.cls-98{fill:#afc8e1;}.cls-99{fill:#a4c1dd;}.cls-100{fill:#8fb5d8;}.cls-101{fill:#8cb5d0;}.cls-102{fill:#74b8ba;}.cls-103{fill:#add1d4;}.cls-104{fill:#52aeb1;}.cls-105{fill:#08999d;}.cls-106{fill:#5fb1b1;}.cls-107{fill:#42b0aa;}.cls-108{fill:#7abdbb;}.cls-109{fill:#80bfbd;}.cls-110{fill:#50abab;}.cls-111{fill:#005d91;}.cls-112{fill:#7b98c8;}.cls-113{fill:#6e93c6;}.cls-114{fill:#3b81bd;}.cls-115{fill:#027ea9;}.cls-116{fill:#6b93c5;}.cls-117{fill:#9db1d2;}.cls-118{fill:#0b81ac;}.cls-119{fill:#005e90;}.cls-120{fill:#0874a0;}.cls-121{fill:#0c578c;}.cls-122{fill:#6c97ca;}.cls-123{fill:#b3c4e0;}.cls-124{fill:#91b1d7;}.cls-125{fill:#7fa7d2;}.cls-126{fill:#80a6cf;}.cls-127{fill:#85a7d0;}.cls-128{fill:#a1b5d5;}.cls-129{fill:#2d8ba8;}.cls-130{fill:#93add2;}.cls-131{fill:#7aa4b9;}.cls-132{fill:#809fcc;}.cls-133{fill:#6e94c7;}.cls-134{fill:#2687a6;}.cls-135{fill:#25809e;}.cls-136{fill:#119499;}.cls-137{fill:#3ea1a5;}.cls-138{fill:#029194;}.cls-139{fill:#aec7d5;}.cls-140{fill:#a1c7cb;}.cls-141{fill:#72b0b7;}.cls-142{fill:#7fb9ba;}.cls-143{fill:#85b0cc;}.cls-144{fill:#4fa8ac;}.cls-145{fill:#7da3c5;}.cls-146{fill:#80a2c4;}.cls-147{fill:#7398be;}.cls-148{fill:#027e91;}.cls-149{fill:#4d96a7;}.cls-150{fill:#5791b8;}.cls-151{fill:#4a96a8;}.cls-152{fill:#098199;}.cls-153{fill:#048797;}.cls-154{fill:#098295;}.cls-155{fill:#0a8094;}.cls-156{fill:#098193;}.cls-157{fill:#038188;}.cls-158{fill:#018188;}.cls-159{fill:#048087;}.cls-160{fill:#037c90;}.cls-161{fill:#01768b;}.cls-162{fill:#678ec3;}.cls-163{fill:#a4b7d7;}.cls-164{fill:#7c9dcc;}.cls-165{fill:#7398c9;}.cls-166{fill:#7192c5;}.cls-167{fill:#5e86bd;}.cls-168{fill:#5f84bc;}.cls-169{fill:#2ba0a3;}.cls-170{fill:#009293;}.cls-171{fill:#8cc2c7;}.cls-172{fill:#6fb6b7;}.cls-173{fill:#5fabb2;}.cls-174{fill:#40a6a9;}.cls-175{fill:#039497;}.cls-176{fill:#50a4ab;}.cls-177{fill:#2a9b9e;}.cls-178{fill:#058d91;}.cls-179{fill:#159799;}.cls-180{fill:#0c8b8e;}.cls-181{fill:#3681ab;}.cls-182{fill:#027593;}.cls-183{fill:#027e90;}.cls-184{fill:#015d84;}.cls-185{fill:#085981;}.cls-186{fill:#0a6b8d;}.cls-187{fill:#086d8d;}.cls-188{fill:#085881;}.cls-189{fill:#066488;}.cls-190{fill:#145481;}.cls-191{fill:#01768a;}.cls-192{fill:#037589;}.cls-193{fill:#046e83;}.cls-194{fill:#057482;}.cls-195{fill:#046d81;}.cls-196{fill:#056781;}.cls-197{fill:#3074ae;}.cls-198{fill:#869ac5;}.cls-199{fill:#6787bc;}.cls-200{fill:#4281b7;}.cls-201{fill:#5681b4;}.cls-202{fill:#5981b5;}.cls-203{fill:#4c77ac;}.cls-204{fill:#608dc3;}.cls-205{fill:#7e9ccb;}.cls-206{fill:#6f8bc0;}.cls-207{fill:#5581b8;}.cls-208{fill:#95acd2;}.cls-209{fill:#8ca7cf;}.cls-210{fill:#1c5e9c;}.cls-211{fill:#1c5695;}.cls-212{fill:#5f81b6;}.cls-213{fill:#6580b7;}.cls-214{fill:#1b6da9;}.cls-215{fill:#1c6ea9;}.cls-216{fill:#1a4c8e;}.cls-217{fill:#115293;}.cls-218{fill:#1a70ab;}.cls-219{fill:#1774ae;}.cls-220{fill:#1d5d9c;}.cls-221{fill:#4881b6;}.cls-222{fill:#7189bd;}.cls-223{fill:#788bbd;}.cls-224{fill:#18629f;}.cls-225{fill:#19609d;}.cls-226{fill:#1d5595;}.cls-227{fill:#467db2;}.cls-228{fill:#3769a1;}.cls-229{fill:#7384b9;}.cls-230{fill:#7d8abc;}.cls-231{fill:#1f5d9b;}.cls-232{fill:#1b5494;}.cls-233{fill:#1d4a8e;}.cls-234{fill:#20478b;}.cls-235{fill:#4581bb;}.cls-236{fill:#3770a9;}.cls-237{fill:#5c84bd;}.cls-238{fill:#5080b4;}.cls-239{fill:#8099c7;}.cls-240{fill:#487eb3;}.cls-241{fill:#4174ab;}.cls-242{fill:#376da4;}.cls-243{fill:#2b5e9b;}.cls-244{fill:#4d80b4;}.cls-245{fill:#1b4e8f;}.cls-246{fill:#1964a0;}.cls-247{fill:#7188bc;}.cls-248{fill:#6e86bd;}.cls-249{fill:#1b5897;}.cls-250{fill:#3070ab;}.cls-251{fill:#818fbf;}.cls-252{fill:#3f7fb5;}.cls-253{fill:#336da4;}.cls-254{fill:#28649f;}.cls-255{fill:#5681b5;}.cls-256{fill:#53afb0;}.cls-257{fill:#84bfc5;}.cls-258{fill:#6cafb8;}.cls-259{fill:#5aa7b0;}.cls-260{fill:#30a7a3;}.cls-261{fill:#4aa0a9;}.cls-262{fill:#3b9ca4;}.cls-263{fill:#9bbadd;}.cls-264{fill:#b0c8e3;}.cls-265{fill:#349caf;}.cls-266{fill:#85b0d9;}.cls-267{fill:#7d9aca;}.cls-268{fill:#6f92c6;}.cls-269{fill:#6385bc;}.cls-270{fill:#96b8dc;}.cls-271{fill:#85acd7;}.cls-272{fill:#6bb2b8;}.cls-273{fill:#a5c5d9;}.cls-274{fill:#90bdcd;}.cls-275{fill:#8eb7d3;}.cls-276{fill:#5daab0;}.cls-277{fill:#4ba7a9;}.cls-278{fill:#39a0a3;}.cls-279{fill:#80aacd;}.cls-280{fill:#80a9cc;}.cls-281{fill:#74a0c8;}.cls-282{fill:#029da2;}.cls-283{fill:#0598a6;}.cls-284{fill:#3a98bf;}.cls-285{fill:#0492a0;}.cls-286{fill:#76a1cc;}.cls-287{fill:#6a91c2;}.cls-288{fill:#4981b3;}.cls-289{fill:#406ea7;}.cls-290{fill:#055293;}.cls-291{fill:#1c4787;}.cls-292{fill:#1f4686;}.cls-293{fill:#114d8f;}.cls-294{fill:#1a4888;}.cls-295{fill:#19498a;}.cls-296{fill:#204580;}.cls-297{fill:#005782;}.cls-298{fill:#056b80;}.cls-299{fill:#067581;}.cls-300{fill:#467eb3;}.cls-301{fill:#2a5f9d;}.cls-302{fill:#0682bb;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "LOGO",
    "data-name": "LOGO",
    viewBox: "0 0 374.32 68.03"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.79,55.29V28.22c0-5.66-.62-9.66-3.3-13.14-3.36-4.37-7.43-6-12.75-6-7.5,0-13.62,4.53-17.6,9.84a14,14,0,0,0-2.07-3.8c-3.36-4.37-7.44-6-12.76-6C259.58,9,254,12.7,250,17.28c0-2.9,0-5.39,0-7.18H233.65v1.61h1c2.21,0,3.62,1.33,3.62,4,0,.88,0,38.81,0,39.61,0,2.67-1.41,4-3.61,4h-1v1.62l21,0V59.29h-1c-2.22,0-3.62-1.33-3.62-4,0-.54,0-18.32,0-31.94,2.64-3.5,7.05-7.37,11.74-7.37a8.33,8.33,0,0,1,7.15,3.31,10.48,10.48,0,0,1,1.69,6.52V55.29c0,2.66-1.4,4-3.61,4h-1V60.9h21V59.28h-1c-2.21,0-3.61-1.33-3.61-4,0-.88,0-22.18,0-27.07a42.05,42.05,0,0,0-.2-4.51c2.61-3.58,7.16-7.72,12-7.72a8.32,8.32,0,0,1,7.14,3.31,10.49,10.49,0,0,1,1.7,6.52V55.29c0,2.66-1.41,4-3.62,4h-1V60.9h21V59.28h-1c-2.21,0-3.62-1.33-3.62-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.2,11.72h1c2.21,0,3.62,1.33,3.62,4,0,.88,0,38.37,0,39.18,0,2.66-1.4,4.42-3.61,4.42h-1v1.61h21v-1.6h-1c-2.21,0-3.61-1.33-3.61-4,0-.89,0-38.73,0-39.61,0-2.66,1.4-4,3.61-4h1V10.1h-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.88,47.81a19.45,19.45,0,0,1-17,9c-7.83-.26-14.69-6.67-17.76-17.34-3.8-13.19-.54-22.2,8-26.13,6.6-3,14.23.16,16.46,3.34-3,1.46-3.53,5.19-2.85,7.45a6.65,6.65,0,0,0,10.44,3.17c2.27-1.75,2.89-4.56,2.27-7.37-.69-3-3.19-5.41-6.11-7.25a26,26,0,0,0-14-3.92c-13.81-.13-26.62,11.49-26.62,27.41,0,16.4,14.2,26.33,26.4,26.33A26.3,26.3,0,0,0,374.32,49.4c-.16-.12-2.22-1.38-2.44-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.83,45.35c0-2.58,3.91-6.19,3.91-11.33a11.34,11.34,0,1,0-22.68,0c0,5.14,3.91,8.79,3.91,11.33s-3.91,6.2-3.91,11.34a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.76-3.91-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.15,45.35c0-2.58,3.91-6.19,3.91-11.33a11.34,11.34,0,1,0-22.68,0c0,5.14,3.91,8.79,3.91,11.33s-3.91,6.2-3.91,11.34a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.76-3.91-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.48,45.35c0-2.58,3.9-6.19,3.9-11.33a11.34,11.34,0,1,0-22.67,0c0,5.14,3.9,8.79,3.9,11.33s-3.9,6.2-3.9,11.34a11.34,11.34,0,1,0,22.67,0c0-5.14-3.9-8.76-3.9-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.8,45.35c0-2.58,3.91-6.19,3.91-11.33A11.34,11.34,0,1,0,68,34c0,5.14,3.91,8.79,3.91,11.33S68,51.55,68,56.69a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.76-3.91-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.12,45.35C64.12,42.77,68,39.16,68,34a11.34,11.34,0,0,0-22.68,0c0,5.14,3.91,8.79,3.91,11.33s-3.91,6.2-3.91,11.34a11.34,11.34,0,0,0,22.68,0c0-5.14-3.91-8.76-3.91-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68,64.12c2.58,0,6.2,3.91,11.34,3.91a11.34,11.34,0,0,0,0-22.68c-5.14,0-8.79,3.91-11.34,3.91s-6.2-3.91-11.34-3.91a11.34,11.34,0,1,0,0,22.68c5.14,0,8.76-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.74,64.12c2.58,0,6.19,3.91,11.33,3.91a11.34,11.34,0,1,0,0-22.68c-5.14,0-8.79,3.91-11.33,3.91s-6.2-3.91-11.34-3.91a11.34,11.34,0,0,0,0,22.68c5.14,0,8.75-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.71,64.12C93.29,64.12,96.9,68,102,68a11.34,11.34,0,0,0,0-22.68c-5.14,0-8.79,3.91-11.33,3.91s-6.2-3.91-11.34-3.91a11.34,11.34,0,0,0,0,22.68c5.14,0,8.75-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113.38,64.12c2.58,0,6.2,3.91,11.34,3.91a11.34,11.34,0,1,0,0-22.68c-5.14,0-8.79,3.91-11.34,3.91s-6.19-3.91-11.33-3.91a11.34,11.34,0,0,0,0,22.68c5.14,0,8.75-3.91,11.33-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.35,64.12c2.59,0,6.2,3.91,11.34,3.91a11.34,11.34,0,1,0,0-22.68c-5.14,0-8.79,3.91-11.34,3.91S39.16,45.35,34,45.35A11.34,11.34,0,0,0,34,68c5.14,0,8.75-3.91,11.33-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.77,22.68c0-2.58,3.91-6.2,3.91-11.34A11.34,11.34,0,0,0,0,11.34c0,5.14,3.91,8.79,3.91,11.34S0,28.87,0,34a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.75-3.91-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.68,18.77c2.58,0,6.19,3.91,11.34,3.91A11.34,11.34,0,0,0,34,0c-5.15,0-8.8,3.91-11.34,3.91S16.48,0,11.34,0a11.34,11.34,0,0,0,0,22.68c5.14,0,8.76-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M136.06,64.12c2.58,0,6.2,3.91,11.34,3.91a11.34,11.34,0,1,0,0-22.68c-5.14,0-8.8,3.91-11.34,3.91s-6.2-3.91-11.34-3.91a11.34,11.34,0,0,0,0,22.68c5.14,0,8.76-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M41.45,45.35c0-2.58,3.9-6.19,3.9-11.33a11.34,11.34,0,1,0-22.67,0c0,5.14,3.91,8.79,3.91,11.33s-3.91,6.2-3.91,11.34a11.34,11.34,0,1,0,22.67,0c0-5.14-3.9-8.76-3.9-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M22.68,64.12C25.26,64.12,28.87,68,34,68a11.34,11.34,0,0,0,0-22.68c-5.15,0-8.8,3.91-11.34,3.91s-6.2-3.91-11.34-3.91a11.34,11.34,0,0,0,0,22.68c5.14,0,8.76-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M18.77,45.35c0-2.58,3.91-6.19,3.91-11.33A11.34,11.34,0,1,0,0,34c0,5.14,3.91,8.79,3.91,11.33S0,51.55,0,56.69a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.76-3.91-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.12,22.68c0-2.58,3.91-6.2,3.91-11.34a11.34,11.34,0,0,0-22.68,0c0,5.14,3.91,8.79,3.91,11.34S45.35,28.87,45.35,34A11.34,11.34,0,0,0,68,34c0-5.14-3.91-8.75-3.91-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.8,22.68c0-2.58,3.91-6.2,3.91-11.34a11.34,11.34,0,1,0-22.68,0c0,5.14,3.91,8.79,3.91,11.34S68,28.87,68,34a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.75-3.91-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.45,22.68c0-2.58,3.9-6.2,3.9-11.34a11.34,11.34,0,1,0-22.67,0c0,5.14,3.91,8.79,3.91,11.34S22.68,28.87,22.68,34a11.34,11.34,0,1,0,22.67,0c0-5.14-3.9-8.75-3.9-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M22.68,41.45c2.58,0,6.19,3.9,11.34,3.9a11.34,11.34,0,0,0,0-22.67c-5.15,0-8.8,3.9-11.34,3.9s-6.2-3.9-11.34-3.9a11.34,11.34,0,1,0,0,22.67c5.14,0,8.76-3.9,11.34-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M45.35,41.45c2.59,0,6.2,3.9,11.34,3.9a11.34,11.34,0,1,0,0-22.67c-5.14,0-8.79,3.9-11.34,3.9s-6.19-3.9-11.33-3.9a11.34,11.34,0,1,0,0,22.67c5.14,0,8.75-3.9,11.33-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M68,41.45c2.58,0,6.2,3.9,11.34,3.9a11.34,11.34,0,1,0,0-22.67c-5.14,0-8.79,3.9-11.34,3.9s-6.2-3.9-11.34-3.9a11.34,11.34,0,1,0,0,22.67c5.14,0,8.76-3.9,11.34-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.71,41.45c2.58,0,6.19,3.9,11.33,3.9a11.34,11.34,0,1,0,0-22.67c-5.14,0-8.79,3.9-11.33,3.9s-6.2-3.9-11.34-3.9a11.34,11.34,0,1,0,0,22.67c5.14,0,8.75-3.9,11.34-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M113.38,41.45c2.58,0,6.2,3.9,11.34,3.9a11.34,11.34,0,1,0,0-22.67c-5.14,0-8.79,3.9-11.34,3.9s-6.19-3.9-11.33-3.9a11.34,11.34,0,1,0,0,22.67c5.14,0,8.75-3.9,11.33-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68,18.77c2.58,0,6.2,3.91,11.34,3.91A11.34,11.34,0,0,0,79.37,0C74.23,0,70.58,3.91,68,3.91S61.83,0,56.69,0a11.34,11.34,0,1,0,0,22.68c5.14,0,8.76-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.71,18.77c2.58,0,6.19,3.91,11.33,3.91A11.34,11.34,0,0,0,102,0C96.9,0,93.25,3.91,90.71,3.91S84.51,0,79.37,0a11.34,11.34,0,0,0,0,22.68c5.14,0,8.75-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M154.83,22.68c0-2.58,3.91-6.2,3.91-11.34a11.34,11.34,0,1,0-22.68,0c0,5.14,3.91,8.79,3.91,11.34s-3.91,6.19-3.91,11.33a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.75-3.91-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M132.15,22.68c0-2.58,3.91-6.2,3.91-11.34a11.34,11.34,0,1,0-22.68,0c0,5.14,3.91,8.79,3.91,11.34s-3.91,6.19-3.91,11.33a11.34,11.34,0,1,0,22.68,0c0-5.14-3.91-8.75-3.91-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,41.45c2.58,0,6.2,3.9,11.34,3.9a11.34,11.34,0,1,0,0-22.67c-5.14,0-8.8,3.9-11.34,3.9s-6.2-3.9-11.34-3.9a11.34,11.34,0,1,0,0,22.67c5.14,0,8.76-3.9,11.34-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.74,41.45c2.58,0,6.19,3.9,11.33,3.9a11.34,11.34,0,1,0,0-22.67c-5.14,0-8.79,3.9-11.33,3.9s-6.2-3.9-11.34-3.9a11.34,11.34,0,1,0,0,22.67c5.14,0,8.75-3.9,11.34-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.74,18.77c2.58,0,6.19,3.91,11.33,3.91a11.34,11.34,0,1,0,0-22.68c-5.14,0-8.79,3.91-11.33,3.91S152.54,0,147.4,0a11.34,11.34,0,0,0,0,22.68c5.14,0,8.75-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.48,22.68c0-2.58,3.9-6.2,3.9-11.34a11.34,11.34,0,1,0-22.67,0c0,5.14,3.9,8.79,3.9,11.34s-3.9,6.19-3.9,11.33a11.34,11.34,0,1,0,22.67,0c0-5.14-3.9-8.75-3.9-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M177.51,45.35c0-2.58,3.9-6.19,3.9-11.33a11.34,11.34,0,1,0-22.67,0c0,5.14,3.9,8.79,3.9,11.33s-3.9,6.2-3.9,11.34a11.34,11.34,0,1,0,22.67,0c0-5.14-3.9-8.76-3.9-11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M177.51,22.68c0-2.58,3.9-6.2,3.9-11.34a11.34,11.34,0,1,0-22.67,0c0,5.14,3.9,8.79,3.9,11.34s-3.9,6.19-3.9,11.33a11.34,11.34,0,1,0,22.67,0c0-5.14-3.9-8.75-3.9-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.35,18.77c2.59,0,6.2,3.91,11.34,3.91A11.34,11.34,0,1,0,56.69,0C51.55,0,47.9,3.91,45.35,3.91S39.16,0,34,0a11.34,11.34,0,0,0,0,22.68c5.14,0,8.75-3.91,11.33-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M113.38,18.77c2.58,0,6.2,3.91,11.34,3.91a11.34,11.34,0,1,0,0-22.68c-5.14,0-8.79,3.91-11.34,3.91S107.19,0,102.05,0a11.34,11.34,0,0,0,0,22.68c5.14,0,8.75-3.91,11.33-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,18.77c2.58,0,6.2,3.91,11.34,3.91A11.34,11.34,0,1,0,147.4,0c-5.14,0-8.8,3.91-11.34,3.91S129.86,0,124.72,0a11.34,11.34,0,0,0,0,22.68c5.14,0,8.76-3.91,11.34-3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.68,11.34c0,3.43-1.74,6.2-2.9,8.42-2.23,1.16-5,2.92-8.44,2.92V11.34H22.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.35,11.34c0,3.43-1.74,6.2-2.89,8.42-2.23,1.16-5,2.92-8.44,2.92V11.34H45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.68,11.34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.16,5,2.92,8.44,2.92V11.34H22.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M22.68,34c0-3.44,1.74-6.21,2.9-8.43,2.22-1.15,5-2.91,8.44-2.91V34H22.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M42.44,25.58c-2.22-1.16-5-2.9-8.42-2.9V34H45.35c0-3.46-1.75-6.22-2.91-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M45.35,34c0,3.43-1.74,6.2-2.89,8.42-2.23,1.15-5,2.91-8.44,2.91V34H45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.68,34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.15,5,2.91,8.44,2.91V34H22.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M22.68,56.69c0-3.43,1.74-6.2,2.9-8.42,2.22-1.16,5-2.92,8.44-2.92V56.69H22.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M42.44,48.25c-2.22-1.16-5-2.9-8.42-2.9V56.69H45.35c0-3.45-1.75-6.21-2.91-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68,11.34c0,3.43-1.74,6.2-2.9,8.42-2.22,1.16-5,2.92-8.44,2.92V11.34H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.35,11.34c0,3.43,1.74,6.2,2.9,8.42,2.23,1.16,5,2.92,8.44,2.92V11.34H45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M45.35,34c0-3.44,1.74-6.21,2.9-8.43,2.23-1.15,5-2.91,8.44-2.91V34H45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M65.11,25.58c-2.22-1.16-5-2.9-8.42-2.9V34H68c0-3.46-1.76-6.22-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M68,34c0,3.43-1.74,6.2-2.9,8.42-2.22,1.15-5,2.91-8.44,2.91V34H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M45.35,34c0,3.43,1.74,6.2,2.9,8.42,2.23,1.15,5,2.91,8.44,2.91V34H45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.35,56.69c0-3.43,1.74-6.2,2.9-8.42,2.23-1.16,5-2.92,8.44-2.92V56.69H45.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.11,48.25c-2.22-1.16-5-2.9-8.42-2.9V56.69H68c0-3.45-1.76-6.21-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.71,11.34c0,3.43-1.74,6.2-2.9,8.42-2.23,1.16-5,2.92-8.44,2.92V11.34H90.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68,11.34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.16,5,2.92,8.44,2.92V11.34H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M68,34c0-3.44,1.74-6.21,2.9-8.43,2.22-1.15,5-2.91,8.44-2.91V34H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M87.79,25.58c-2.22-1.16-5-2.9-8.42-2.9V34H90.71c0-3.46-1.76-6.22-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.71,34c0,3.43-1.74,6.2-2.9,8.42-2.23,1.15-5,2.91-8.44,2.91V34H90.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M68,34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.15,5,2.91,8.44,2.91V34H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68,56.69c0-3.43,1.74-6.2,2.9-8.42,2.22-1.16,5-2.92,8.44-2.92V56.69H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.79,48.25c-2.22-1.16-5-2.9-8.42-2.9V56.69H90.71c0-3.45-1.76-6.21-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.38,11.34c0,3.43-1.74,6.2-2.9,8.42-2.22,1.16-5,2.92-8.44,2.92V11.34h11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.71,11.34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.16,5,2.92,8.43,2.92V11.34H90.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.71,34c0-3.44,1.74-6.21,2.9-8.43,2.22-1.15,5-2.91,8.43-2.91V34H90.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M110.47,25.58c-2.22-1.16-5-2.9-8.43-2.9V34h11.34c0-3.46-1.76-6.22-2.91-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M113.38,34c0,3.43-1.74,6.2-2.9,8.42-2.22,1.15-5,2.91-8.44,2.91V34h11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.71,34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.15,5,2.91,8.43,2.91V34H90.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.71,56.69c0-3.43,1.74-6.2,2.9-8.42,2.22-1.16,5-2.92,8.43-2.92V56.69H90.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M110.47,48.25c-2.22-1.16-5-2.9-8.43-2.9V56.69h11.34c0-3.45-1.76-6.21-2.91-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,11.34c0,3.43-1.74,6.2-2.9,8.42-2.22,1.16-5,2.92-8.44,2.92V11.34h11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.38,11.34c0,3.43,1.74,6.2,2.9,8.42,2.23,1.16,5,2.92,8.44,2.92V11.34H113.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.38,34c0-3.44,1.74-6.21,2.9-8.43,2.23-1.15,5-2.91,8.44-2.91V34H113.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.14,25.58c-2.22-1.16-5-2.9-8.42-2.9V34h11.34c0-3.46-1.76-6.22-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.06,34c0,3.43-1.74,6.2-2.9,8.42-2.22,1.15-5,2.91-8.44,2.91V34h11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.38,34c0,3.43,1.74,6.2,2.9,8.42,2.23,1.15,5,2.91,8.44,2.91V34H113.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.38,56.69c0-3.43,1.74-6.2,2.9-8.42,2.23-1.16,5-2.92,8.44-2.92V56.69H113.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.14,48.25c-2.22-1.16-5-2.9-8.42-2.9V56.69h11.34c0-3.45-1.76-6.21-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.74,11.34c0,3.43-1.75,6.2-2.9,8.42-2.23,1.16-5,2.92-8.44,2.92V11.34h11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,11.34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.16,5,2.92,8.44,2.92V11.34H136.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,34c0-3.44,1.74-6.21,2.9-8.43,2.22-1.15,5-2.91,8.44-2.91V34H136.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.82,25.58c-2.22-1.16-5-2.9-8.42-2.9V34h11.34c0-3.46-1.76-6.22-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M158.74,34c0,3.43-1.75,6.2-2.9,8.42-2.23,1.15-5,2.91-8.44,2.91V34h11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,34c0,3.43,1.74,6.2,2.9,8.42,2.22,1.15,5,2.91,8.44,2.91V34H136.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,56.69c0-3.43,1.74-6.2,2.9-8.42,2.22-1.16,5-2.92,8.44-2.92V56.69H136.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M155.82,48.25c-2.22-1.16-5-2.9-8.42-2.9V56.69h11.34c0-3.45-1.76-6.21-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M22.68,56.69c0-3.43-1.74-6.2-2.9-8.42-2.23-1.16-5-2.92-8.44-2.92V56.69H22.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M19.76,25.58c-2.22-1.16-5-2.9-8.42-2.9V34H22.68c0-3.46-1.76-6.22-2.92-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M22.68,34c0,3.43-1.74,6.2-2.9,8.42-2.23,1.15-5,2.91-8.44,2.91V34H22.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M158.74,11.34c0,3.43,1.74,6.2,2.89,8.42,2.23,1.16,5,2.92,8.44,2.92V11.34H158.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M158.74,56.69c0-3.43,1.74-6.2,2.89-8.42,2.23-1.16,5-2.92,8.44-2.92V56.69H158.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M161.65,25.58c2.22-1.16,5-2.9,8.42-2.9V34H158.74c0-3.46,1.75-6.22,2.91-8.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M158.74,34c0,3.43,1.74,6.2,2.89,8.42,2.23,1.15,5,2.91,8.44,2.91V34H158.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M22.68,34A11.34,11.34,0,1,1,11.34,22.68,11.34,11.34,0,0,1,22.68,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.68,11.34A11.34,11.34,0,1,1,11.34,0,11.34,11.34,0,0,1,22.68,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.35,11.34A11.34,11.34,0,1,1,34,0,11.34,11.34,0,0,1,45.35,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68,11.34A11.34,11.34,0,1,1,56.69,0,11.34,11.34,0,0,1,68,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M90.71,11.34A11.34,11.34,0,1,1,79.37,0,11.34,11.34,0,0,1,90.71,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M113.38,11.34A11.34,11.34,0,1,1,102,0a11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M136.06,11.34A11.34,11.34,0,1,1,124.72,0a11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M158.74,11.34A11.34,11.34,0,1,1,147.4,0a11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M181.41,11.34A11.34,11.34,0,1,1,170.07,0a11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M181.41,34a11.34,11.34,0,1,1-11.34-11.34A11.33,11.33,0,0,1,181.41,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M158.74,34A11.34,11.34,0,1,1,147.4,22.68,11.34,11.34,0,0,1,158.74,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M136.06,34a11.34,11.34,0,1,1-11.34-11.34A11.34,11.34,0,0,1,136.06,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M113.38,34A11.34,11.34,0,1,1,102,22.68,11.33,11.33,0,0,1,113.38,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M90.71,34A11.34,11.34,0,1,1,79.37,22.68,11.34,11.34,0,0,1,90.71,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M68,34A11.34,11.34,0,1,1,56.69,22.68,11.34,11.34,0,0,1,68,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M45.35,34A11.34,11.34,0,1,1,34,22.68,11.33,11.33,0,0,1,45.35,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M22.68,56.69A11.34,11.34,0,1,1,11.34,45.35,11.34,11.34,0,0,1,22.68,56.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M45.35,56.69A11.34,11.34,0,1,1,34,45.35,11.34,11.34,0,0,1,45.35,56.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M68,56.69A11.34,11.34,0,1,1,56.69,45.35,11.34,11.34,0,0,1,68,56.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.71,56.69A11.34,11.34,0,1,1,79.37,45.35,11.34,11.34,0,0,1,90.71,56.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M113.38,56.69A11.34,11.34,0,1,1,102,45.35a11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M136.06,56.69a11.34,11.34,0,1,1-11.34-11.34,11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M158.74,56.69A11.34,11.34,0,1,1,147.4,45.35a11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M181.41,56.69a11.34,11.34,0,1,1-11.34-11.34,11.34,11.34,0,0,1,11.34,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M139.82,44.41a10.47,10.47,0,0,0-.68-1.62,10.47,10.47,0,0,1,.68,1.62m.06,1.64h0M139,48.26a10.41,10.41,0,0,0,.91-2.2,10.41,10.41,0,0,1-.91,2.2m-4.69.55c-.36-.16-.74-.35-1.14-.56h0c.4.21.78.4,1.14.56m3.11.17a12.56,12.56,0,0,0,1.53-.7,12.56,12.56,0,0,1-1.53.7m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139,48.26a10.41,10.41,0,0,0,.91-2.2h0a2.86,2.86,0,0,0,.09-.7,3.67,3.67,0,0,0-.15-.94,10.47,10.47,0,0,0-.68-1.62l-.18-.35c1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07a11.24,11.24,0,0,0-4.09,1.11c-1.28.56-2.43,1.22-3.46,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M136.06,55.81h0a11.58,11.58,0,0,0-1.14-4.15c-.56-1.26-1.22-2.39-1.75-3.41.4.21.78.4,1.14.56a4.81,4.81,0,0,0,1.78.45,3.73,3.73,0,0,0,1.32-.28h0a12.56,12.56,0,0,0,1.53-.7l.05,0c1-.54,2.18-1.2,3.45-1.76l-.06,0c-1.26.56-2.39,1.21-3.4,1.74-.54,1-1.21,2.18-1.76,3.47a11.13,11.13,0,0,0-1.11,4.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M133.14,48.25h0a6.94,6.94,0,0,1-1-2.9,6.91,6.91,0,0,1,1-2.91h0a6.91,6.91,0,0,0-1,2.91,6.94,6.94,0,0,0,1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M133.14,48.25c-1-.54-2.18-1.2-3.46-1.76a11.23,11.23,0,0,0-4.08-1.1v-.07a11.25,11.25,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.38-1.73a6.91,6.91,0,0,0-1,2.91,6.8,6.8,0,0,0,1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M129.68,46.49h0a11.12,11.12,0,0,0-4.07-1.1,11.23,11.23,0,0,1,4.08,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M136.06,41.45h0m0,0h0m0,0h0m0,0h0m0,0h0m-.25,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m3.08.93a6.71,6.71,0,0,0-2.75-.94,6.56,6.56,0,0,1,2.75.94m-5.7,0h0a7.76,7.76,0,0,1,2.62-1,7.76,7.76,0,0,0-2.62,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.16,42.44c.54-1,1.2-2.18,1.76-3.46A11.44,11.44,0,0,0,136,34.89h.06A11.24,11.24,0,0,0,137.2,39c.56,1.28,1.22,2.42,1.76,3.46l-.1,0a6.56,6.56,0,0,0-2.75-.94h-.33a7.76,7.76,0,0,0-2.62,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M129.77,44.17A11.4,11.4,0,0,0,134.92,39c-.56,1.28-1.22,2.43-1.76,3.45h0c-1,.53-2.13,1.18-3.38,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M134.89,51.66a11.44,11.44,0,0,0-5.21-5.17h0c1.28.56,2.43,1.22,3.46,1.76h0c.53,1,1.19,2.16,1.75,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.35,44.17C141.1,43.62,140,43,139,42.44h0c-.54-1-1.2-2.17-1.76-3.45a11.36,11.36,0,0,0,5.15,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.2,51.74c.55-1.29,1.22-2.44,1.76-3.47,1-.53,2.15-1.18,3.4-1.74a11.37,11.37,0,0,0-5.16,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M146.52,45.32a11.06,11.06,0,0,1-4.17-1.15,11.33,11.33,0,0,1-6.26-9.28c2.28,0,5.17,1.62,7.68,2.75,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M125.6,45.32c0-2.27,1.61-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.75a11.33,11.33,0,0,1-6.26,9.28,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M136,55.81c-2.26,0-5.17-1.61-7.69-2.75-1.13-2.51-2.72-5.4-2.74-7.67a11.23,11.23,0,0,1,4.08,1.1,11.44,11.44,0,0,1,5.21,5.17A11.58,11.58,0,0,1,136,55.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M136.09,55.81a11.13,11.13,0,0,1,1.11-4.07,11.33,11.33,0,0,1,5.16-5.21l.07,0a11.24,11.24,0,0,1,4.09-1.11c0,2.25-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M140,22.63a7.19,7.19,0,0,0-1-2.87,7.19,7.19,0,0,1,1,2.87m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,.18h0m0,0h0m0,0h0m0,0h0m-4.37,3.62a8.69,8.69,0,0,1-2.44-1h0a8.69,8.69,0,0,0,2.44,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.46,0a7,7,0,0,0,2.86-1,7.83,7.83,0,0,0,1-2.65,7.83,7.83,0,0,1-1,2.65,7,7,0,0,1-2.86,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M139,25.58a7.83,7.83,0,0,0,1-2.65h0v0h0v0h0c0-.06,0-.12,0-.18h0v0h0a7.19,7.19,0,0,0-1-2.87c1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07a11.29,11.29,0,0,0-4.1,1.11c-1.28.56-2.42,1.22-3.45,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,33.14h0A11.58,11.58,0,0,0,134.89,29c-.56-1.26-1.22-2.39-1.75-3.41a8.69,8.69,0,0,0,2.44,1h.07a2.66,2.66,0,0,0,.39,0h.07a7,7,0,0,0,2.86-1c1-.53,2.17-1.2,3.45-1.75l-.06,0c-1.26.55-2.39,1.21-3.4,1.73-.54,1-1.21,2.19-1.76,3.47l-.08.15a11.47,11.47,0,0,0-1,3.93h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.36,23.86l.06,0a11.29,11.29,0,0,1,4.1-1.11,11.24,11.24,0,0,0-4.16,1.14h0m-5.23,5.35a1,1,0,0,1,.07-.15h0a1,1,0,0,0-.07.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M132.15,22.63A6.71,6.71,0,0,1,133,20a6.71,6.71,0,0,0-.89,2.66m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,.29h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m1,2.5h0a8.4,8.4,0,0,1-1-2.5,8.4,8.4,0,0,0,1,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M133.14,25.57c-1-.53-2.18-1.2-3.47-1.76a11.32,11.32,0,0,0-4.07-1.1v-.07a11.06,11.06,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.38-1.72,0,.06-.07.13-.11.2a6.71,6.71,0,0,0-.89,2.66h0v0h0a2.83,2.83,0,0,0,0,.29h0v0h0a8.4,8.4,0,0,0,1,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M136.9,18.89h0m-2.22.17h0m-1,.41a9.4,9.4,0,0,1,1-.41,9.4,9.4,0,0,0-1,.41m0,0h0m5.24.28a9.85,9.85,0,0,0-2.06-.87,9.85,9.85,0,0,1,2.06.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.16,19.76c.54-1,1.2-2.18,1.76-3.45A11.49,11.49,0,0,0,136,12.22h.06a11.24,11.24,0,0,0,1.11,4.08c.56,1.28,1.22,2.43,1.76,3.46a10.25,10.25,0,0,0-2.05-.87h0a3.08,3.08,0,0,0-.83-.12,4,4,0,0,0-1.37.29h0a9.4,9.4,0,0,0-1,.41h0l-.56.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.77,21.49a11.43,11.43,0,0,0,5.15-5.18c-.56,1.27-1.22,2.42-1.76,3.45h0c-1,.52-2.13,1.17-3.38,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.89,29a11.44,11.44,0,0,0-5.22-5.18c1.29.56,2.44,1.23,3.47,1.76h0c.53,1,1.19,2.15,1.75,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.35,21.49c-1.25-.55-2.38-1.2-3.39-1.73h0c-.54-1-1.2-2.18-1.76-3.46a11.36,11.36,0,0,0,5.15,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.2,29.06h0c.55-1.28,1.22-2.43,1.76-3.47,1-.52,2.14-1.18,3.4-1.73h0a11.42,11.42,0,0,0-5.16,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M125.6,22.64c0-2.27,1.61-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.74a11.31,11.31,0,0,1-6.26,9.27,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M146.52,22.64a11.06,11.06,0,0,1-4.17-1.15,11.34,11.34,0,0,1-6.26-9.27c2.28,0,5.17,1.61,7.68,2.74,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M136.09,33.14a11.26,11.26,0,0,1,1-3.93,1,1,0,0,1,.07-.15,11.37,11.37,0,0,1,5.16-5.21,11.24,11.24,0,0,1,4.16-1.14c0,2.26-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M136,33.14c-2.26,0-5.17-1.62-7.69-2.75-1.13-2.51-2.72-5.41-2.74-7.68a11.24,11.24,0,0,1,4.08,1.11A11.39,11.39,0,0,1,134.89,29,11.52,11.52,0,0,1,136,33.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M160.6,48.77c.33-.15.68-.32,1-.51a6.91,6.91,0,0,0,1-2.91,6.18,6.18,0,0,0-.85-2.61,6.18,6.18,0,0,1,.85,2.61,6.91,6.91,0,0,1-1,2.91c-.36.19-.71.36-1,.51m0,0h0m-3.59,0q-.56-.24-1.17-.57.62.33,1.17.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.74,55.81h0a11.19,11.19,0,0,0-1.14-4.15c-.55-1.26-1.21-2.39-1.74-3.41q.62.33,1.17.57a4.59,4.59,0,0,0,1.75.44,4.73,4.73,0,0,0,1.85-.49h0c.33-.15.68-.32,1-.51h0c-.54,1-1.2,2.18-1.76,3.47a11.32,11.32,0,0,0-1.1,4.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M161.64,48.27h0a6.77,6.77,0,0,0,1-2.91,6.3,6.3,0,0,0-.84-2.61c-.06-.1-.11-.2-.16-.3,1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07A11.18,11.18,0,0,0,165,46.53c-1.26.56-2.39,1.21-3.4,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M155.82,48.25h0a6.8,6.8,0,0,1-1-2.9,6.88,6.88,0,0,1,1-2.91h0a6.88,6.88,0,0,0-1,2.91,6.8,6.8,0,0,0,1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.82,48.25c-1-.54-2.19-1.2-3.47-1.76a11.18,11.18,0,0,0-4.07-1.1v-.07a11.25,11.25,0,0,0,4.17-1.15c1.24-.55,2.36-1.2,3.37-1.73a6.88,6.88,0,0,0-1,2.91,6.8,6.8,0,0,0,1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M158.75,41.45h0m0,0h0m.05,0h0m-.07,0h0m0,0h0m.09,0h0m-.11,0h0m.13,0h0m0,0h0m-.15,0h0m.17,0h0m-.19,0h0m.21,0h0m-.22,0h0m.23,0h0m-.25,0h0m2.59.76a6.25,6.25,0,0,0-2.33-.76,6.25,6.25,0,0,1,2.33.76m-5.36.23h0a7.24,7.24,0,0,1,2.76-1,7.24,7.24,0,0,0-2.76,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.84,42.44c.54-1,1.2-2.18,1.75-3.46a11.24,11.24,0,0,0,1.11-4.09h.07A11.24,11.24,0,0,0,159.88,39c.55,1.28,1.21,2.42,1.75,3.46a4.37,4.37,0,0,0-.43-.22,6.11,6.11,0,0,0-2.33-.77h-.27a7.24,7.24,0,0,0-2.76,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M152.45,44.17A11.33,11.33,0,0,0,157.59,39c-.55,1.28-1.22,2.43-1.75,3.46h0c-1,.53-2.13,1.18-3.37,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M157.56,51.66a11.35,11.35,0,0,0-5.21-5.17c1.28.56,2.43,1.22,3.47,1.76h0c.53,1,1.19,2.15,1.74,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M159.87,51.74c.56-1.29,1.22-2.44,1.76-3.47h0c1-.53,2.14-1.18,3.4-1.74a11.35,11.35,0,0,0-5.17,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M165,44.17c-1.25-.55-2.38-1.2-3.39-1.73h0c-.54-1-1.2-2.19-1.75-3.46A11.31,11.31,0,0,0,165,44.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M169.2,45.32A11.06,11.06,0,0,1,165,44.17a11.33,11.33,0,0,1-6.26-9.28c2.27,0,5.17,1.62,7.68,2.75,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M148.28,45.32c0-2.27,1.61-5.17,2.74-7.68,2.51-1.13,5.41-2.73,7.68-2.75a11.35,11.35,0,0,1-6.25,9.28,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M158.7,55.81c-2.26,0-5.16-1.61-7.68-2.75-1.13-2.51-2.73-5.4-2.75-7.67a11.17,11.17,0,0,1,4.08,1.1,11.35,11.35,0,0,1,5.21,5.17,11.19,11.19,0,0,1,1.14,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M158.77,55.81A11.32,11.32,0,0,1,165,46.53a11.18,11.18,0,0,1,4.16-1.14c0,2.25-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M159.14,26.55a8.12,8.12,0,0,0,2.5-1,6.92,6.92,0,0,0,1-2.9,6.59,6.59,0,0,0-.93-2.78,6.59,6.59,0,0,1,.93,2.78,6.92,6.92,0,0,1-1,2.9,8.12,8.12,0,0,1-2.5,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-.38,0a7.71,7.71,0,0,1-2.73-1h0a7.71,7.71,0,0,0,2.73,1m.37,0h0m-.36,0h0m.34,0h0m-.33,0h0m.31,0h0m-.29,0h0m.28,0h0m-.27,0h0m.25,0h0m-.23,0h0m.22,0h0m-.21,0h0m.19,0h0m-.17,0h0m.16,0h0m-.15,0h0m.14,0h0m-.12,0h0m.1,0h0m-.09,0h0m.08,0h0m-.06,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.74,33.14h0A11.08,11.08,0,0,0,157.56,29c-.55-1.26-1.21-2.39-1.74-3.41a7.71,7.71,0,0,0,2.73,1h.59a8.38,8.38,0,0,0,2.5-1c-.53,1-1.2,2.17-1.75,3.45a11.1,11.1,0,0,0-1.12,4.11h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M159.89,29c.55-1.28,1.22-2.42,1.75-3.45a6.92,6.92,0,0,0,1-2.9,6.59,6.59,0,0,0-.93-2.78l-.07-.14c1,.53,2.13,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07a11.43,11.43,0,0,0-4.08,1.1c-1.28.56-2.43,1.23-3.47,1.77-.53,1-1.19,2.15-1.74,3.41l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M155.82,25.57h0a6.76,6.76,0,0,1-1-2.89,6.79,6.79,0,0,1,1-2.91,6.79,6.79,0,0,0-1,2.91,6.72,6.72,0,0,0,1,2.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M155.82,25.57c-1-.53-2.18-1.2-3.46-1.75a11.24,11.24,0,0,0-4.08-1.11v-.07a11.16,11.16,0,0,0,4.17-1.15c1.24-.55,2.36-1.2,3.37-1.72a6.93,6.93,0,0,0-1,2.91,6.76,6.76,0,0,0,1,2.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.36,23.82h0a11.37,11.37,0,0,0-4.08-1.1h0a11.24,11.24,0,0,1,4.09,1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M156.87,19.26h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0,0,0,0,0m-.31.15c.1-.06.21-.1.31-.15-.1.05-.21.09-.31.15m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m5.22.2a10.81,10.81,0,0,0-1.77-.77,10.81,10.81,0,0,1,1.77.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.84,19.76c.54-1,1.2-2.18,1.75-3.45a11.24,11.24,0,0,0,1.11-4.09h.07a11.24,11.24,0,0,0,1.11,4.08c.55,1.28,1.21,2.43,1.75,3.46l-.09-.05a10.81,10.81,0,0,0-1.77-.77,3.57,3.57,0,0,0-1-.17,4.77,4.77,0,0,0-1.87.49h-.08l0,0h0l-.31.15h-.12l-.48.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.45,21.49a11.36,11.36,0,0,0,5.14-5.18c-.55,1.27-1.22,2.42-1.75,3.45h0c-1,.52-2.13,1.17-3.37,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.56,29a11.37,11.37,0,0,0-5.21-5.18h0c1.28.55,2.43,1.22,3.46,1.75h0c.53,1,1.19,2.15,1.74,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M165,21.5c-1.25-.56-2.38-1.21-3.39-1.74h0c-.54-1-1.2-2.18-1.75-3.46A11.38,11.38,0,0,0,165,21.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M159.91,29c.55-1.26,1.21-2.39,1.74-3.41,1-.54,2.19-1.21,3.47-1.77A11.37,11.37,0,0,0,159.91,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M148.28,22.64c0-2.27,1.61-5.17,2.74-7.68,2.51-1.13,5.41-2.73,7.68-2.74a11.24,11.24,0,0,1-1.11,4.09,11.36,11.36,0,0,1-5.14,5.18,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M169.2,22.64A11.06,11.06,0,0,1,165,21.49a11.34,11.34,0,0,1-6.26-9.27c2.27,0,5.17,1.61,7.68,2.74,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M158.77,33.14A11.1,11.1,0,0,1,159.89,29v0a11.33,11.33,0,0,1,9.3-6.28c0,2.26-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M158.7,33.14c-2.26,0-5.16-1.62-7.68-2.75-1.13-2.51-2.73-5.41-2.75-7.68a11.13,11.13,0,0,1,4.08,1.11A11.3,11.3,0,0,1,157.56,29a11.08,11.08,0,0,1,1.14,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M178,64.76h0a11.28,11.28,0,0,0,3.37-8v-.12A11.32,11.32,0,0,1,178,64.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M181.41,56.81v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.41,34.25h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M181.41,11.34v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.41,11.57h0v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M71.55,65.44A8.49,8.49,0,0,0,68,64.12a7.13,7.13,0,0,0-3,1.06,7.13,7.13,0,0,1,3-1.06,8.49,8.49,0,0,1,3.52,1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.78,66.83A11.34,11.34,0,0,0,68,57.57h.06a11.34,11.34,0,0,0,6.22,9.26c-1-.44-1.89-.94-2.73-1.39A8.49,8.49,0,0,0,68,64.12a7.13,7.13,0,0,0-3,1.06c-1,.51-2.05,1.12-3.23,1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M87.66,65.19a7.13,7.13,0,0,1,3-1.07A6.29,6.29,0,0,1,93.3,65a6.29,6.29,0,0,0-2.59-.83,7.13,7.13,0,0,0-3,1.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97,66.83C95.6,66.22,94.38,65.5,93.3,65a6.29,6.29,0,0,0-2.59-.83,7.13,7.13,0,0,0-3,1.07c-1,.51-2,1.11-3.2,1.64a11.43,11.43,0,0,0,5.09-5.15,11.21,11.21,0,0,0,1.12-4.11h.07A11.34,11.34,0,0,0,97,66.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M84.46,66.83a11.43,11.43,0,0,0,5.09-5.15,11.43,11.43,0,0,1-5.09,5.15h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M156.09,65h0m5.64.18a7.09,7.09,0,0,0-3-1,6.24,6.24,0,0,0-2.64.86,6.24,6.24,0,0,1,2.64-.86,7.09,7.09,0,0,1,3,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.48,66.83a11.31,11.31,0,0,0,6.22-9.26h.07A11.32,11.32,0,0,0,165,66.83c-1.2-.53-2.28-1.15-3.26-1.67a7.09,7.09,0,0,0-3-1,6.24,6.24,0,0,0-2.64.86h0c-1.07.54-2.27,1.25-3.61,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.48,66.83A11.38,11.38,0,0,0,157,62.68a11.38,11.38,0,0,1-4.55,4.15h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M48.81,65.4a8.42,8.42,0,0,0-3.46-1.28,6.79,6.79,0,0,0-2.87,1,6.79,6.79,0,0,1,2.87-1,8.42,8.42,0,0,1,3.46,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.61,66.83c-1-.45-2-1-2.8-1.43a8.42,8.42,0,0,0-3.46-1.28,6.79,6.79,0,0,0-2.87,1c-1,.52-2.13,1.17-3.37,1.72a11.29,11.29,0,0,0,6.21-9.25h.07a11.32,11.32,0,0,0,6.22,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M39.1,66.83a11.4,11.4,0,0,0,5.25-5.46,11.37,11.37,0,0,1-5.24,5.45h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M139.28,65.28a7.62,7.62,0,0,0-3.22-1.16,6.39,6.39,0,0,0-2.69.88,6.39,6.39,0,0,1,2.69-.88,7.62,7.62,0,0,1,3.22,1.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M142.31,66.83c-1.11-.49-2.11-1.06-3-1.55a7.62,7.62,0,0,0-3.22-1.16,6.39,6.39,0,0,0-2.69.88c-1.06.54-2.24,1.24-3.56,1.83A11.36,11.36,0,0,0,136,57.57h.06a11.34,11.34,0,0,0,6.22,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M26,65.33a7.92,7.92,0,0,0-3.31-1.21,5.94,5.94,0,0,0-2.5.79,5.94,5.94,0,0,1,2.5-.79A7.92,7.92,0,0,1,26,65.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M28.93,66.83c-1.07-.48-2.05-1-2.94-1.5a7.92,7.92,0,0,0-3.31-1.21,5.94,5.94,0,0,0-2.5.79c-1.11.55-2.34,1.29-3.74,1.91a11.34,11.34,0,0,0,6.2-9.25h.07a11.34,11.34,0,0,0,6.22,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M16.44,66.82a11.34,11.34,0,0,0,6.2-9.25,11.34,11.34,0,0,1-6.2,9.25h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M116.32,65.13a6.91,6.91,0,0,0-2.94-1,6.58,6.58,0,0,0-2.81.95,6.58,6.58,0,0,1,2.81-.95,6.91,6.91,0,0,1,2.94,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M119.63,66.82c-1.22-.54-2.32-1.17-3.31-1.69a6.91,6.91,0,0,0-2.94-1,6.58,6.58,0,0,0-2.81.95c-1,.53-2.16,1.19-3.43,1.75a11.36,11.36,0,0,0,5.08-5.13,11.22,11.22,0,0,0,1.13-4.12h.07a11.26,11.26,0,0,0,6.21,9.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M119.63,66.83h0a11.35,11.35,0,0,1-4.54-4.15,11.35,11.35,0,0,0,4.54,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M107.14,66.82a11.36,11.36,0,0,0,5.08-5.13,11.36,11.36,0,0,1-5.08,5.13h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M178,64.76a11.15,11.15,0,0,0,1.62-2,11.27,11.27,0,0,0,1.75-5.94,11.28,11.28,0,0,1-3.37,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.66,62.75a11.3,11.3,0,0,0,1.75-6.06v.12a11.27,11.27,0,0,1-1.75,5.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M176.89,65.76a11.35,11.35,0,0,0,4.52-9.07h0a11.3,11.3,0,0,1-1.75,6.06,11.15,11.15,0,0,1-1.62,2,13.73,13.73,0,0,1-1.15,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1.35,62.06h0m.19.33a2.75,2.75,0,0,1-.17-.29l0,0a3.37,3.37,0,0,0,.19.32m0,0h0m0,0a0,0,0,0,1,0,0,0,0,0,0,0,0,0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M3,48.16a6.76,6.76,0,0,0,1-2.81,4.32,4.32,0,0,0-.42-1.67,4.32,4.32,0,0,1,.42,1.67,6.62,6.62,0,0,1-1,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1.16,51.7c.57-1.31,1.26-2.49,1.8-3.54a6.62,6.62,0,0,0,1-2.81,4.48,4.48,0,0,0-.41-1.67C2.94,42.36,2,40.81,1.16,39a11.33,11.33,0,0,0,9.3,6.31v.07a11.33,11.33,0,0,0-9.3,6.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M180.22,51.62A11.34,11.34,0,0,0,171,45.39v-.07a11.35,11.35,0,0,0,9.27-6.24c-1.15,2.59-2.71,4.64-2.71,6.27s1.56,3.69,2.71,6.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.41,34.25v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M181.41,34h0v-.23h0V34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 181.41,
    y1: 34.02,
    x2: 181.41,
    y2: 34.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M3.43,24.5a4.7,4.7,0,0,0,.48-1.82,5.15,5.15,0,0,0-.6-2.09,5.15,5.15,0,0,1,.6,2.09,4.7,4.7,0,0,1-.48,1.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1.17,29c.76-1.73,1.71-3.22,2.26-4.5a4.7,4.7,0,0,0,.48-1.82,5.15,5.15,0,0,0-.6-2.09C2.74,19.37,1.87,18,1.16,16.34a11.33,11.33,0,0,0,9.3,6.3v.07a11.74,11.74,0,0,0-2.85.59A11.38,11.38,0,0,0,1.17,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M7.61,23.3a11.64,11.64,0,0,1,2.85-.59,11.74,11.74,0,0,0-2.85.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1.17,29h0a11.41,11.41,0,0,1,6.44-5.7,11.74,11.74,0,0,1,2.85-.59h0A11.31,11.31,0,0,0,1.17,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M180.22,28.94A11.36,11.36,0,0,0,171,22.71v-.07a11.33,11.33,0,0,0,9.26-6.22C179.07,19,177.5,21,177.5,22.68s1.57,3.68,2.72,6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M181.39,10.56h0m0,.66c0-.22,0-.44,0-.66,0,.22,0,.44,0,.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.41,11.57v-.23h0a11.27,11.27,0,0,0-1.52-5.68,11.29,11.29,0,0,1,1.5,4.9h0c0,.22,0,.44,0,.66v.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 181.41,
    y1: 11.34,
    x2: 181.41,
    y2: 11.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M156.62,3.3h0m4.07.07h0m-1.95.54a5.15,5.15,0,0,1-2.12-.61,5.15,5.15,0,0,0,2.12.61,4.93,4.93,0,0,0,1.94-.53,4.93,4.93,0,0,1-1.94.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.74,10.46h0a11.36,11.36,0,0,0-6.31-9.31c1.6.71,3,1.57,4.22,2.15h0a5.15,5.15,0,0,0,2.12.61,4.93,4.93,0,0,0,1.94-.53h0c1.26-.56,2.71-1.48,4.38-2.21a11.34,11.34,0,0,0-6.3,9.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M138.23,3.27h0m-3.65.3h0m1.48.34a4.18,4.18,0,0,1-1.47-.33,4.18,4.18,0,0,0,1.47.33,5.32,5.32,0,0,0,2.17-.64,5.32,5.32,0,0,1-2.17.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,10.46h0a11.35,11.35,0,0,0-6.33-9.31c1.9.83,3.51,1.89,4.88,2.42h0a4.18,4.18,0,0,0,1.47.33,5.32,5.32,0,0,0,2.17-.64h0c1.2-.57,2.59-1.43,4.17-2.12a11.37,11.37,0,0,0-6.32,9.31h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M115.18,3.44h0m-1.8.47a4.85,4.85,0,0,1-1.87-.5,4.85,4.85,0,0,0,1.87.5,4.65,4.65,0,0,0,1.79-.46,4.65,4.65,0,0,1-1.79.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M113.38,10.46h0A11.33,11.33,0,0,0,107,1.16c1.72.75,3.2,1.69,4.47,2.25a4.85,4.85,0,0,0,1.87.5,4.65,4.65,0,0,0,1.79-.46h0c1.29-.56,2.79-1.52,4.54-2.28a11.37,11.37,0,0,0-6.31,9.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M90.71,3.91a4.75,4.75,0,0,1-1.89-.51,4.75,4.75,0,0,0,1.89.51,4.38,4.38,0,0,0,1.62-.39,4.38,4.38,0,0,1-1.62.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M90.71,10.46h0a11.33,11.33,0,0,0-6.31-9.3c1.71.74,3.19,1.68,4.46,2.24a4.75,4.75,0,0,0,1.89.51,4.38,4.38,0,0,0,1.62-.39C93.66,3,95.22,2,97.05,1.16a11.33,11.33,0,0,0-6.31,9.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M66.43,3.52h0m1.6.39a4.37,4.37,0,0,1-1.59-.38A4.37,4.37,0,0,0,68,3.91,5,5,0,0,0,70,3.39,5,5,0,0,1,68,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68,10.46h0a11.36,11.36,0,0,0-6.32-9.3C63.52,2,65.09,3,66.43,3.53h0A4.37,4.37,0,0,0,68,3.91,5,5,0,0,0,70,3.39c1.26-.57,2.72-1.49,4.42-2.23a11.36,11.36,0,0,0-6.32,9.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M43,3.19h0m4.26.2h0m-1.92.52A5.52,5.52,0,0,1,43,3.19a5.52,5.52,0,0,0,2.33.72,4.78,4.78,0,0,0,1.92-.52,4.78,4.78,0,0,1-1.92.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M22.68,3.91a5.22,5.22,0,0,1-2.13-.62,5.22,5.22,0,0,0,2.13.62,5.2,5.2,0,0,0,2.07-.59,5.2,5.2,0,0,1-2.07.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M22.68,10.46h0a11.34,11.34,0,0,0-6.31-9.31c1.6.71,3,1.57,4.22,2.15a5.35,5.35,0,0,0,2.13.61,5.2,5.2,0,0,0,2.07-.59C26,2.75,27.39,1.87,29,1.16a11.33,11.33,0,0,0-6.31,9.3h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.71,10.46A11.33,11.33,0,0,1,29,1.16h0a11.33,11.33,0,0,0-6.31,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M.86,7A11.34,11.34,0,0,1,11.34,0h0A11.32,11.32,0,0,0,.86,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M11.43,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M2.81,3.86A11.31,11.31,0,0,1,11.34,0,11.31,11.31,0,0,0,2.81,3.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.92,4.24c-.19-.23-.38-.45-.59-.67h0l-.24-.24h0a12.09,12.09,0,0,1,.83.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M178.33,3.56l-.24-.24.24.24m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M174.58.93A11.26,11.26,0,0,0,170.07,0h0a11.26,11.26,0,0,1,4.51.93m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.05,0h0m0,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.07,0h0m6.71,2.2h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.06,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0a0,0,0,0,1,0,0l0,0m0,0h0m0,0s0,0,0,0,0,0,0,0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.08.06-.08-.06.08.06m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0,0,0,0,0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.13.11L177.7,3l.09.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M177.79,3a11.29,11.29,0,0,0-7.72-3,11.26,11.26,0,0,1,4.51.93h.11l.05,0h0a11.43,11.43,0,0,1,2,1.18h0a0,0,0,0,1,0,0h.07l.05,0h.19a0,0,0,0,0,0,0h.13l.08.06h.13l0,0h.14l0,0h0l.09.08h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M124.91,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M124.91,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M124.92,0h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 124.72,
    x2: 124.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M79.17,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M79.17,0h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 79.37,
    x2: 79.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M101.85,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M102,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M102.24,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M34.21,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M34.21,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.82,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M56.5,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56.88,0h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 56.69,
    x2: 56.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M147.2,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M147.59,0h0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "147.4 0 147.4 0 147.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M10.46,45.32A11.33,11.33,0,0,1,1.16,39v0A11.24,11.24,0,0,1,0,34.51c0-.14,0-.28,0-.43v-.14c0-.14,0-.28,0-.42A11.24,11.24,0,0,1,1.15,29s0,0,0,0a11.31,11.31,0,0,1,9.29-6.29c0,2.8-2.48,6.59-3.45,9.42A4.76,4.76,0,0,0,6.61,34V34A4.85,4.85,0,0,0,7,35.91c1,2.82,3.43,6.61,3.45,9.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M10.46,22.64a11.33,11.33,0,0,1-9.3-6.3v0A11.19,11.19,0,0,1,0,11.83c0-.14,0-.28,0-.42v-.07A11.33,11.33,0,0,1,11.34,0h.5a11.19,11.19,0,0,1,4.47,1.14h0a11.36,11.36,0,0,1,6.31,9.31C19.84,10.44,16,8,13.22,7a4.72,4.72,0,0,0-1.8-.39h-.13a4.74,4.74,0,0,0-4.68,4.7v.06A4.8,4.8,0,0,0,7,13.23c1,2.82,3.43,6.61,3.45,9.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M22.71,10.46A11.33,11.33,0,0,1,29,1.16h0A11.24,11.24,0,0,1,33.52,0h1A11.24,11.24,0,0,1,39,1.15h0a11.33,11.33,0,0,1,6.32,9.31c-2.8,0-6.6-2.48-9.42-3.46l-.14,0a4.54,4.54,0,0,0-1.69-.33H34A4.72,4.72,0,0,0,32.13,7c-2.82,1-6.61,3.44-9.42,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.39,10.46a11.33,11.33,0,0,1,6.31-9.3h0A11.19,11.19,0,0,1,56.19,0h1a11.19,11.19,0,0,1,4.47,1.14h0A11.36,11.36,0,0,1,68,10.46C65.19,10.44,61.39,8,58.57,7h0a4.49,4.49,0,0,0-1.8-.37h-.1A4.64,4.64,0,0,0,54.81,7c-2.82,1-6.62,3.44-9.42,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M68.06,10.46a11.36,11.36,0,0,1,6.32-9.3h0A11.19,11.19,0,0,1,78.87,0h1a11.24,11.24,0,0,1,4.48,1.14h0a11.33,11.33,0,0,1,6.31,9.3c-2.8,0-6.6-2.48-9.42-3.46l-.06,0h0a4.68,4.68,0,0,0-1.76-.35h-.1A4.64,4.64,0,0,0,77.49,7c-2.83,1-6.62,3.44-9.43,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M90.74,10.46a11.33,11.33,0,0,1,6.31-9.3h0A11.24,11.24,0,0,1,101.55,0h1A11.24,11.24,0,0,1,107,1.15h0a11.33,11.33,0,0,1,6.31,9.3c-2.8,0-6.6-2.48-9.43-3.46l-.14-.06h0a4.38,4.38,0,0,0-1.66-.32H102a4.59,4.59,0,0,0-1.82.38c-2.83,1-6.63,3.44-9.43,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M113.42,10.46a11.32,11.32,0,0,1,6.3-9.3h0A11.19,11.19,0,0,1,124.22,0h1a11.19,11.19,0,0,1,4.47,1.14h0A11.35,11.35,0,0,1,136,10.46c-2.81,0-6.6-2.48-9.43-3.46a4.64,4.64,0,0,0-1.83-.38h-.1a4.64,4.64,0,0,0-1.83.38c-2.83,1-6.62,3.44-9.42,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M136.09,10.46a11.37,11.37,0,0,1,6.32-9.31h0A11.19,11.19,0,0,1,146.9,0h1a11.19,11.19,0,0,1,4.48,1.14h0a11.36,11.36,0,0,1,6.31,9.31c-2.8,0-6.6-2.48-9.42-3.46l-.2-.08a4.67,4.67,0,0,0-1.63-.3h-.1a4.64,4.64,0,0,0-1.83.38c-2.83,1-6.62,3.44-9.43,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M171,22.64c0-2.82,2.48-6.6,3.46-9.42a4.92,4.92,0,0,0,.39-1.77v-.11A4.73,4.73,0,0,0,171.9,7h0a4.74,4.74,0,0,0-1.76-.37H170A4.82,4.82,0,0,0,168.2,7c-2.83,1-6.63,3.44-9.43,3.46a11.33,11.33,0,0,1,6.31-9.3h0A11.1,11.1,0,0,1,169.57,0h.5a11.25,11.25,0,0,1,7.72,3,2.09,2.09,0,0,1,.22.2l.08.08.24.24h0c.21.22.4.44.59.67a11.48,11.48,0,0,1,1,1.42,11.27,11.27,0,0,1,1.52,5.68h0v.23c0,.09,0,.18,0,.27a11.24,11.24,0,0,1-1.16,4.52l0,.06A11.33,11.33,0,0,1,171,22.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M171,45.32c0-2.82,2.48-6.6,3.45-9.41a4.69,4.69,0,0,0,0-3.79c-1-2.81-3.43-6.59-3.45-9.41a11.36,11.36,0,0,1,9.27,6.23s0,0,0,0a11.28,11.28,0,0,1,1.16,4.53c0,.09,0,.18,0,.26v.46c0,.1,0,.18,0,.27A11.28,11.28,0,0,1,180.24,39l0,0A11.35,11.35,0,0,1,171,45.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M11.34,68h0a11.35,11.35,0,0,1-9.68-5.42h0s0,0,0,0H1.56a0,0,0,0,1,0,0h0a3.37,3.37,0,0,1-.19-.32h0A11.31,11.31,0,0,1,0,56.69v-.07c0-.14,0-.28,0-.42a11.24,11.24,0,0,1,1.14-4.48v0a11.33,11.33,0,0,1,9.3-6.31C10.44,48.19,8,52,7,54.8a4.8,4.8,0,0,0-.4,1.86v.06a4.73,4.73,0,0,0,4.73,4.7,4.61,4.61,0,0,0,1.89-.4c2.82-1,6.59-3.43,9.41-3.45a11.34,11.34,0,0,1-6.2,9.25l-.07,0A11.18,11.18,0,0,1,11.83,68h-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M34,68h-.5A11.13,11.13,0,0,1,29,66.85l-.06,0a11.34,11.34,0,0,1-6.22-9.26c2.82,0,6.6,2.47,9.41,3.45a4.61,4.61,0,0,0,1.89.4h0a4.61,4.61,0,0,0,1.89-.4c2.82-1,6.59-3.43,9.41-3.45a11.31,11.31,0,0,1-6.22,9.26l-.05,0A11.22,11.22,0,0,1,34.51,68H34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M51.61,66.83h0a11.33,11.33,0,0,1-6.21-9.26,11.34,11.34,0,0,0,6.22,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M79.37,68h-.5a11.17,11.17,0,0,1-4.53-1.17l-.06,0a11.34,11.34,0,0,1-6.22-9.26c2.83,0,6.6,2.47,9.42,3.45a4.54,4.54,0,0,0,1.89.4h0a4.69,4.69,0,0,0,1.9-.4c2.81-1,6.58-3.43,9.4-3.45a11.15,11.15,0,0,1-1.12,4.11,11.43,11.43,0,0,1-5.09,5.15l-.06,0A11.18,11.18,0,0,1,79.86,68h-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M102,68h-.49A11.13,11.13,0,0,1,97,66.85l-.06,0a11.34,11.34,0,0,1-6.22-9.26c2.82,0,6.6,2.47,9.41,3.45a4.61,4.61,0,0,0,1.89.4h0a4.62,4.62,0,0,0,1.9-.4c2.81-1,6.59-3.43,9.41-3.45a11.2,11.2,0,0,1-1.12,4.12,11.38,11.38,0,0,1-5.09,5.13l-.07,0A11.13,11.13,0,0,1,102.54,68H102"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M124.72,68h-.49a11.18,11.18,0,0,1-4.54-1.17l-.06,0a11.3,11.3,0,0,1-6.21-9.25c2.82,0,6.59,2.47,9.41,3.45a4.69,4.69,0,0,0,3.79,0c2.81-1,6.59-3.43,9.41-3.45a11.34,11.34,0,0,1-6.22,9.25l-.06,0A11.17,11.17,0,0,1,125.22,68h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M147.4,68h-.5a11.17,11.17,0,0,1-4.53-1.17l-.06,0a11.34,11.34,0,0,1-6.22-9.26c2.83,0,6.6,2.47,9.41,3.45a4.62,4.62,0,0,0,1.9.4h0a4.61,4.61,0,0,0,1.89-.4c2.82-1,6.59-3.43,9.41-3.45a11.31,11.31,0,0,1-6.22,9.26l0,0A11.18,11.18,0,0,1,147.89,68h-.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M170.07,68h-.49a11.13,11.13,0,0,1-4.53-1.17l-.06,0a11.34,11.34,0,0,1-6.22-9.26c2.82,0,6.6,2.47,9.41,3.45a4.61,4.61,0,0,0,1.89.4h0a4.73,4.73,0,0,0,4.73-4.73v-.1a4.93,4.93,0,0,0-.39-1.78c-1-2.82-3.44-6.6-3.46-9.42a11.34,11.34,0,0,1,9.27,6.23s0,0,0,.05a11.24,11.24,0,0,1,1.16,4.52c0,.09,0,.18,0,.27v.23A11.34,11.34,0,0,1,170.07,68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M117,43.93a13.88,13.88,0,0,0-.7-1.49,13.88,13.88,0,0,1,.7,1.49m0,0h0m.13,2.47h0m0,0h0m0,0h0m-.8,1.81a11.86,11.86,0,0,0,.8-1.81,11.86,11.86,0,0,1-.8,1.81m-4.77.51c-.34-.15-.69-.33-1-.52h0c.36.19.71.37,1,.52m3.3.17a14.6,14.6,0,0,0,1.43-.66,14.6,14.6,0,0,1-1.43.66m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M116.29,48.26a11.86,11.86,0,0,0,.8-1.81h0a3.74,3.74,0,0,0,.18-1.06,4.14,4.14,0,0,0-.31-1.41h0a13.88,13.88,0,0,0-.7-1.49c1,.53,2.14,1.18,3.39,1.73a11.16,11.16,0,0,0,4.17,1.15v.07a11.24,11.24,0,0,0-4.09,1.11c-1.28.56-2.43,1.22-3.46,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M113.38,55.81h0a11.19,11.19,0,0,0-1.14-4.15c-.56-1.26-1.21-2.39-1.74-3.41.36.19.71.37,1,.52a4.77,4.77,0,0,0,1.86.49,4.15,4.15,0,0,0,1.43-.31h0a14.6,14.6,0,0,0,1.43-.66l0,0h0c-.54,1-1.2,2.18-1.76,3.47a11.33,11.33,0,0,0-1.11,4.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M116.28,48.27h0c1-.54,2.18-1.2,3.46-1.76l-.06,0c-1.26.55-2.39,1.21-3.41,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M109.54,44.75a9.44,9.44,0,0,1,.93-2.31h0a9.44,9.44,0,0,0-.93,2.31m0,0h0m0,0h0m0,0h0m0,.55h0m0,0h0m0,0h0m0,0h0m1,2.86h0a7,7,0,0,1-1-2.86,6.89,6.89,0,0,0,1,2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M110.46,48.25c-1-.54-2.18-1.2-3.46-1.76a11.17,11.17,0,0,0-4.08-1.1v-.07a11.35,11.35,0,0,0,4.18-1.15c1.24-.55,2.36-1.2,3.37-1.73a9.44,9.44,0,0,0-.93,2.31h0a3.51,3.51,0,0,0,0,.55h0a7,7,0,0,0,1,2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M113.4,41.45h0m0,0h0m0,0h0m.07,0h0m-.08,0h0m.09,0h0m-.11,0h0m.13,0h0m-.15,0h0m.16,0h0m-.17,0h0m.19,0h0m-.21,0h0m0,0h0m0,0h0m0,0h0m3.06,1a7.14,7.14,0,0,0-2.8-1,7.14,7.14,0,0,1,2.8,1m-5.8,0h0a7.47,7.47,0,0,1,2.74-1,7.45,7.45,0,0,0-2.74,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M110.48,42.44c.54-1,1.2-2.18,1.76-3.46a11.24,11.24,0,0,0,1.11-4.09h.07a11.23,11.23,0,0,0,1.1,4.09c.56,1.28,1.22,2.42,1.76,3.46a7.07,7.07,0,0,0-2.8-1h-.26a7.33,7.33,0,0,0-2.74,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M107.1,44.17A11.38,11.38,0,0,0,112.24,39c-.56,1.28-1.22,2.43-1.75,3.45h0c-1,.53-2.13,1.18-3.37,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M112.21,51.66A11.39,11.39,0,0,0,107,46.49c1.28.56,2.43,1.22,3.46,1.76h0c.53,1,1.18,2.15,1.74,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M119.67,44.17c-1.25-.55-2.37-1.21-3.39-1.73h0c-.54-1-1.2-2.18-1.76-3.46a11.4,11.4,0,0,0,5.15,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M114.52,51.74c.56-1.29,1.22-2.44,1.76-3.47h0c1-.53,2.15-1.18,3.41-1.74a11.35,11.35,0,0,0-5.17,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M123.84,45.32a11,11,0,0,1-4.16-1.15A11.38,11.38,0,0,1,114.52,39a11.23,11.23,0,0,1-1.1-4.09c2.27,0,5.16,1.62,7.67,2.75,1.14,2.52,2.74,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M102.92,45.32c0-2.27,1.62-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.75A11.24,11.24,0,0,1,112.24,39a11.31,11.31,0,0,1-9.32,6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M113.35,55.81c-2.26,0-5.16-1.61-7.68-2.75-1.14-2.51-2.73-5.4-2.75-7.67a11.17,11.17,0,0,1,4.08,1.1,11.39,11.39,0,0,1,5.21,5.17,11.19,11.19,0,0,1,1.14,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M113.42,55.81a11.12,11.12,0,0,1,1.1-4.07,11.35,11.35,0,0,1,5.17-5.21l.06,0a11.24,11.24,0,0,1,4.09-1.11c0,2.25-1.61,5.16-2.74,7.68-2.52,1.13-5.43,2.73-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M94.58,44.92a9.06,9.06,0,0,0-1-2.48,9.06,9.06,0,0,1,1,2.48m0,0h0m0,0h0m0,0h0m0,0h0m0,.37h0m0,0h0m0,0h0m0,0h0m-1,2.87a6.86,6.86,0,0,0,1-2.87,6.91,6.91,0,0,1-1,2.87h0m-.22.11h0m-.77.37.76-.36-.76.36m0,0h0m0,0h0m-3.73,0c-.34-.16-.7-.33-1.07-.53.37.2.73.37,1.07.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M93.61,48.26a6.91,6.91,0,0,0,1-2.87h0v0h0c0-.12,0-.24,0-.37h0v0h0a9.06,9.06,0,0,0-1-2.48c1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07a11.24,11.24,0,0,0-4.09,1.11c-1.29.55-2.44,1.22-3.47,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.71,55.81h0c0-.1,0-.21,0-.31a11.3,11.3,0,0,0-1.12-3.84c-.55-1.26-1.21-2.39-1.74-3.41a11.54,11.54,0,0,0,1.07.52,4.69,4.69,0,0,0,1.85.49,4.89,4.89,0,0,0,1.88-.5h0l.76-.37h0l.22-.11h0c-.53,1-1.2,2.18-1.76,3.47a11.32,11.32,0,0,0-1.1,4.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M93.61,48.27h0c1-.54,2.18-1.2,3.47-1.76l-.07,0c-1.25.55-2.38,1.21-3.4,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M87.19,43.72a13.2,13.2,0,0,1,.61-1.28h0a13.2,13.2,0,0,0-.61,1.28m.6,4.53h0a10.42,10.42,0,0,1-.84-2,10.42,10.42,0,0,0,.84,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M87.79,48.25c-1-.54-2.19-1.2-3.47-1.76a11.18,11.18,0,0,0-4.07-1.1v-.07a11.25,11.25,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.37-1.73-.23.45-.44.88-.6,1.28a4.43,4.43,0,0,0-.39,1.63,3.29,3.29,0,0,0,.15.95,10.42,10.42,0,0,0,.84,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M90.71,41.45h0m0,0h0m0,0h0m0,0h0m0,0h0m.39,0h0m0,0h0m0,0h0m0,0h0m0,0h0m2.49,1a8.26,8.26,0,0,0-2.48-1,8.26,8.26,0,0,1,2.48,1m-5.79,0h0a6.86,6.86,0,0,1,2.84-1,6.81,6.81,0,0,0-2.84,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M87.81,42.44c.54-1,1.2-2.18,1.75-3.46a11,11,0,0,0,1.11-4.09h.07A11.24,11.24,0,0,0,91.85,39c.55,1.28,1.22,2.42,1.75,3.46a8,8,0,0,0-2.49-1h-.06a1.88,1.88,0,0,0-.33,0h-.06a6.85,6.85,0,0,0-2.85,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M84.42,44.17A11.33,11.33,0,0,0,89.56,39c-.55,1.28-1.21,2.43-1.75,3.46h0c-1,.53-2.14,1.18-3.38,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M89.53,51.66a11.39,11.39,0,0,0-5.21-5.17c1.28.56,2.44,1.22,3.47,1.76h0c.53,1,1.19,2.15,1.74,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M97,44.17c-1.25-.55-2.38-1.2-3.39-1.73h0c-.53-1-1.2-2.17-1.75-3.45A11.31,11.31,0,0,0,97,44.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M91.84,51.74c.56-1.29,1.23-2.44,1.77-3.47h0c1-.53,2.14-1.19,3.4-1.74a11.39,11.39,0,0,0-5.17,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M101.17,45.32A11.06,11.06,0,0,1,97,44.17a11.33,11.33,0,0,1-6.26-9.28c2.28,0,5.17,1.62,7.68,2.75,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M80.25,45.32c0-2.27,1.61-5.17,2.74-7.68,2.51-1.13,5.41-2.73,7.68-2.75A11.32,11.32,0,0,1,80.25,45.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.67,55.81c-2.26,0-5.16-1.61-7.68-2.75-1.13-2.51-2.73-5.4-2.74-7.67a11.12,11.12,0,0,1,4.07,1.1,11.37,11.37,0,0,1,6.33,9c0,.1,0,.21,0,.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M90.74,55.81A11.32,11.32,0,0,1,97,46.53l.06,0a11.34,11.34,0,0,1,4.1-1.11c0,2.25-1.62,5.16-2.75,7.68C95.9,54.2,93,55.8,90.74,55.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M68,41.45h0m0,0h0m0,0h0m0,0h0m0,0h0m-.3,0h0m0,0h0m0,0h0m0,0h0m0,0h0m3,.86a6.53,6.53,0,0,0-2.63-.87,6.53,6.53,0,0,1,2.63.87m-5.58.12h0a8.12,8.12,0,0,1,2.58-1,8.12,8.12,0,0,0-2.58,1m0,5.81h0a6.94,6.94,0,0,1-1-2.9,6.91,6.91,0,0,1,1-2.91,6.91,6.91,0,0,0-1,2.91,6.94,6.94,0,0,0,1,2.9m1.26.6c-.4-.16-.82-.37-1.26-.6h0c.44.23.86.44,1.26.6m0,0h0m3,.11a15.56,15.56,0,0,0,1.54-.71,6.91,6.91,0,0,0,1-2.91,6.18,6.18,0,0,0-.84-2.59,6.18,6.18,0,0,1,.84,2.59,6.91,6.91,0,0,1-1,2.91A15.56,15.56,0,0,1,69.4,49m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M70.94,48.26a7,7,0,0,0,1-2.91,6.1,6.1,0,0,0-.84-2.58l-.17-.33c1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07A11.24,11.24,0,0,0,74.4,46.5c-1.28.56-2.43,1.22-3.46,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.11,48.25c-1-.53-2.17-1.19-3.44-1.75a11.29,11.29,0,0,0-4.1-1.11v-.07a11.06,11.06,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.38-1.73a6.91,6.91,0,0,0-1,2.91,6.8,6.8,0,0,0,1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68,55.81h0a11.44,11.44,0,0,0-1.15-4.16c-.55-1.25-1.21-2.38-1.74-3.4.44.23.86.44,1.26.6h0a4.31,4.31,0,0,0,1.65.4A4,4,0,0,0,69.39,49h0a15.56,15.56,0,0,0,1.54-.71c1-.54,2.18-1.2,3.46-1.76l-.06,0c-1.26.56-2.39,1.21-3.41,1.74-.54,1-1.21,2.18-1.76,3.47a11.13,11.13,0,0,0-1.11,4.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M65.13,42.44c.54-1,1.2-2.18,1.76-3.45A11.34,11.34,0,0,0,68,34.89h.06A11.24,11.24,0,0,0,69.17,39c.56,1.28,1.22,2.42,1.76,3.46l-.22-.12a6.38,6.38,0,0,0-2.63-.87h-.37a8,8,0,0,0-2.58,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M61.74,44.17A11.43,11.43,0,0,0,66.89,39c-.56,1.27-1.22,2.42-1.76,3.44h0c-1,.53-2.13,1.18-3.38,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.85,51.65a11.43,11.43,0,0,0-5.18-5.15c1.27.56,2.42,1.22,3.44,1.75h0c.52,1,1.18,2.15,1.73,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M74.32,44.17c-1.25-.55-2.37-1.2-3.39-1.73h0c-.54-1-1.2-2.18-1.76-3.46a11.36,11.36,0,0,0,5.15,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.17,51.74h0c.55-1.29,1.22-2.44,1.76-3.47,1-.53,2.15-1.18,3.41-1.74a11.35,11.35,0,0,0-5.17,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M78.49,45.32a11.06,11.06,0,0,1-4.17-1.15A11.36,11.36,0,0,1,69.17,39a11.24,11.24,0,0,1-1.11-4.09c2.28,0,5.17,1.62,7.68,2.75,1.13,2.52,2.74,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M57.57,45.32c0-2.27,1.62-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.75A11.55,11.55,0,0,1,66.89,39a11.43,11.43,0,0,1-5.15,5.18,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M68.06,55.81a11.13,11.13,0,0,1,1.11-4.07,11.37,11.37,0,0,1,5.16-5.21,11.24,11.24,0,0,1,4.16-1.14c0,2.25-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M45.37,41.45h0m0,0h0m0,0h0m-.06,0h0m.08,0h0m-.09,0h0m.11,0h0m-.13,0h0m.14,0h0m-.16,0h0m.18,0h0m-.19,0h0m.2,0h0m-.22,0h0m.24,0h0m-.26,0h0m3,1a7.36,7.36,0,0,0-2.77-1,7.36,7.36,0,0,1,2.77,1m-5.79,0h0a7.24,7.24,0,0,1,2.76-1,7.24,7.24,0,0,0-2.76,1m-.83,1.85a12.75,12.75,0,0,1,.81-1.85,12.75,12.75,0,0,0-.81,1.85m0,0v0m0,0h0m0,0h0m7.62.57a8.81,8.81,0,0,0-1-2.48,8.81,8.81,0,0,1,1,2.48m0,0h0m0,0h0m-7.78.4h0m7.81,0h0m-7.81,0h0m7.81,0h0m0,0h0m-7.81,0h0m7.81,0h0m-7.81,0h0m1,2.86h0a7,7,0,0,1-1-2.86,6.89,6.89,0,0,0,1,2.86m1.26.61c-.4-.17-.82-.38-1.26-.61h0c.44.23.86.44,1.26.61m3.17,0a15.29,15.29,0,0,0,1.39-.65,7,7,0,0,0,1-2.87,7,7,0,0,1-1,2.87,15.29,15.29,0,0,1-1.39.65m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.26,48.26a7.05,7.05,0,0,0,1-2.87h0v0h0a2.8,2.8,0,0,0,0-.4h0a8.7,8.7,0,0,0-1-2.48c1,.53,2.14,1.18,3.39,1.73a11.16,11.16,0,0,0,4.18,1.15v.07a11.29,11.29,0,0,0-4.11,1.11c-1.28.56-2.42,1.22-3.45,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.35,55.81h0a11.19,11.19,0,0,0-1.14-4.15c-.55-1.26-1.21-2.39-1.74-3.41.44.23.86.44,1.26.61a4.4,4.4,0,0,0,1.65.4,4.11,4.11,0,0,0,1.52-.35h0a15.29,15.29,0,0,0,1.39-.65c1-.54,2.17-1.2,3.45-1.75l-.07,0c-1.25.55-2.37,1.2-3.39,1.73-.54,1-1.2,2.18-1.76,3.47a11.12,11.12,0,0,0-1.1,4.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M42.44,48.25c-1-.54-2.19-1.2-3.47-1.76a11.17,11.17,0,0,0-4.08-1.1v-.07a11.06,11.06,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.38-1.73a12.75,12.75,0,0,0-.81,1.85h0v0h0v0a3.64,3.64,0,0,0-.16,1h0a6.89,6.89,0,0,0,1,2.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M42.46,42.44c.53-1,1.19-2.18,1.75-3.46a11.24,11.24,0,0,0,1.11-4.09h.07A11.23,11.23,0,0,0,46.49,39c.56,1.28,1.22,2.42,1.76,3.46h0a7.36,7.36,0,0,0-2.77-1h-.26a7.24,7.24,0,0,0-2.76,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M39.06,44.17A11.36,11.36,0,0,0,44.21,39c-.56,1.28-1.22,2.43-1.75,3.45h0c-1,.53-2.13,1.18-3.38,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M44.18,51.66A11.35,11.35,0,0,0,39,46.49c1.28.56,2.43,1.22,3.47,1.76h0c.53,1,1.19,2.15,1.74,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M51.64,44.17c-1.25-.55-2.37-1.2-3.39-1.73h0c-.54-1-1.2-2.17-1.76-3.45a11.4,11.4,0,0,0,5.15,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.49,51.74c.56-1.29,1.22-2.44,1.76-3.47,1-.53,2.14-1.18,3.39-1.73a11.35,11.35,0,0,0-4.43,3.93,13,13,0,0,0-.72,1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M55.82,45.32a11.11,11.11,0,0,1-4.18-1.15A11.33,11.33,0,0,1,46.5,39a11,11,0,0,1-1.11-4.09c2.27,0,5.16,1.62,7.68,2.75,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M34.89,45.32c0-2.27,1.62-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.75a11.33,11.33,0,0,1-6.26,9.28,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M45.32,55.81c-2.26,0-5.16-1.61-7.68-2.75-1.13-2.51-2.73-5.4-2.75-7.67A11.17,11.17,0,0,1,39,46.49a11.35,11.35,0,0,1,5.21,5.17,11.19,11.19,0,0,1,1.14,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M45.39,55.81a11.12,11.12,0,0,1,1.1-4.07,13,13,0,0,1,.72-1.27,11.31,11.31,0,0,0-1.82,5.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M22.68,41.45h0m0,0h0m0,0h0m0,0h0m0,0h0m-.3,0h0m0,0h0m0,0h0m0,0h0m0,0h0m3.22,1a7,7,0,0,0-2.85-1,7,7,0,0,1,2.85,1m-5.8,0h0a7.86,7.86,0,0,1,2.58-1,7.68,7.68,0,0,0-2.58,1m6.77,2.48a8.46,8.46,0,0,0-1-2.48h0a8.46,8.46,0,0,1,1,2.48m0,0h0m0,0h0M18.8,45a8,8,0,0,1,1-2.52h0a8,8,0,0,0-1,2.52m7.75,0h0M18.8,45h0m7.76,0h0m-7.77,0h0m0,.35h0m7.81,0h0m-7.81,0h0m7.81,0h0m0,0h0m-7.81,0h0m7.81,0h0m-7.81,0h0m5.42,3.52a15.29,15.29,0,0,0,1.39-.65,6.86,6.86,0,0,0,1-2.87,6.91,6.91,0,0,1-1,2.87,15.29,15.29,0,0,1-1.39.65m-3,0a15.14,15.14,0,0,1-1.44-.68,6.89,6.89,0,0,1-1-2.86,6.89,6.89,0,0,0,1,2.86,15.14,15.14,0,0,0,1.44.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M25.58,48.26a6.91,6.91,0,0,0,1-2.87h0v0h0c0-.12,0-.24,0-.37h0v0h0a8.46,8.46,0,0,0-1-2.48c1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07A11.34,11.34,0,0,0,29,46.5c-1.28.56-2.43,1.22-3.46,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M22.68,55.81h0a11.23,11.23,0,0,0-1.1-4.08c-.56-1.28-1.22-2.43-1.76-3.46h0a15.14,15.14,0,0,0,1.44.68,4.06,4.06,0,0,0,1.48.33,4.33,4.33,0,0,0,1.51-.34c.44-.18.9-.4,1.39-.66,1-.54,2.18-1.2,3.46-1.76l-.06,0c-1.26.55-2.39,1.21-3.4,1.74-.54,1-1.21,2.18-1.76,3.47a11.13,11.13,0,0,0-1.11,4.07h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M19.77,48.26c-1-.52-2.14-1.18-3.39-1.73a11.24,11.24,0,0,0-4.16-1.14v-.07a11.25,11.25,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.38-1.73a8.07,8.07,0,0,0-1,2.51h0a2.28,2.28,0,0,0,0,.36h0a6.89,6.89,0,0,0,1,2.86h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M19.78,42.44c.54-1,1.2-2.18,1.75-3.46a11,11,0,0,0,1.11-4.09h.07a11.1,11.1,0,0,0,1.08,4l0,.07c.55,1.28,1.22,2.42,1.76,3.46a6.9,6.9,0,0,0-2.85-1h-.37a8,8,0,0,0-2.58,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M23.79,38.92a11.41,11.41,0,0,1-1.08-4h0a11.41,11.41,0,0,0,1.08,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M29,44.17c-1.25-.55-2.38-1.21-3.39-1.73h0c-.54-1-1.21-2.18-1.76-3.46A11.31,11.31,0,0,0,29,44.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M23.82,51.74c.55-1.29,1.22-2.44,1.76-3.47,1-.53,2.14-1.18,3.4-1.74a11.33,11.33,0,0,0-5.16,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M21.54,51.73a11.45,11.45,0,0,0-5.16-5.2c1.25.55,2.37,1.21,3.38,1.73h0c.54,1,1.2,2.18,1.76,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M16.39,44.17A11.33,11.33,0,0,0,21.53,39c-.55,1.28-1.21,2.43-1.75,3.45h0c-1,.53-2.13,1.18-3.38,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M12.22,45.32c0-2.27,1.61-5.17,2.74-7.68,2.51-1.13,5.41-2.73,7.68-2.75A11,11,0,0,1,21.53,39a11.31,11.31,0,0,1-9.31,6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M33.14,45.32A11.06,11.06,0,0,1,29,44.17,11.31,11.31,0,0,1,23.82,39l0-.07a11.3,11.3,0,0,1-1.08-4c2.27,0,5.17,1.62,7.68,2.75,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M22.64,55.81c-2.26,0-5.16-1.61-7.68-2.75-1.13-2.51-2.73-5.4-2.74-7.67a11.24,11.24,0,0,1,4.16,1.14,11.45,11.45,0,0,1,5.16,5.2,11.23,11.23,0,0,1,1.1,4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M22.71,55.81A11.32,11.32,0,0,1,29,46.53l.06,0a11.34,11.34,0,0,1,4.1-1.11c0,2.25-1.62,5.16-2.75,7.68C27.87,54.2,25,55.8,22.71,55.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M117.29,22.63a7,7,0,0,0-1-2.87h0a7,7,0,0,1,1,2.87m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,.32h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0a0,0,0,0,0,0,0,0,0,0,0,1,0,0M113,26.56a8,8,0,0,1-2.57-1h0a8,8,0,0,0,2.57,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.26,0a7.24,7.24,0,0,0,2.78-1,8.26,8.26,0,0,0,1-2.47,8.26,8.26,0,0,1-1,2.47,7.19,7.19,0,0,1-2.78,1m-.25,0h0m.23,0h0m-.21,0h0m.2,0h0m-.19,0h0m.18,0h0m-.16,0h0m.15,0h0m-.14,0h0m.12,0h0m-.1,0h0m.09,0h0m0,0h0m-.06,0h0m.05,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M113.38,33.14h0A11.18,11.18,0,0,0,112.21,29c-.56-1.26-1.21-2.39-1.74-3.4a8,8,0,0,0,2.57,1h.47a7.3,7.3,0,0,0,2.78-1h0c-.54,1-1.2,2.19-1.76,3.47l-.09.18a11.52,11.52,0,0,0-1,3.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M116.28,25.59h0a8.54,8.54,0,0,0,1-2.47h0a0,0,0,0,0,0,0h0v0h0c0-.11,0-.21,0-.32h0v0h0a7,7,0,0,0-1-2.87c1,.53,2.14,1.18,3.39,1.74a11.49,11.49,0,0,0,4.17,1.15v.06a11.06,11.06,0,0,0-4.16,1.15c-1.25.55-2.38,1.2-3.4,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.68,23.86a11.06,11.06,0,0,1,4.16-1.15,11.19,11.19,0,0,0-4.15,1.14h0m-5.25,5.38.09-.18-.09.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M109.68,21.53a11.91,11.91,0,0,1,.79-1.76h0a11.91,11.91,0,0,0-.79,1.76m0,0h0m.79,4h0c-.16-.32-.31-.62-.44-.91.13.29.28.59.45.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M110.46,25.57c-1-.53-2.18-1.2-3.46-1.76a11.37,11.37,0,0,0-4.08-1.1v-.07a11.16,11.16,0,0,0,4.18-1.15c1.24-.55,2.36-1.2,3.37-1.72a11.91,11.91,0,0,0-.79,1.76h0a3.7,3.7,0,0,0-.2,1.14,4.92,4.92,0,0,0,.54,2c.13.3.28.6.44.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M112,19.05h0m4.26.71a10.56,10.56,0,0,0-2-.86,10.56,10.56,0,0,1,2,.86h0m-5.8,0h0a13.38,13.38,0,0,1,1.54-.7,13.38,13.38,0,0,0-1.54.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M110.48,19.76c.54-1,1.2-2.18,1.76-3.45a11.29,11.29,0,0,0,1.11-4.09h.07a11.23,11.23,0,0,0,1.1,4.08c.56,1.28,1.22,2.43,1.76,3.46a10.56,10.56,0,0,0-2-.86,3.62,3.62,0,0,0-.9-.13,3.88,3.88,0,0,0-1.35.28h0a13.38,13.38,0,0,0-1.54.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M107.1,21.49a11.41,11.41,0,0,0,5.14-5.18c-.56,1.27-1.22,2.42-1.75,3.45h0c-1,.52-2.13,1.17-3.37,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M112.21,29A11.37,11.37,0,0,0,107,23.82c1.28.55,2.43,1.22,3.46,1.75h0c.53,1,1.18,2.15,1.74,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M119.67,21.5c-1.25-.56-2.37-1.21-3.39-1.74h0c-.54-1-1.2-2.18-1.76-3.46a11.47,11.47,0,0,0,5.15,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.52,29.06h0c.56-1.28,1.22-2.43,1.76-3.47h0c1-.53,2.15-1.18,3.4-1.73h0a11.39,11.39,0,0,0-5.17,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M102.92,22.64c0-2.27,1.62-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.74a11.29,11.29,0,0,1-1.11,4.09,11.41,11.41,0,0,1-5.14,5.18,11.16,11.16,0,0,1-4.18,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M123.84,22.64a11,11,0,0,1-4.16-1.15,11.38,11.38,0,0,1-5.16-5.19,11.23,11.23,0,0,1-1.1-4.08c2.27,0,5.16,1.61,7.67,2.74,1.13,2.52,2.74,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M113.42,33.14a11.28,11.28,0,0,1,1-3.9l.09-.18a11.39,11.39,0,0,1,5.17-5.21,11.19,11.19,0,0,1,4.15-1.14c0,2.26-1.61,5.16-2.74,7.68-2.52,1.13-5.43,2.73-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M113.35,33.14c-2.26,0-5.16-1.62-7.68-2.75-1.14-2.51-2.73-5.41-2.75-7.68A11.18,11.18,0,0,1,107,23.82,11.37,11.37,0,0,1,112.21,29a11.18,11.18,0,0,1,1.14,4.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M91.27,26.53a9.35,9.35,0,0,0,2.34-1,6.78,6.78,0,0,0,1-2.9,7,7,0,0,0-1-2.92h0a7,7,0,0,1,1,2.92,6.78,6.78,0,0,1-1,2.9,9.35,9.35,0,0,1-2.34,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-.5,0a7,7,0,0,1-2.87-1,7,7,0,0,0,2.87,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.71,33.14h0A11.13,11.13,0,0,0,89.53,29c-.55-1.26-1.21-2.39-1.74-3.41a7,7,0,0,0,2.87,1h.06a2.18,2.18,0,0,0,.44,0h.11a9.35,9.35,0,0,0,2.34-1h0c-.53,1-1.2,2.19-1.76,3.47l-.12.26a11.1,11.1,0,0,0-1,3.82h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M91.72,29.32l.12-.26-.12.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M93.61,25.59h0a6.78,6.78,0,0,0,1-2.9,7,7,0,0,0-1-2.92c1,.53,2.14,1.18,3.39,1.74a11.44,11.44,0,0,0,4.17,1.15v.06A11.18,11.18,0,0,0,97,23.85c-1.26.56-2.39,1.21-3.4,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M89.62,19h0m4,.8A12.09,12.09,0,0,0,91.92,19a12.64,12.64,0,0,1,1.68.76h0m-5.79,0h0a11.36,11.36,0,0,1,1.8-.8,11.36,11.36,0,0,0-1.8.8m-.73,1.56a13.84,13.84,0,0,1,.72-1.55h0a13.84,13.84,0,0,0-.72,1.55m.71,4.25h0A11.27,11.27,0,0,1,87,23.82a11.27,11.27,0,0,0,.78,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M87.79,25.57c-1-.53-2.18-1.2-3.46-1.75a11.24,11.24,0,0,0-4.08-1.11v-.07a11.06,11.06,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.37-1.72a15.66,15.66,0,0,0-.71,1.55,3.89,3.89,0,0,0-.28,1.36A3.85,3.85,0,0,0,87,23.83a11.62,11.62,0,0,0,.78,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M84.33,23.82h0a11.38,11.38,0,0,0-4.07-1.1h0a11.24,11.24,0,0,1,4.08,1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M87.81,19.76c.54-1,1.2-2.18,1.75-3.45a11.09,11.09,0,0,0,1.11-4.09h.07a11.24,11.24,0,0,0,1.11,4.08c.55,1.28,1.22,2.43,1.75,3.46A12.09,12.09,0,0,0,91.92,19a3.68,3.68,0,0,0-1.21-.23,3.63,3.63,0,0,0-1.09.19h0a11.36,11.36,0,0,0-1.8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M84.42,21.49a11.36,11.36,0,0,0,5.14-5.18c-.55,1.27-1.21,2.42-1.75,3.45h0c-1,.52-2.14,1.17-3.38,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M89.53,29a11.3,11.3,0,0,0-5.21-5.17h0c1.28.55,2.43,1.22,3.46,1.76h0c.53,1,1.19,2.15,1.74,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M97,21.5c-1.25-.56-2.38-1.21-3.39-1.74h0c-.53-1-1.2-2.18-1.75-3.46A11.38,11.38,0,0,0,97,21.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M91.84,29.06h0c.56-1.28,1.23-2.43,1.76-3.47h0c1-.53,2.14-1.18,3.4-1.74a11.44,11.44,0,0,0-5.17,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M80.25,22.64c0-2.27,1.61-5.17,2.74-7.68,2.51-1.13,5.41-2.73,7.68-2.74a11.32,11.32,0,0,1-6.25,9.27,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M101.17,22.64A11.23,11.23,0,0,1,97,21.5a11.38,11.38,0,0,1-5.15-5.2,11.24,11.24,0,0,1-1.11-4.08c2.27,0,5.17,1.61,7.68,2.74,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M90.74,33.14a11.1,11.1,0,0,1,1-3.82l.12-.26A11.44,11.44,0,0,1,97,23.85a11.18,11.18,0,0,1,4.16-1.14c0,2.26-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M90.67,33.14c-2.26,0-5.16-1.62-7.68-2.75-1.13-2.51-2.73-5.41-2.74-7.68a11.13,11.13,0,0,1,4.07,1.11A11.3,11.3,0,0,1,89.53,29a11.13,11.13,0,0,1,1.14,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M66.33,19.19h0m0,0h0m0,0h0m0,0h0m-.42.19.42-.19-.42.19m0,0h0m0,0h0m0,0h0m5.13.34a10.14,10.14,0,0,0-2.07-.87,10.14,10.14,0,0,1,2.07.87m-5.82,5.81h0a6.9,6.9,0,0,1-1-2.89,6.82,6.82,0,0,1,1-2.91h0a6.82,6.82,0,0,0-1,2.91,6.85,6.85,0,0,0,1,2.89m2.58,1a8,8,0,0,1-2.58-1h0a8,8,0,0,0,2.58,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.31,0a7,7,0,0,0,2.86-1,6.92,6.92,0,0,0,1-2.9A6.54,6.54,0,0,0,71,19.93a6.5,6.5,0,0,1,.92,2.75,6.92,6.92,0,0,1-1,2.9,7,7,0,0,1-2.86,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.11,25.57c-1-.53-2.18-1.2-3.46-1.75a11.24,11.24,0,0,0-4.08-1.11v-.07a11.23,11.23,0,0,0,4.17-1.14c1.25-.56,2.37-1.21,3.38-1.73a6.86,6.86,0,0,0-1,2.91,6.76,6.76,0,0,0,1,2.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M70.94,25.58a6.92,6.92,0,0,0,1-2.9A6.54,6.54,0,0,0,71,19.93l-.09-.17c1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07a11.29,11.29,0,0,0-4.1,1.11c-1.28.56-2.43,1.22-3.45,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M61.65,23.82h0a11.43,11.43,0,0,0-4.08-1.1h0a11.18,11.18,0,0,1,4.08,1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M68,33.14h0A11.33,11.33,0,0,0,66.86,29c-.56-1.26-1.21-2.39-1.75-3.41a8,8,0,0,0,2.58,1h.39a7,7,0,0,0,2.86-1c1-.53,2.17-1.2,3.45-1.75l-.06,0c-1.26.55-2.39,1.21-3.4,1.73-.54,1-1.2,2.18-1.76,3.46a11.24,11.24,0,0,0-1.11,4.09h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M74.32,23.86l.07,0a11.34,11.34,0,0,1,4.1-1.11,11.24,11.24,0,0,0-4.16,1.14h0m-6.26,9.28a11.24,11.24,0,0,1,1.11-4.09h0a11.18,11.18,0,0,0-1.11,4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.13,19.76c.54-1,1.2-2.18,1.75-3.45A11.05,11.05,0,0,0,68,12.22h.06a11.24,11.24,0,0,0,1.11,4.08c.56,1.28,1.22,2.43,1.76,3.46a10.14,10.14,0,0,0-2.07-.87,3.08,3.08,0,0,0-.83-.12,4.41,4.41,0,0,0-1.7.42h-.07l-.42.18h0l-.67.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.74,21.49a11.43,11.43,0,0,0,5.15-5.18c-.56,1.28-1.22,2.42-1.76,3.45h0c-1,.52-2.13,1.17-3.38,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M66.86,29a11.46,11.46,0,0,0-5.21-5.18h0c1.28.55,2.43,1.22,3.46,1.76h0c.54,1,1.19,2.15,1.75,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M74.32,21.5c-1.25-.56-2.37-1.21-3.39-1.74h0c-.54-1-1.2-2.18-1.76-3.46a11.42,11.42,0,0,0,5.15,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M69.17,29.06h0c.56-1.28,1.22-2.43,1.76-3.46,1-.52,2.14-1.18,3.4-1.73h0a11.42,11.42,0,0,0-5.16,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.57,22.64c0-2.27,1.62-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.74a11.31,11.31,0,0,1-6.26,9.27,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M78.49,22.64a11.06,11.06,0,0,1-4.17-1.15,11.36,11.36,0,0,1-5.15-5.19,11.24,11.24,0,0,1-1.11-4.08c2.28,0,5.17,1.61,7.68,2.74,1.13,2.52,2.74,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M68.06,33.14a11.18,11.18,0,0,1,1.11-4.08,11.42,11.42,0,0,1,5.16-5.21,11.24,11.24,0,0,1,4.16-1.14c0,2.26-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M68,33.14c-2.26,0-5.17-1.62-7.69-2.75-1.13-2.51-2.72-5.41-2.74-7.68A11.34,11.34,0,0,1,68,33.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M44.12,19h0m-1.28.55A11.81,11.81,0,0,1,44.1,19a11.81,11.81,0,0,0-1.26.55m5.41.2a10.86,10.86,0,0,0-1.88-.82,11.2,11.2,0,0,1,1.88.82h0m-6.8,2.85a7.06,7.06,0,0,1,1-2.84h0a7.06,7.06,0,0,0-1,2.84m0,0v0m7.81,0a7,7,0,0,0-1-2.87h0a7,7,0,0,1,1,2.87m-7.81,0h0m7.81,0h0m-7.81,0h0m7.81,0h0m-7.81,0h0m7.81,0h0m-7.81,0h0m7.81,0h0m0,0h0m-7.81,0h0m0,.26h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m7.73.21h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-6.73,2.18h0a8.23,8.23,0,0,1-1-2.52,8,8,0,0,0,1,2.52m3.23,1a8.07,8.07,0,0,0,2.59-1,10,10,0,0,0,.91-2.18,10,10,0,0,1-.91,2.18,8.07,8.07,0,0,1-2.59,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-.39,0a7.73,7.73,0,0,1-2.72-1h0a7.73,7.73,0,0,0,2.72,1m.37,0h0m-.35,0h0m.34,0h0m-.33,0h0m.31,0h0m-.29,0h0m.28,0h0m-.27,0h0m.25,0h0m-.23,0h0m.22,0h0m-.21,0h0m.19,0h0m-.18,0h0m.17,0h0m-.15,0h0m.13,0h0m-.12,0h0m.11,0h0m-.09,0h0m.07,0h0m-.06,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.26,25.58a9.79,9.79,0,0,0,.91-2.18h0v0h0v0h0a2.83,2.83,0,0,0,.06-.57h0v0h0a7,7,0,0,0-1-2.87c1,.53,2.14,1.18,3.39,1.73a11.11,11.11,0,0,0,4.18,1.15v.07a11.23,11.23,0,0,0-4.1,1.11c-1.28.56-2.43,1.22-3.46,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M42.44,25.57c-1-.53-2.18-1.2-3.46-1.75a11.24,11.24,0,0,0-4.09-1.11v-.07a11.23,11.23,0,0,0,4.17-1.14c1.25-.56,2.37-1.21,3.38-1.73a7.06,7.06,0,0,0-1,2.84v0h0v0h0a2.26,2.26,0,0,0,0,.26h0v0h0a8,8,0,0,0,1,2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M39,23.82h0a11.37,11.37,0,0,0-4.08-1.1h0A11.24,11.24,0,0,1,39,23.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M45.35,33.14h0A11.13,11.13,0,0,0,44.18,29c-.55-1.26-1.21-2.39-1.74-3.41a7.67,7.67,0,0,0,2.72,1h.51a8,8,0,0,0,2.59-1c1-.53,2.18-1.2,3.46-1.75l-.07,0c-1.26.55-2.38,1.21-3.4,1.73-.54,1-1.2,2.19-1.76,3.47a1.42,1.42,0,0,0-.08.18,11.08,11.08,0,0,0-1,3.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M51.65,23.86l.07,0a11.24,11.24,0,0,1,4.09-1.11,11.24,11.24,0,0,0-4.16,1.14h0m-5.24,5.38a1.42,1.42,0,0,1,.08-.18,1.42,1.42,0,0,0-.08.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.46,19.76c.53-1,1.2-2.18,1.75-3.45a11.29,11.29,0,0,0,1.11-4.09h.07a11.23,11.23,0,0,0,1.1,4.08c.56,1.28,1.22,2.43,1.76,3.46a10.86,10.86,0,0,0-1.88-.82,3.51,3.51,0,0,0-1-.17,3.82,3.82,0,0,0-1.23.24h0a10.38,10.38,0,0,0-1.27.55l-.38.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.06,21.49a11.38,11.38,0,0,0,5.15-5.18c-.56,1.27-1.22,2.42-1.75,3.45h0c-1,.52-2.13,1.17-3.38,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M44.18,29A11.37,11.37,0,0,0,39,23.81h0c1.28.55,2.43,1.22,3.46,1.76h0c.53,1,1.19,2.15,1.74,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.64,21.49c-1.25-.55-2.37-1.2-3.39-1.73h0c-.54-1-1.2-2.18-1.76-3.46a11.4,11.4,0,0,0,5.15,5.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M46.49,29.06h0c.56-1.28,1.22-2.43,1.76-3.47,1-.52,2.14-1.18,3.4-1.73h0a11.39,11.39,0,0,0-5.17,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M34.89,22.64c0-2.27,1.62-5.17,2.75-7.68,2.51-1.13,5.4-2.73,7.68-2.74a11.31,11.31,0,0,1-6.26,9.27,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.82,22.64a11.11,11.11,0,0,1-4.18-1.15A11.33,11.33,0,0,1,46.5,16.3a11,11,0,0,1-1.11-4.08c2.27,0,5.16,1.61,7.67,2.74,1.14,2.52,2.74,5.42,2.76,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M45.39,33.14a11.08,11.08,0,0,1,1-3.9,1.42,1.42,0,0,1,.08-.18,11.42,11.42,0,0,1,5.16-5.21,11.29,11.29,0,0,1,4.17-1.14c0,2.26-1.62,5.16-2.75,7.68-2.52,1.13-5.43,2.73-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M45.32,33.14c-2.26,0-5.16-1.62-7.68-2.75-1.13-2.51-2.73-5.41-2.75-7.68A11.3,11.3,0,0,1,44.18,29a11.13,11.13,0,0,1,1.14,4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M23.51,18.89h0m-2.26.19h0m-1.47.68h0a12.43,12.43,0,0,1,1.46-.68,12.43,12.43,0,0,0-1.46.68m5.8,0a10.87,10.87,0,0,0-2-.87,10.25,10.25,0,0,1,2,.87h0m-6.81,2.87a7.07,7.07,0,0,1,1-2.86h0a7.07,7.07,0,0,0-1,2.86m7.81,0a7,7,0,0,0-1-2.87h0a7,7,0,0,1,1,2.87m-7.81,0h0m7.81,0h0m-7.81,0h0m7.81,0h0m-7.81,0h0m7.81,0h0m-7.81,0h0m7.81,0h0m0,0h0m-7.81,0h0m0,.19h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m7.78.05h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0v0m-6.79,2.46h0a7.6,7.6,0,0,1-1-2.61,7.81,7.81,0,0,0,1,2.61m2.62,1a8.2,8.2,0,0,1-2.62-1h0a8.2,8.2,0,0,0,2.62,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m.27,0a7.06,7.06,0,0,0,2.83-1,8.31,8.31,0,0,0,1-2.47,8.31,8.31,0,0,1-1,2.47,7.06,7.06,0,0,1-2.83,1m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M19.76,25.57c-1-.53-2.18-1.19-3.45-1.75a11.29,11.29,0,0,0-4.09-1.11v-.07a11.06,11.06,0,0,0,4.17-1.15c1.25-.55,2.37-1.2,3.37-1.72a7.2,7.2,0,0,0-1,2.85h0v0h0a1.09,1.09,0,0,0,0,.18v0h0a7.68,7.68,0,0,0,1,2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M19.78,19.76c.54-1,1.2-2.18,1.75-3.45a11.09,11.09,0,0,0,1.11-4.09h.07a11.24,11.24,0,0,0,1.11,4.08c.55,1.28,1.22,2.43,1.76,3.46a10.25,10.25,0,0,0-2-.87h0a3.14,3.14,0,0,0-.83-.12,4.12,4.12,0,0,0-1.43.3h0a12.43,12.43,0,0,0-1.46.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M16.31,23.82h0a11.24,11.24,0,0,0-4.08-1.11h0a11.29,11.29,0,0,1,4.09,1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M25.58,25.58a8.31,8.31,0,0,0,1-2.47v0h0v0h0a1.72,1.72,0,0,0,0-.32h0v0h0a7,7,0,0,0-1-2.87c1,.53,2.14,1.18,3.39,1.73a11.06,11.06,0,0,0,4.17,1.15v.07A11.21,11.21,0,0,0,29,23.83c-1.27.55-2.42,1.22-3.45,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M22.68,33.14h0A11.18,11.18,0,0,0,21.5,29c-.55-1.26-1.21-2.39-1.74-3.4a8.2,8.2,0,0,0,2.62,1h.37a7.06,7.06,0,0,0,2.83-1c1-.53,2.18-1.2,3.45-1.75l-.06,0c-1.25.55-2.38,1.21-3.39,1.73-.54,1-1.2,2.18-1.76,3.46a11.24,11.24,0,0,0-1.11,4.09h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M29,23.86l.06,0a11.21,11.21,0,0,1,4.11-1.12A11.18,11.18,0,0,0,29,23.85h0m-6.26,9.28a11.24,11.24,0,0,1,1.11-4.09h0a11.18,11.18,0,0,0-1.11,4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.82,16.3a11.24,11.24,0,0,1-1.11-4.08,11.24,11.24,0,0,0,1.11,4.08h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M16.39,21.49a11.36,11.36,0,0,0,5.14-5.18c-.55,1.27-1.21,2.42-1.75,3.45h0c-1,.52-2.12,1.17-3.37,1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M29,21.5c-1.25-.56-2.38-1.21-3.39-1.74h0c-.54-1-1.21-2.18-1.76-3.46h0A11.38,11.38,0,0,0,29,21.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M23.82,29.06h0c.56-1.28,1.22-2.43,1.76-3.46,1-.52,2.14-1.18,3.39-1.73h0a11.37,11.37,0,0,0-5.16,5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M21.5,29a11.39,11.39,0,0,0-5.21-5.17h0c1.27.55,2.42,1.22,3.45,1.75h0c.53,1,1.19,2.14,1.74,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M22.64,33.14c-2.26,0-5.16-1.62-7.68-2.75-1.13-2.51-2.73-5.41-2.74-7.68A11.35,11.35,0,0,1,21.5,29a11.18,11.18,0,0,1,1.14,4.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M12.22,22.64c0-2.27,1.61-5.17,2.74-7.68,2.51-1.13,5.41-2.73,7.68-2.74a11.09,11.09,0,0,1-1.11,4.09,11.36,11.36,0,0,1-5.14,5.18,11.06,11.06,0,0,1-4.17,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M33.14,22.64A11.06,11.06,0,0,1,29,21.49a11.34,11.34,0,0,1-6.26-9.27c2.27,0,5.17,1.61,7.68,2.74,1.13,2.52,2.73,5.42,2.75,7.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M22.71,33.14A11.31,11.31,0,0,1,29,23.85a11.18,11.18,0,0,1,4.16-1.14c0,2.26-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M136.06,33.93v-.17l0-.62h.06c0,.26,0,.52,0,.79m0,1c0-.27,0-.54,0-.82,0,.28,0,.55,0,.82H136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M136.06,34v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M143.77,37.64c-2.51-1.13-5.4-2.73-7.68-2.75,0-.27,0-.54,0-.82v-.14c0-.27,0-.53,0-.79,2.26,0,5.16-1.62,7.68-2.75-.27.61-.52,1.19-.7,1.74a4.57,4.57,0,0,0-.4,1.89,4.53,4.53,0,0,0,.4,1.88c.18.55.43,1.13.7,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M128.35,37.64c.27-.6.51-1.18.7-1.73a4.69,4.69,0,0,0,0-3.79c-.19-.54-.43-1.13-.71-1.73,2.52,1.13,5.43,2.73,7.69,2.75l0,.62v.31c0,.28,0,.55,0,.82-2.28,0-5.17,1.62-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M158.73,33.9v-.1q0-.33,0-.66h.07l0,.54v.22m0,1c0-.27,0-.54,0-.81q0,.41,0,.81h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M158.74,33.91a.37.37,0,0,0,0-.11.34.34,0,0,1,0,.1h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M158.74,34v0h0V34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M166.45,37.64c-2.51-1.13-5.41-2.73-7.68-2.75q0-.41,0-.81v-.4c0-.18,0-.36,0-.54,2.26,0,5.16-1.62,7.68-2.75-.27.61-.52,1.19-.71,1.74a4.76,4.76,0,0,0-.39,1.88h0a4.76,4.76,0,0,0,.39,1.88c.19.55.43,1.13.71,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M151,37.64c.27-.6.52-1.18.71-1.73a4.8,4.8,0,0,0,0-3.79c-.19-.54-.44-1.13-.71-1.73,2.52,1.13,5.42,2.73,7.68,2.75q0,.33,0,.66v.11a.06.06,0,0,0,0,0v.13c0,.27,0,.54,0,.81-2.27,0-5.17,1.62-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M143.07,35.91a4.62,4.62,0,0,1-.4-1.9,4.53,4.53,0,0,1,.4-1.88h0a4.75,4.75,0,0,0,0,3.77h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M113.38,34c0-.28,0-.55,0-.82h.07a7.38,7.38,0,0,0,0,.82m0,.93c0-.27,0-.54,0-.82a7.38,7.38,0,0,0,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M121.09,37.64c-2.51-1.13-5.4-2.73-7.67-2.75,0-.27,0-.54,0-.82V34c0-.28,0-.55,0-.82,2.25,0,5.16-1.62,7.68-2.75a18.26,18.26,0,0,0-.71,1.74A4.73,4.73,0,0,0,120,34a4.68,4.68,0,0,0,.39,1.88c.19.55.43,1.13.7,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M105.67,37.64c.27-.6.52-1.19.7-1.73a4.61,4.61,0,0,0,.4-1.89,4.78,4.78,0,0,0-.39-1.9c-.19-.54-.44-1.13-.71-1.73,2.52,1.13,5.42,2.73,7.68,2.75,0,.27,0,.54,0,.82v.11c0,.28,0,.55,0,.82-2.28,0-5.17,1.62-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M120.39,35.9A4.68,4.68,0,0,1,120,34a4.73,4.73,0,0,1,.39-1.89h0a4.75,4.75,0,0,0,0,3.77h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M57.57,45.39l-.74,0c.25,0,.49,0,.74,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M55.82,45.39v-.07c.24,0,.49,0,.74,0l-.74,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M56.56,45.35c-.25,0-.5,0-.74,0,0-2.26-1.62-5.16-2.76-7.68.61.27,1.19.52,1.74.7a4.61,4.61,0,0,0,1.89.4h0a4.62,4.62,0,0,0,1.9-.4c.54-.19,1.12-.43,1.73-.7-1.13,2.51-2.73,5.4-2.75,7.68-.25,0-.49,0-.74,0h-.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M57.57,22.71c-.25,0-.51,0-.77,0l.77,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M57.57,22.71c-.21,0-.41,0-.62,0H56.8c.26,0,.52,0,.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M56.84,22.68h0m.06,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M57,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M55.82,22.71v-.07l.76,0c-.26,0-.51,0-.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M55.82,22.71h0c.25,0,.5,0,.76,0h0c-.27,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M56.78,22.68h-.2c-.26,0-.51,0-.76,0,0-2.26-1.62-5.16-2.76-7.68.61.27,1.19.52,1.74.71a4.77,4.77,0,0,0,1.89.39h0a4.73,4.73,0,0,0,1.89-.39c.55-.19,1.13-.44,1.74-.71-1.14,2.51-2.73,5.41-2.75,7.68-.25,0-.51,0-.77,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M53.07,30.39c1.13-2.52,2.73-5.42,2.75-7.68q.39,0,.78,0H57c.21,0,.41,0,.62,0,0,2.28,1.61,5.17,2.75,7.68-.61-.27-1.2-.52-1.75-.71a4.68,4.68,0,0,0-1.88-.39h0a4.72,4.72,0,0,0-1.88.39c-.55.19-1.13.44-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M58.57,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M58.58,29.68h0a4.68,4.68,0,0,0-1.88-.39,4.77,4.77,0,0,1,1.89.39m-1.89,9.06h0a4.77,4.77,0,0,0,1.89-.39h0a4.78,4.78,0,0,1-1.9.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M45.35,33.93v-.17c0-.21,0-.42,0-.62h.07c0,.26,0,.52,0,.79m0,1c0-.27,0-.54,0-.82,0,.28,0,.55,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M45.35,34v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M53.06,37.64c-2.51-1.13-5.4-2.73-7.67-2.75,0-.27,0-.54,0-.82v-.14c0-.27,0-.53,0-.79,2.26,0,5.16-1.62,7.68-2.75-.28.61-.52,1.19-.71,1.74A4.76,4.76,0,0,0,52,34h0a4.76,4.76,0,0,0,.39,1.88c.19.55.43,1.13.7,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M37.64,37.64c.27-.6.52-1.18.71-1.73a4.8,4.8,0,0,0,0-3.79c-.19-.54-.44-1.13-.71-1.73,2.52,1.13,5.42,2.73,7.68,2.75,0,.2,0,.41,0,.62v.31c0,.28,0,.55,0,.82-2.27,0-5.17,1.62-7.68,2.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: 56.69,
    y1: 38.74,
    x2: 56.69,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M54.8,38.35c-.55-.19-1.13-.44-1.73-.71-.28-.61-.52-1.19-.71-1.74a4.79,4.79,0,0,0,2.44,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M52,34h0a4.76,4.76,0,0,1,.39-1.88h0A4.78,4.78,0,0,0,52,34V34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M52.36,32.13c.19-.55.43-1.13.71-1.74a18.26,18.26,0,0,1,1.74-.71,4.71,4.71,0,0,0-1.94,1.56,4.89,4.89,0,0,0-.51.89m0,3.77A4.76,4.76,0,0,1,52,34v.06a4.78,4.78,0,0,0,.39,1.82h0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "56.69 29.29 56.69 29.29 56.69 29.29 56.69 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M56.69,38.74a6.07,6.07,0,0,0,1.89-.39,4.7,4.7,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M52.67,36.49a4.75,4.75,0,0,1-.31-.59h0a4.75,4.75,0,0,0,.31.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M52,34.08v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M52.36,32.13h0a4.89,4.89,0,0,1,.51-.89,5.25,5.25,0,0,0-.51.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M58.57,29.68a6,6,0,0,0-1.88-.39,4.68,4.68,0,0,1,1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M12.22,22.71c-.25,0-.5,0-.76,0l.76,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M12.22,22.71q-.32,0-.63,0h-.13c.26,0,.51,0,.76,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M11.59,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M10.46,22.71v-.07l.76,0c-.26,0-.51,0-.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M10.46,22.71h0c.25,0,.5,0,.76,0h0c-.26,0-.51,0-.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M10.46,22.71h0c.26,0,.51,0,.77,0h0c-.26,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M7,32.13c1-2.83,3.43-6.62,3.45-9.42.26,0,.53,0,.79,0h.34c.21,0,.42,0,.63,0,0,2.27,1.61,5.17,2.74,7.68-.61-.28-1.19-.52-1.74-.71A4.72,4.72,0,0,0,7,32.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M11.34,22.68h-.12l-.76,0c0-2.8-2.48-6.59-3.45-9.41a4.72,4.72,0,0,0,4.33,2.83A9.92,9.92,0,0,0,15,15c-1.13,2.51-2.73,5.41-2.74,7.68l-.76,0h-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M13.22,7a6,6,0,0,0-1.8-.38,4.71,4.71,0,0,1,1.8.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M22.64,12.22c0-.27,0-.53,0-.79,0,.26,0,.52,0,.79h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M22.71,12.22h0c0-.27,0-.53,0-.79v0c0,.27,0,.54,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M22.68,11.25c0-.26,0-.53,0-.79h.07c0,.26,0,.53,0,.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M22.68,11.28v0c0-.26,0-.53,0-.79,0,.27,0,.55,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M15,15a10,10,0,0,0,1.1-3.62A4.74,4.74,0,0,0,13.22,7c2.82,1,6.62,3.44,9.42,3.46,0,.26,0,.53,0,.79v.18c0,.26,0,.52,0,.79-2.27,0-5.17,1.61-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M30.39,15c-2.51-1.13-5.41-2.73-7.68-2.74,0-.27,0-.55,0-.82v-.12c0-.27,0-.55,0-.82,2.8,0,6.6-2.48,9.42-3.46a4.73,4.73,0,0,0-2.45,6.22c.19.55.43,1.13.71,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M7,13.23a4.8,4.8,0,0,1-.4-1.86v-.06a4.74,4.74,0,0,1,4.68-4.7h.05a4.72,4.72,0,0,0-4.73,4.72A5.83,5.83,0,0,0,7,13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M35.76,7a4.65,4.65,0,0,0-1.67-.34h0A4.71,4.71,0,0,1,35.76,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M11.34,16.06A4.72,4.72,0,0,1,7,13.23a5.79,5.79,0,0,1-.39-1.89,4.72,4.72,0,0,1,4.72-4.73h.08a6,6,0,0,1,1.8.38,4.74,4.74,0,0,1,2.84,4.34A10,10,0,0,1,15,15a9.92,9.92,0,0,1-3.62,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M34,61.42h0a4.61,4.61,0,0,0,1.89-.4h0a4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M34.89,45.39l-.79,0c.27,0,.53,0,.79,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M33.14,45.39v-.07c.26,0,.52,0,.79,0l-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M34.1,45.35h-.17c-.27,0-.53,0-.79,0,0-2.26-1.62-5.16-2.75-7.68.6.27,1.19.51,1.73.7a4.62,4.62,0,0,0,1.9.4h0a4.61,4.61,0,0,0,1.89-.4c.55-.19,1.13-.43,1.73-.7-1.13,2.51-2.73,5.4-2.75,7.68-.26,0-.52,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M30.39,53.07c1.13-2.52,2.73-5.43,2.75-7.68.26,0,.52,0,.79,0h.17c.27,0,.53,0,.79,0,0,2.27,1.62,5.16,2.75,7.67-.61-.27-1.2-.52-1.75-.7A4.67,4.67,0,0,0,34,52h0a4.68,4.68,0,0,0-1.88.39,18.4,18.4,0,0,0-1.75.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-105",
    x1: 34.02,
    y1: 38.74,
    x2: 34.02,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M34,38.74a4.77,4.77,0,0,1-1.89-.39h0a4.68,4.68,0,0,0,1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M35.91,38.34a4.65,4.65,0,0,0,2.43-2.43,17.94,17.94,0,0,1-.7,1.73c-.6.27-1.18.51-1.73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M38.74,34v-.13a4.87,4.87,0,0,0-.39-1.76h0a4.78,4.78,0,0,1,.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M34,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M11.34,61.42a4.73,4.73,0,0,1-4.73-4.7v-.06A4.8,4.8,0,0,1,7,54.8a6.07,6.07,0,0,0-.39,1.89,4.72,4.72,0,0,0,4.72,4.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M22.64,57.57c0-.27,0-.54,0-.82,0,.28,0,.55,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M22.64,57.57c0-.27,0-.55,0-.82,0,.28,0,.55,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M22.68,56.63a7.5,7.5,0,0,0,0-.82h.07c0,.27,0,.55,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M13.23,61a4.72,4.72,0,0,0,2.83-4.33A10,10,0,0,0,15,53.06c2.52,1.13,5.42,2.74,7.68,2.75,0,.27,0,.55,0,.82v.12c0,.27,0,.55,0,.82-2.82,0-6.59,2.47-9.41,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M32.12,61c-2.81-1-6.59-3.43-9.41-3.45,0-.27,0-.54,0-.82v-.12c0-.27,0-.55,0-.82,2.26,0,5.16-1.61,7.68-2.74-.27.6-.52,1.19-.71,1.74a4.7,4.7,0,0,0,.39,4.47h0a4.73,4.73,0,0,0,2,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M34,61.42a5.83,5.83,0,0,0,1.89-.4,4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-110",
    points: "30.07 59.29 30.07 59.28 30.07 59.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M29.68,54.81c.19-.55.44-1.14.71-1.75.61-.27,1.19-.51,1.75-.7a4.71,4.71,0,0,0-2.46,2.45m.38,4.47a4.75,4.75,0,0,1-.77-2.59,4.75,4.75,0,0,0,.77,2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M35.89,52.36A6,6,0,0,0,34,52a4.67,4.67,0,0,1,1.87.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "34.01 51.97 34.01 51.97 34.02 51.97 34.01 51.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M106.37,35.91h0a4.81,4.81,0,0,0,.39-1.78V34h0a4.61,4.61,0,0,1-.4,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M102.92,22.71c-.21,0-.41,0-.62,0h-.15l.77,0v.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M102.3,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M101.17,22.71v-.06c.26,0,.52,0,.79,0-.27,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M102.13,22.68H102c-.27,0-.53,0-.79,0,0-2.26-1.62-5.16-2.75-7.68.6.27,1.19.52,1.73.71a4.77,4.77,0,0,0,1.89.39h0a4.68,4.68,0,0,0,1.88-.39c.55-.19,1.13-.44,1.74-.71-1.13,2.51-2.73,5.41-2.75,7.68-.25,0-.51,0-.77,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M98.42,30.39c1.13-2.52,2.73-5.42,2.75-7.68.26,0,.52,0,.79,0h.34c.21,0,.42,0,.62,0,0,2.28,1.61,5.17,2.75,7.68-.61-.27-1.19-.52-1.74-.71a4.72,4.72,0,0,0-1.88-.39h0a4.76,4.76,0,0,0-1.88.39c-.54.19-1.13.44-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M103.92,7h0l-.14-.06.14.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M103.77,6.94h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M106.37,32.12a4.73,4.73,0,0,0-2.44-2.44c.55.19,1.13.43,1.74.71.27.6.51,1.19.7,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M100.16,29.68a4.76,4.76,0,0,1,1.88-.39h0a4.67,4.67,0,0,0-1.87.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M102,29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M102.05,61.42h0a4.53,4.53,0,0,0,1.88-.4h0a4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M101.17,45.39v-.07c.26,0,.52,0,.79,0l-.79,0m1.75,0-.79,0c.27,0,.53,0,.79,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M102.13,45.35H102c-.27,0-.53,0-.79,0,0-2.26-1.62-5.16-2.75-7.68.6.27,1.19.51,1.73.7a4.61,4.61,0,0,0,1.89.4h0a4.61,4.61,0,0,0,1.89-.4c.54-.19,1.13-.43,1.73-.7-1.13,2.51-2.73,5.4-2.75,7.68-.26,0-.52,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M98.42,53.07c1.13-2.52,2.73-5.43,2.75-7.68.26,0,.52,0,.79,0h.17c.27,0,.53,0,.79,0,0,2.27,1.62,5.16,2.75,7.67-.61-.27-1.2-.52-1.75-.7a4.67,4.67,0,0,0-1.87-.39h0a4.67,4.67,0,0,0-1.87.39,18.4,18.4,0,0,0-1.75.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-119",
    x1: 102.04,
    y1: 38.74,
    x2: 102.04,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M102,38.74a4.77,4.77,0,0,1-1.89-.39h0a4.68,4.68,0,0,0,1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M103.94,38.34a4.69,4.69,0,0,0,2.43-2.43c-.19.54-.43,1.13-.7,1.73-.61.27-1.19.51-1.73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M106.77,34v-.11a5,5,0,0,0-.39-1.78h0a4.78,4.78,0,0,1,.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M102.05,38.74h0a4.68,4.68,0,0,0,1.88-.39h0a4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-121",
    x1: 102.04,
    y1: 38.74,
    x2: 102.04,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M102,38.74a4.68,4.68,0,0,1-1.88-.39,6,6,0,0,0,1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M103.93,38.35a4.76,4.76,0,0,0,2.45-2.45h0a4.65,4.65,0,0,1-2.43,2.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M106.77,34.12v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M103.93,29.68h0a4.67,4.67,0,0,0-1.87-.39,4.76,4.76,0,0,1,1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M106.38,32.13a4.75,4.75,0,0,0-2.46-2.45h0a4.78,4.78,0,0,1,2.45,2.44h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M100.17,29.68a4.67,4.67,0,0,1,1.87-.39,6,6,0,0,0-1.87.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M102.05,29.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-122",
    x1: 56.69,
    y1: 16.06,
    x2: 56.69,
    y2: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M56.69,16.06a6.07,6.07,0,0,0,1.89-.39,4.73,4.73,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M45.35,11.28c0-.27,0-.55,0-.82h.07c0,.27,0,.55,0,.82m0,.94c0-.28,0-.55,0-.82,0,.27,0,.54,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M37.64,15c.27-.61.52-1.19.71-1.74a4.86,4.86,0,0,0,.39-1.75v-.13A4.74,4.74,0,0,0,35.9,7c2.82,1,6.62,3.44,9.42,3.46,0,.27,0,.55,0,.82v.12c0,.27,0,.54,0,.82-2.27,0-5.17,1.61-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M53.06,15c-2.51-1.13-5.4-2.73-7.67-2.74,0-.27,0-.55,0-.82v-.12c0-.27,0-.55,0-.82C48.19,10.44,52,8,54.81,7a4.78,4.78,0,0,0-2.39,2.32,4.71,4.71,0,0,0-.45,2v.07a4.77,4.77,0,0,0,.39,1.81c.19.55.43,1.13.7,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M54.8,15.67c-.55-.19-1.13-.44-1.74-.71-.27-.61-.51-1.19-.7-1.74a4.75,4.75,0,0,0,2.44,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M52,11.41v-.07a4.71,4.71,0,0,1,.45-2,4.71,4.71,0,0,0-.45,2v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M29.68,13.22a4.72,4.72,0,0,1-.39-1.88,6,6,0,0,0,.39,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M38.35,13.22a6.34,6.34,0,0,0,.39-1.75,4.86,4.86,0,0,1-.39,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M32.13,7A4.87,4.87,0,0,1,34,6.61h0A4.87,4.87,0,0,0,32.14,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M29.29,11.34h0A4.73,4.73,0,0,1,32.14,7h0a4.73,4.73,0,0,0-2.85,4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M33.93,6.62h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M58.54,7a4.91,4.91,0,0,0-1.77-.38h0a4.87,4.87,0,0,1,1.8.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M58.57,7a6.73,6.73,0,0,0-1.8-.39A4.91,4.91,0,0,1,58.54,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M79.37,61.42h0a4.61,4.61,0,0,0,1.89-.4h0a4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M78.49,45.39v-.07c.26,0,.53,0,.79,0l-.79,0m1.76,0-.79,0,.79,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M79.46,45.35h-.18c-.26,0-.53,0-.79,0,0-2.26-1.62-5.16-2.75-7.68.61.27,1.19.51,1.74.7a4.57,4.57,0,0,0,1.89.4h0a4.61,4.61,0,0,0,1.89-.4c.55-.19,1.13-.43,1.73-.7-1.13,2.51-2.73,5.4-2.74,7.68l-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M75.74,53.07c1.13-2.52,2.74-5.43,2.75-7.68.26,0,.53,0,.79,0h.18c.26,0,.52,0,.79,0,0,2.27,1.61,5.16,2.74,7.67-.61-.27-1.19-.51-1.74-.7A4.72,4.72,0,0,0,79.37,52h0a4.68,4.68,0,0,0-1.88.39c-.55.19-1.14.43-1.75.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M80.25,22.71l-.77,0,.77,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M80.25,22.71q-.31,0-.63,0h-.14l.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M79.52,22.68h0m.06,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M79.62,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M78.49,22.71v-.07l.77,0c-.26,0-.52,0-.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M78.49,22.71h0c.25,0,.51,0,.77,0h0c-.26,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M79.46,22.68h-.2c-.26,0-.51,0-.77,0,0-2.26-1.62-5.16-2.75-7.68.61.27,1.19.52,1.74.71a4.77,4.77,0,0,0,1.89.39h0a4.77,4.77,0,0,0,1.89-.39c.55-.19,1.13-.44,1.73-.71-1.13,2.51-2.73,5.41-2.74,7.68-.26,0-.51,0-.77,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M75.74,30.39c1.13-2.52,2.74-5.42,2.75-7.68.26,0,.53,0,.79,0h.34q.31,0,.63,0c0,2.28,1.61,5.17,2.74,7.68-.61-.27-1.19-.52-1.74-.71a4.68,4.68,0,0,0-1.88-.39h0a4.68,4.68,0,0,0-1.88.39c-.55.19-1.14.44-1.75.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M81.25,7h0l-.06,0,.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M81.25,29.68h0a4.72,4.72,0,0,0-1.88-.39,4.68,4.68,0,0,1,1.88.39m-1.88,9.06h0a4.77,4.77,0,0,0,1.89-.39h0a4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M38.35,35.91h0a4.87,4.87,0,0,0,.39-1.76V34a4.78,4.78,0,0,1-.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M34,38.74h0a4.77,4.77,0,0,0,1.89-.39h0a4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-138",
    x1: 34.02,
    y1: 38.74,
    x2: 34.02,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M34,38.74a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M35.91,38.35a4.78,4.78,0,0,0,2.44-2.45h0a4.65,4.65,0,0,1-2.43,2.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M38.74,34.14v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M34.89,22.71c-.25,0-.51,0-.77,0l.77,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M34.89,22.71c-.2,0-.41,0-.62,0h-.15c.26,0,.52,0,.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M34.27,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M33.14,22.71v-.07l.77,0c-.26,0-.52,0-.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M33.14,22.71h0c.25,0,.51,0,.77,0h0c-.27,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M34.1,22.68h-.19c-.26,0-.52,0-.77,0,0-2.26-1.62-5.16-2.75-7.68.6.27,1.19.52,1.73.71a4.78,4.78,0,0,0,1.9.39h0a4.77,4.77,0,0,0,1.89-.39c.54-.19,1.13-.44,1.73-.71-1.13,2.51-2.73,5.41-2.75,7.68-.25,0-.51,0-.77,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M30.39,30.39c1.13-2.52,2.73-5.42,2.75-7.68.26,0,.52,0,.79,0h.34c.21,0,.42,0,.62,0,0,2.28,1.62,5.17,2.75,7.68-.61-.27-1.19-.52-1.74-.71A4.72,4.72,0,0,0,34,29.29h0a4.76,4.76,0,0,0-1.88.39c-.54.19-1.13.44-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M38.35,32.12a4.78,4.78,0,0,0-2.45-2.44c.55.19,1.13.43,1.74.71.27.6.52,1.18.71,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M32.13,29.68A4.76,4.76,0,0,1,34,29.29a4.67,4.67,0,0,0-1.87.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M34,29.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-145",
    x1: 34.01,
    y1: 16.06,
    x2: 34.02,
    y2: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M34,16.06a6.07,6.07,0,0,0,1.89-.39,4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M32.12,15.67c-.54-.19-1.13-.44-1.73-.71-.27-.61-.52-1.19-.71-1.74a4.78,4.78,0,0,0,2.44,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M35.9,29.68h0A4.67,4.67,0,0,0,34,29.29a4.72,4.72,0,0,1,1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M38.35,32.13a4.8,4.8,0,0,0-2.45-2.45h0a4.78,4.78,0,0,1,2.45,2.44h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M32.14,29.68A4.67,4.67,0,0,1,34,29.29a6,6,0,0,0-1.87.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-138",
    x1: 34.02,
    y1: 29.29,
    x2: 34.01,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M29.29,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M35.9,7h0l-.14,0,.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M35.89,7a6.38,6.38,0,0,0-1.79-.39A4.64,4.64,0,0,1,35.76,7l.13,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-146",
    x1: 34.02,
    y1: 16.06,
    x2: 34.02,
    y2: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M34,16.06a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M35.91,15.67a4.78,4.78,0,0,0,2.44-2.45c-.19.55-.44,1.13-.71,1.74-.6.27-1.19.52-1.73.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M38.74,11.47v-.13A4.74,4.74,0,0,0,35.9,7h0a4.74,4.74,0,0,1,2.84,4.34v.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M32.14,7a4.66,4.66,0,0,1,1.79-.38A6.26,6.26,0,0,0,32.14,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M34,16.06h0a6.07,6.07,0,0,1-1.89-.39,4.78,4.78,0,0,1-2.44-2.45,6,6,0,0,1-.39-1.88A4.73,4.73,0,0,1,32.14,7a5.94,5.94,0,0,1,1.79-.38h.16a6,6,0,0,1,1.8.38,4.73,4.73,0,0,1,2.85,4.34v.13a6.34,6.34,0,0,1-.39,1.75,4.78,4.78,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-148",
    x1: 79.37,
    y1: 38.74,
    x2: 79.37,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M68,33.93v-.17l0-.62h.06c0,.26,0,.52,0,.79m0,1c0-.27,0-.54,0-.82,0,.28,0,.55,0,.82H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M68,33.93h0c0-.27,0-.53,0-.79,0,.26,0,.52,0,.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M68,34v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M75.74,37.64c-2.51-1.13-5.4-2.73-7.68-2.75,0-.27,0-.54,0-.82v-.14c0-.27,0-.53,0-.79,2.26,0,5.16-1.62,7.68-2.75-.27.61-.52,1.19-.71,1.74a4.3,4.3,0,0,0-.2.57A4.76,4.76,0,0,0,74.65,34h0A4.59,4.59,0,0,0,75,35.9c.18.55.43,1.13.7,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M60.32,37.64c.27-.6.51-1.18.7-1.73a4.69,4.69,0,0,0,0-3.79c-.19-.54-.43-1.13-.71-1.73,2.52,1.13,5.43,2.73,7.69,2.75l0,.62v.31c0,.28,0,.55,0,.82-2.28,0-5.17,1.62-7.68,2.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-154",
    x1: 56.69,
    y1: 38.74,
    x2: 56.69,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M56.69,38.74a4.77,4.77,0,0,1-1.89-.39h0a4.77,4.77,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M58.59,38.34A4.72,4.72,0,0,0,61,35.91c-.19.55-.43,1.13-.7,1.73-.61.27-1.19.52-1.73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M61.42,34a.31.31,0,0,0,0-.1A4.63,4.63,0,0,0,61,32.13h0a4.62,4.62,0,0,1,.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M61,32.12a4.76,4.76,0,0,0-2.44-2.44c.54.19,1.13.44,1.73.71A18.13,18.13,0,0,1,61,32.12m0,3.79h0a4.83,4.83,0,0,0,.4-1.79V34a4.62,4.62,0,0,1-.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M54.81,29.68a4.72,4.72,0,0,1,1.88-.39,4.72,4.72,0,0,0-1.88.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M56.69,29.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-156",
    x1: 56.69,
    y1: 38.74,
    x2: 56.69,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M56.69,38.74a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M58.58,38.35A4.75,4.75,0,0,0,61,35.9h0a4.69,4.69,0,0,1-2.43,2.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M61.42,34.11v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M61,32.13a4.66,4.66,0,0,0-2.45-2.45h0A4.75,4.75,0,0,1,61,32.12h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M54.81,29.68a4.72,4.72,0,0,1,1.88-.39,6,6,0,0,0-1.88.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-156",
    x1: 56.69,
    y1: 29.29,
    x2: 56.69,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-157",
    x1: 56.69,
    y1: 38.74,
    x2: 56.69,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M52,34a4.78,4.78,0,0,1,.39-1.82A6.15,6.15,0,0,0,52,34m2.83,4.4h0a4.7,4.7,0,0,1-2.13-1.86,4.75,4.75,0,0,0,2.13,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M61.42,33.92a6.28,6.28,0,0,0-.4-1.79,4.83,4.83,0,0,1,.4,1.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M61,35.9a5.92,5.92,0,0,0,.39-1.79A4.63,4.63,0,0,1,61,35.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M52.87,31.24a4.71,4.71,0,0,1,1.94-1.56h0a4.71,4.71,0,0,0-1.94,1.56m-.51,4.66A4.78,4.78,0,0,1,52,34.08a6.15,6.15,0,0,0,.39,1.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "56.69 29.29 56.69 29.29 56.69 29.29 56.69 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M56.69,38.74h0a6.07,6.07,0,0,1-1.89-.39,4.7,4.7,0,0,1-2.13-1.86,4.75,4.75,0,0,1-.31-.59A6.15,6.15,0,0,1,52,34.08V34a6,6,0,0,1,.39-1.81,4.66,4.66,0,0,1,.51-.9,4.71,4.71,0,0,1,1.94-1.56,6,6,0,0,1,1.88-.39h0a6,6,0,0,1,1.88.39A4.66,4.66,0,0,1,61,32.13a6.37,6.37,0,0,1,.4,1.78v.2A6.28,6.28,0,0,1,61,35.9a4.75,4.75,0,0,1-2.44,2.45,6,6,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M77.48,38.35c-.55-.19-1.13-.44-1.74-.71-.27-.61-.52-1.19-.71-1.74a4.8,4.8,0,0,0,2.45,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M74.64,34h0a4.77,4.77,0,0,1,.19-1.31A4.77,4.77,0,0,0,74.64,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M75,32.13c.19-.55.44-1.13.71-1.74.61-.28,1.2-.52,1.75-.71A4.78,4.78,0,0,0,75,32.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M81.25,29.68a6,6,0,0,0-1.88-.39,4.72,4.72,0,0,1,1.88.39m-1.88,9.06a6.07,6.07,0,0,0,1.89-.39,4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "79.37 29.29 79.37 29.29 79.37 29.29 79.37 29.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-162",
    x1: 56.69,
    y1: 16.06,
    x2: 56.69,
    y2: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M56.69,16.06a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M68,11.28c0-.27,0-.55,0-.82h.06c0,.27,0,.55,0,.82m0,.94c0-.28,0-.55,0-.82,0,.27,0,.54,0,.82H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M60.32,15c.27-.6.52-1.19.71-1.74a4.81,4.81,0,0,0,.38-1.78.34.34,0,0,0,0-.1A4.73,4.73,0,0,0,58.57,7c2.82,1,6.62,3.44,9.43,3.46,0,.27,0,.55,0,.82v.12c0,.27,0,.54,0,.82-2.28,0-5.17,1.61-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M75.74,15c-2.51-1.13-5.4-2.73-7.68-2.74,0-.27,0-.55,0-.82v-.12c0-.27,0-.55,0-.82,2.81,0,6.6-2.48,9.43-3.46A4.73,4.73,0,0,0,75,13.22c.19.55.44,1.13.71,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M58.58,15.67A4.71,4.71,0,0,0,61,13.22c-.18.55-.43,1.13-.7,1.74-.61.27-1.19.52-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M61.42,11.44v-.1A4.73,4.73,0,0,0,58.57,7a4.73,4.73,0,0,1,2.85,4.34v.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M54.81,7a4.83,4.83,0,0,1,1.83-.39h0A4.82,4.82,0,0,0,54.82,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M54.82,7a4.82,4.82,0,0,1,1.79-.39A6.59,6.59,0,0,0,54.82,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M81.19,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M81.18,7a4.72,4.72,0,0,0-1.73-.35h0A4.89,4.89,0,0,1,81.18,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M61,13.22a6.53,6.53,0,0,0,.39-1.78A5,5,0,0,1,61,13.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M52.42,9.32A4.78,4.78,0,0,1,54.81,7h0a4.72,4.72,0,0,0-2.4,2.32m-.06,3.9A4.77,4.77,0,0,1,52,11.41a6.16,6.16,0,0,0,.39,1.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M56.61,6.62h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M56.69,16.06h0a6.07,6.07,0,0,1-1.89-.39,4.75,4.75,0,0,1-2.44-2.45A6.16,6.16,0,0,1,52,11.41v-.07A4.71,4.71,0,0,1,54.82,7a5.94,5.94,0,0,1,1.79-.38h.16a6,6,0,0,1,1.8.38,4.73,4.73,0,0,1,2.85,4.34v.1a6.22,6.22,0,0,1-.4,1.78,4.75,4.75,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-168",
    x1: 79.37,
    y1: 16.06,
    x2: 79.37,
    y2: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M79.37,16.06a6.07,6.07,0,0,0,1.89-.39,4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M77.48,15.67c-.55-.19-1.13-.44-1.74-.71-.27-.61-.52-1.19-.71-1.74a4.76,4.76,0,0,0,2.45,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M74.64,11.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M81.25,7a6.73,6.73,0,0,0-1.8-.39A4.54,4.54,0,0,1,81.18,7h0l.06,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-169",
    x1: 34.01,
    y1: 38.74,
    x2: 34.02,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-170",
    x1: 34.02,
    y1: 38.74,
    x2: 34.01,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M22.64,34.89c0-.26,0-.52,0-.79,0,.27,0,.53,0,.79h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M22.71,34.89h0c0-.26,0-.52,0-.79v0c0,.28,0,.55,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M22.68,33.93c0-.27,0-.53,0-.79h.07c0,.26,0,.52,0,.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M22.68,34v0c0-.27,0-.53,0-.79,0,.27,0,.54,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M15,37.64c.27-.6.52-1.19.71-1.73a4.8,4.8,0,0,0,0-3.79c-.19-.54-.44-1.13-.71-1.73,2.52,1.13,5.42,2.73,7.68,2.75,0,.26,0,.52,0,.79v.17c0,.27,0,.53,0,.79-2.27,0-5.17,1.62-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M30.39,37.64c-2.51-1.13-5.41-2.73-7.68-2.75,0-.27,0-.54,0-.82V34c0-.28,0-.55,0-.82,2.26,0,5.16-1.62,7.68-2.75-.27.61-.52,1.19-.71,1.74a4.94,4.94,0,0,0-.23.68h0a4.82,4.82,0,0,0-.16,1.2h0a4.72,4.72,0,0,0,.39,1.88c.19.55.44,1.13.71,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M7,35.91A4.67,4.67,0,0,1,6.62,34V34A4.58,4.58,0,0,1,7,32.13H7A4.75,4.75,0,0,0,6.62,34,4.6,4.6,0,0,0,7,35.9H7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M29.68,35.9A4.77,4.77,0,0,1,29.29,34a4.77,4.77,0,0,0,.39,1.89h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M29.45,32.81a4.94,4.94,0,0,1,.23-.68h0a4.94,4.94,0,0,0-.23.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M15.67,35.91a6.07,6.07,0,0,0,.39-1.9h0a4.77,4.77,0,0,1-.39,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M7,32.13H7a4.72,4.72,0,0,1,4.33-2.84A4.71,4.71,0,0,0,7,32.13M7,35.9A4.61,4.61,0,0,1,6.61,34,6.11,6.11,0,0,0,7,35.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M15.67,32.12a4.75,4.75,0,0,0-2.45-2.44c.55.19,1.13.43,1.74.71.27.6.52,1.19.71,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M32.12,38.35c-.54-.2-1.13-.44-1.73-.71-.27-.61-.52-1.19-.71-1.74a4.78,4.78,0,0,0,2.44,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M29.29,34h0a4.34,4.34,0,0,1,.16-1.2,4.34,4.34,0,0,0-.16,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M29.45,32.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M32.13,38.35h0a4.78,4.78,0,0,1-2.44-2.45h0a4.76,4.76,0,0,0,2.45,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M29.29,34h0a4.34,4.34,0,0,1,.16-1.2h0a4.94,4.94,0,0,1,.23-.68A6.07,6.07,0,0,0,29.29,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M38.74,33.89a6.4,6.4,0,0,0-.39-1.76,4.67,4.67,0,0,1,.39,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M29.68,32.13c.19-.55.44-1.13.71-1.74.61-.28,1.2-.52,1.75-.71a4.78,4.78,0,0,0-2.46,2.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "34.01 29.29 34.01 29.29 34.02 29.29 34.01 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M38.35,35.9a6.4,6.4,0,0,0,.39-1.76,4.87,4.87,0,0,1-.39,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M29.68,32.13h0a4.78,4.78,0,0,1,2.46-2.45h0a4.78,4.78,0,0,0-2.46,2.45m0,3.77A4.72,4.72,0,0,1,29.29,34a6.07,6.07,0,0,0,.39,1.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "34.01 29.29 34.01 29.29 34.02 29.29 34.01 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M35.9,29.68A6.07,6.07,0,0,0,34,29.29a4.76,4.76,0,0,1,1.88.39M34,38.74a6.07,6.07,0,0,0,1.89-.39,4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M34,38.74h0a6.07,6.07,0,0,1-1.89-.39,4.78,4.78,0,0,1-2.44-2.45A6.07,6.07,0,0,1,29.29,34a6.07,6.07,0,0,1,.39-1.88,4.75,4.75,0,0,1,2.46-2.45A6,6,0,0,1,34,29.29h0a6,6,0,0,1,1.87.39,4.71,4.71,0,0,1,2.46,2.45,6.48,6.48,0,0,1,.39,1.76v.25a6.4,6.4,0,0,1-.39,1.76,4.78,4.78,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M90.71,33.93a.91.91,0,0,1,0-.17c0-.21,0-.42,0-.62h.07c0,.26,0,.52,0,.79m0,1c0-.27,0-.54,0-.82,0,.28,0,.55,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M90.71,34c0-.07,0-.13,0-.2s0,.12,0,.17v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M98.42,37.64c-2.51-1.13-5.41-2.73-7.68-2.75,0-.27,0-.54,0-.82v-.14c0-.27,0-.53,0-.79,2.26,0,5.16-1.62,7.68-2.75-.27.61-.52,1.19-.71,1.74A4.73,4.73,0,0,0,97.32,34a4.68,4.68,0,0,0,.39,1.88c.19.55.44,1.13.71,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M83,37.64c.27-.6.52-1.18.71-1.73a4.8,4.8,0,0,0,0-3.79c-.19-.54-.44-1.13-.71-1.73,2.52,1.13,5.42,2.73,7.68,2.75,0,.2,0,.41,0,.62s0,.13,0,.2v.11c0,.28,0,.55,0,.82-2.27,0-5.17,1.62-7.68,2.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M97.71,35.91a4.78,4.78,0,0,1-.39-1.9,4.68,4.68,0,0,1,.39-1.88h0a4.75,4.75,0,0,0,0,3.77h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M106.38,35.9a6.53,6.53,0,0,0,.39-1.78,5,5,0,0,1-.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M97.71,35.9A4.77,4.77,0,0,1,97.32,34a6.07,6.07,0,0,0,.39,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M97.71,32.13c.19-.55.44-1.14.71-1.74.61-.28,1.2-.52,1.75-.71a4.71,4.71,0,0,0-2.46,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M97.71,32.13h0a4.76,4.76,0,0,1,2.45-2.45h0a4.78,4.78,0,0,0-2.46,2.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-186",
    x1: 102.04,
    y1: 29.29,
    x2: 102.04,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "102.04 29.29 102.04 29.29 102.04 29.29 102.04 29.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-187",
    points: "102.04 38.74 102.04 38.74 102.04 38.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-188",
    x1: 102.04,
    y1: 38.74,
    x2: 102.04,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M100.15,38.35c-.54-.19-1.13-.44-1.73-.71-.27-.61-.52-1.19-.71-1.73a4.8,4.8,0,0,0,2.44,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M100.16,38.35h0a4.73,4.73,0,0,1-2.44-2.44h0a4.76,4.76,0,0,0,2.45,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M97.32,34h0a4.76,4.76,0,0,1,.39-1.88A6.07,6.07,0,0,0,97.32,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M106.77,33.91a6.53,6.53,0,0,0-.39-1.78,5,5,0,0,1,.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M102.05,38.74a6,6,0,0,0,1.88-.39,4.68,4.68,0,0,1-1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M103.92,29.68a6,6,0,0,0-1.87-.39,4.67,4.67,0,0,1,1.87.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M102,38.74h0a6,6,0,0,1-1.88-.39,4.76,4.76,0,0,1-2.45-2.45A6.07,6.07,0,0,1,97.32,34a6.07,6.07,0,0,1,.39-1.88,4.71,4.71,0,0,1,2.46-2.45,6,6,0,0,1,1.87-.39h0a6,6,0,0,1,1.88.39,4.71,4.71,0,0,1,2.46,2.45,6.53,6.53,0,0,1,.39,1.78v.21a6.53,6.53,0,0,1-.39,1.78,4.76,4.76,0,0,1-2.45,2.45,6,6,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M81.26,38.34a4.71,4.71,0,0,0,2.44-2.43c-.19.55-.44,1.13-.71,1.73-.6.27-1.18.51-1.73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M84.09,34v-.11a4.62,4.62,0,0,0-.39-1.78h0a4.78,4.78,0,0,1,.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M83.7,32.12a4.78,4.78,0,0,0-2.45-2.44c.55.19,1.13.44,1.74.71.27.6.52,1.18.71,1.73m0,3.79h0a4.62,4.62,0,0,0,.39-1.78V34a4.78,4.78,0,0,1-.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M81.26,38.35A4.75,4.75,0,0,0,83.7,35.9h0a4.71,4.71,0,0,1-2.44,2.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M84.09,34.12v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M83.7,32.13a4.76,4.76,0,0,0-2.45-2.45h0a4.78,4.78,0,0,1,2.45,2.44h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-191",
    x1: 79.37,
    y1: 38.74,
    x2: 79.37,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-193",
    x1: 79.37,
    y1: 38.74,
    x2: 79.37,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M79.37,38.74a4.73,4.73,0,0,1-1.89-.39h0a4.77,4.77,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M79.37,38.74a4.73,4.73,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M77.49,29.68a4.68,4.68,0,0,1,1.88-.39,4.68,4.68,0,0,0-1.88.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M77.49,29.68a4.68,4.68,0,0,1,1.88-.39,6,6,0,0,0-1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M79.37,29.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-193",
    x1: 79.37,
    y1: 29.29,
    x2: 79.37,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M74.64,34h0M75,35.9a4.61,4.61,0,0,1-.4-1.89A4.61,4.61,0,0,0,75,35.9h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M74.83,32.7a4.3,4.3,0,0,1,.2-.57,4.3,4.3,0,0,0-.2.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-195",
    x1: 79.37,
    y1: 38.74,
    x2: 79.37,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M77.48,38.35h0A4.75,4.75,0,0,1,75,35.9h0a4.8,4.8,0,0,0,2.45,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M74.64,34h0a4.77,4.77,0,0,1,.19-1.31,4.3,4.3,0,0,1,.2-.57A6.07,6.07,0,0,0,74.64,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M84.09,33.91a6.17,6.17,0,0,0-.39-1.78,4.62,4.62,0,0,1,.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M83.7,35.9a6.17,6.17,0,0,0,.39-1.78,4.58,4.58,0,0,1-.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M75,32.13h0a4.78,4.78,0,0,1,2.46-2.45h0A4.78,4.78,0,0,0,75,32.13m0,3.77A4.77,4.77,0,0,1,74.64,34,6.07,6.07,0,0,0,75,35.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "79.37 29.29 79.37 29.29 79.37 29.29 79.37 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M79.37,38.74h0a6.07,6.07,0,0,1-1.89-.39A4.75,4.75,0,0,1,75,35.9,5.79,5.79,0,0,1,74.65,34,6,6,0,0,1,75,32.13a4.75,4.75,0,0,1,2.46-2.45,6,6,0,0,1,1.88-.39h0a6,6,0,0,1,1.88.39,4.73,4.73,0,0,1,2.45,2.45,6.17,6.17,0,0,1,.39,1.78v.21a6.17,6.17,0,0,1-.39,1.78,4.75,4.75,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-197",
    points: "102.04 16.06 102.04 16.06 102.04 16.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M90.71,11.28c0-.27,0-.55,0-.82h.07c0,.27,0,.55,0,.82m0,.94c0-.28,0-.55,0-.82,0,.27,0,.54,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M83,15a18.26,18.26,0,0,0,.71-1.74,4.53,4.53,0,0,0,.39-1.77v-.11A4.74,4.74,0,0,0,81.25,7c2.82,1,6.62,3.44,9.42,3.46,0,.27,0,.55,0,.82v.12c0,.27,0,.54,0,.82C88.4,12.23,85.5,13.83,83,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M98.42,15c-2.51-1.13-5.41-2.73-7.68-2.74,0-.27,0-.55,0-.82v-.12c0-.27,0-.55,0-.82,2.8,0,6.6-2.48,9.42-3.46a4.75,4.75,0,0,0-2.45,6.23c.19.54.44,1.13.71,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M77.49,7a4.83,4.83,0,0,1,1.83-.39h0a4.87,4.87,0,0,0-1.8.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M100.15,15.67c-.54-.19-1.13-.44-1.73-.71-.27-.61-.52-1.19-.71-1.73a4.76,4.76,0,0,0,2.44,2.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-201",
    points: "79.37 16.06 79.37 16.06 79.37 16.06 79.37 16.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M79.37,16.06a4.73,4.73,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M81.26,15.67a4.71,4.71,0,0,0,2.44-2.45c-.19.55-.43,1.13-.71,1.74-.6.27-1.18.52-1.73.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M84.09,11.45v-.11A4.74,4.74,0,0,0,81.25,7h0a4.74,4.74,0,0,1,2.84,4.34v.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M77.49,7a4.87,4.87,0,0,1,1.79-.39A6.75,6.75,0,0,0,77.49,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M75,13.22a4.71,4.71,0,0,1-.38-1.88A6,6,0,0,0,75,13.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M74.64,11.34h0A4.73,4.73,0,0,1,77.49,7h0a4.75,4.75,0,0,0-2.85,4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M79.29,6.61h0m4.41,6.61a6.17,6.17,0,0,0,.39-1.78,4.54,4.54,0,0,1-.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M79.37,16.06h0a6.07,6.07,0,0,1-1.89-.39A4.8,4.8,0,0,1,75,13.22a6,6,0,0,1-.38-1.88A4.74,4.74,0,0,1,77.49,7a6,6,0,0,1,1.8-.38h.16a6,6,0,0,1,1.8.38,4.74,4.74,0,0,1,2.84,4.34v.11a6.18,6.18,0,0,1-.39,1.77,4.75,4.75,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M102.05,16.06a6,6,0,0,0,1.88-.39,4.68,4.68,0,0,1-1.88.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-200",
    points: "103.78 6.94 103.78 6.94 103.78 6.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M103.76,6.94a4.48,4.48,0,0,0-1.64-.32h0a4.59,4.59,0,0,1,1.66.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M103.92,7a6,6,0,0,0-1.8-.38,4.48,4.48,0,0,1,1.64.32h0l.14.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-204",
    x1: 102.04,
    y1: 61.42,
    x2: 102.04,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M79.37,61.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-206",
    x1: 79.37,
    y1: 61.42,
    x2: 79.37,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M79.37,61.42a4.57,4.57,0,0,1-1.89-.4h0a4.57,4.57,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M79.37,61.42a4.57,4.57,0,0,1-1.89-.4,6.11,6.11,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M102.05,61.42a5.73,5.73,0,0,0,1.88-.4,4.53,4.53,0,0,1-1.88.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M90.71,56.61a1,1,0,0,1,0-.17q0-.31,0-.63h.07c0,.27,0,.53,0,.8m0,1c0-.27,0-.55,0-.82,0,.27,0,.55,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M90.71,56.63c0-.06,0-.13,0-.19s0,.11,0,.17v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M81.26,61a4.72,4.72,0,0,0,2.83-4.33v-.1a4.54,4.54,0,0,0-.39-1.78c-.19-.55-.44-1.14-.71-1.75,2.52,1.14,5.42,2.74,7.68,2.75q0,.31,0,.63a1.34,1.34,0,0,1,0,.2v.11c0,.27,0,.55,0,.82-2.82,0-6.59,2.47-9.41,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M100.15,61c-2.81-1-6.59-3.43-9.41-3.45,0-.27,0-.55,0-.82v-.14c0-.27,0-.53,0-.8,2.26,0,5.16-1.61,7.68-2.74-.27.6-.52,1.19-.71,1.73A4.74,4.74,0,0,0,100.15,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M97.71,54.8c.19-.54.44-1.13.71-1.74.61-.27,1.2-.51,1.75-.7a4.73,4.73,0,0,0-2.46,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M81.26,61a4.72,4.72,0,0,0,2.83-4.33v0A4.72,4.72,0,0,1,81.26,61h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M83.7,54.81a4.73,4.73,0,0,0-2.45-2.45c.55.18,1.13.43,1.74.7.28.61.52,1.2.71,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M77.49,52.36A4.68,4.68,0,0,1,79.37,52a6,6,0,0,0-1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M103.92,52.36a6,6,0,0,0-1.87-.39,4.67,4.67,0,0,1,1.87.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-206",
    x1: 79.37,
    y1: 51.97,
    x2: 79.37,
    y2: 51.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-207",
    x1: 102.04,
    y1: 51.97,
    x2: 102.04,
    y2: 51.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M151.73,35.91h0a4.67,4.67,0,0,0,.39-1.76V34a4.78,4.78,0,0,1-.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M151.73,35.9a6.4,6.4,0,0,0,.39-1.76,4.67,4.67,0,0,1-.39,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M143.06,35.9a4.77,4.77,0,0,1-.39-1.89,6.07,6.07,0,0,0,.39,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M148.28,22.71l-.77,0,.77,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M148.28,22.71q-.32,0-.63,0h-.14l.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M147.55,22.68h0m.06,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M147.65,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M146.52,22.71v-.07l.77,0c-.26,0-.52,0-.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M146.52,22.71h0c.25,0,.51,0,.77,0h0c-.26,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M147.48,22.68h-.19c-.26,0-.52,0-.77,0,0-2.26-1.62-5.16-2.75-7.68.61.27,1.19.52,1.74.71a4.7,4.7,0,0,0,1.89.39h0a4.77,4.77,0,0,0,1.89-.39c.54-.19,1.13-.44,1.73-.71-1.13,2.51-2.73,5.41-2.75,7.68-.25,0-.5,0-.76,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M143.77,30.39c1.13-2.52,2.73-5.42,2.75-7.68.26,0,.52,0,.79,0h.34q.32,0,.63,0c0,2.28,1.61,5.17,2.74,7.68-.61-.27-1.19-.52-1.74-.71a4.72,4.72,0,0,0-1.88-.39h0a4.68,4.68,0,0,0-1.88.39c-.55.19-1.14.44-1.75.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M143.07,32.13c.19-.55.43-1.14.7-1.74.61-.28,1.2-.52,1.75-.71a4.66,4.66,0,0,0-2.45,2.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "147.4 29.29 147.4 29.29 147.4 29.29 147.4 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M151.73,32.12a4.78,4.78,0,0,0-2.45-2.44c.55.19,1.13.43,1.74.71.27.6.52,1.18.71,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M145.52,29.68a4.68,4.68,0,0,1,1.88-.39,4.68,4.68,0,0,0-1.88.39h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-210",
    x1: 147.4,
    y1: 29.29,
    x2: 147.4,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M143.06,32.13h0a4.69,4.69,0,0,1,2.45-2.45h0a4.78,4.78,0,0,0-2.46,2.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "147.4 29.29 147.4 29.29 147.4 29.29 147.4 29.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M149.28,7h0l-.2-.08.2.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M129.05,35.91h0a4.48,4.48,0,0,0,.39-1.76.53.53,0,0,0,0-.13,4.79,4.79,0,0,1-.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M129.05,35.9a6.06,6.06,0,0,0,.39-1.76,4.48,4.48,0,0,1-.39,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M120.39,35.9A4.77,4.77,0,0,1,120,34a6.07,6.07,0,0,0,.39,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M125.6,22.71q-.31,0-.63,0h-.14l.77,0v.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M124.87,22.68h0m.06,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M125,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M123.84,22.71v-.07l.77,0c-.26,0-.51,0-.77,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M123.84,22.71h0c.26,0,.51,0,.77,0h0l-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M124.81,22.68h-.2c-.26,0-.51,0-.77,0,0-2.26-1.62-5.16-2.75-7.68.61.27,1.19.52,1.74.71a4.77,4.77,0,0,0,1.89.39h0a4.82,4.82,0,0,0,1.9-.39c.54-.19,1.12-.44,1.73-.71-1.14,2.51-2.74,5.41-2.75,7.68-.26,0-.51,0-.77,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M121.1,30.39c1.13-2.52,2.73-5.42,2.74-7.68.26,0,.53,0,.79,0H125q.32,0,.63,0c0,2.28,1.61,5.17,2.74,7.68-.6-.27-1.19-.52-1.73-.71a4.77,4.77,0,0,0-1.89-.39,4.68,4.68,0,0,0-1.88.39c-.55.19-1.14.44-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M129.05,32.12a4.76,4.76,0,0,0-2.44-2.44c.54.19,1.13.44,1.73.71a18.13,18.13,0,0,1,.71,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M122.84,29.68a4.68,4.68,0,0,1,1.88-.39h0a4.72,4.72,0,0,0-1.88.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M120.39,32.13c.19-.55.43-1.13.71-1.74.6-.27,1.19-.52,1.74-.71a4.73,4.73,0,0,0-2.45,2.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-217",
    x1: 124.72,
    y1: 29.29,
    x2: 124.72,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M120.39,32.13h0a4.69,4.69,0,0,1,2.45-2.45h0a4.73,4.73,0,0,0-2.45,2.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-216",
    x1: 124.72,
    y1: 29.29,
    x2: 124.72,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M158.74,11.27c0-.27,0-.54,0-.81h.07q0,.4,0,.81m0,1c0-.27,0-.54,0-.82,0,.28,0,.55,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M151,15c.28-.61.52-1.19.71-1.74a4.66,4.66,0,0,0,.39-1.75v-.13A4.74,4.74,0,0,0,149.28,7c2.82,1,6.62,3.44,9.42,3.46,0,.27,0,.54,0,.81a.17.17,0,0,0,0,.07.13.13,0,0,0,0,.06c0,.28,0,.55,0,.82-2.27,0-5.17,1.61-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M166.45,15c-2.52-1.13-5.41-2.73-7.68-2.74,0-.27,0-.54,0-.82v-.13q0-.4,0-.81c2.8,0,6.61-2.49,9.43-3.46a4.73,4.73,0,0,0-2.85,4.34,10,10,0,0,0,1.1,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M174.41,13.22a6.53,6.53,0,0,0,.39-1.78,4.73,4.73,0,0,1-.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M145.52,7a4.83,4.83,0,0,1,1.83-.39h0a4.87,4.87,0,0,0-1.79.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M171.9,7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M171.89,7a4.75,4.75,0,0,0-1.81-.36h0a5,5,0,0,1,1.77.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-220",
    points: "147.4 16.06 147.4 16.06 147.4 16.06 147.4 16.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M147.4,16.06a4.7,4.7,0,0,1-1.89-.39,6,6,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M149.29,15.67a4.75,4.75,0,0,0,2.44-2.45c-.19.55-.43,1.13-.71,1.74-.6.27-1.18.52-1.73.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M152.12,11.47v-.13A4.74,4.74,0,0,0,149.28,7h0a4.74,4.74,0,0,1,2.84,4.34v.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M145.52,7a4.87,4.87,0,0,1,1.79-.39,6.75,6.75,0,0,0-1.79.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M147.4,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M124.72,61.42a4.61,4.61,0,0,1-1.89-.4h0a4.61,4.61,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M136.06,56.61v-.17l0-.63h.06c0,.27,0,.53,0,.8m0,1c0-.27,0-.55,0-.82,0,.27,0,.55,0,.82H136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M136.06,56.63v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M126.62,61a4.73,4.73,0,0,0,2.83-4.33s0-.08,0-.13a4.47,4.47,0,0,0-.39-1.75c-.19-.55-.43-1.14-.71-1.75,2.52,1.14,5.43,2.74,7.69,2.75l0,.63v.31c0,.27,0,.55,0,.82-2.83,0-6.6,2.47-9.41,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M145.5,61c-2.81-1-6.59-3.43-9.41-3.45,0-.27,0-.55,0-.82v-.14c0-.27,0-.53,0-.8,2.26,0,5.16-1.61,7.68-2.74-.27.6-.51,1.19-.71,1.73A4.74,4.74,0,0,0,145.5,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M136.06,11.28c0-.27,0-.55,0-.82h.06c0,.27,0,.55,0,.82m0,.94c0-.28,0-.55,0-.82,0,.27,0,.54,0,.82H136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M128.35,15c.27-.6.51-1.19.71-1.74a4.65,4.65,0,0,0,.38-1.75.57.57,0,0,0,0-.13A4.75,4.75,0,0,0,126.6,7c2.83,1,6.62,3.44,9.43,3.46,0,.27,0,.55,0,.82v.12c0,.27,0,.54,0,.82-2.28,0-5.17,1.61-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M143.77,15c-2.51-1.13-5.4-2.73-7.68-2.74,0-.27,0-.55,0-.82v-.12c0-.27,0-.55,0-.82,2.81,0,6.6-2.48,9.43-3.46a4.74,4.74,0,0,0-2.46,6.23c.19.54.44,1.13.71,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M122.84,7a4.83,4.83,0,0,1,1.83-.39h0a4.63,4.63,0,0,0-1.79.38h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M149.08,6.92a4.5,4.5,0,0,0-1.6-.3h0a4.91,4.91,0,0,1,1.63.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-220",
    x1: 147.4,
    y1: 16.06,
    x2: 147.4,
    y2: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M147.4,16.06a6.07,6.07,0,0,0,1.89-.39,4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M145.51,15.67c-.55-.19-1.13-.44-1.74-.71-.27-.6-.52-1.19-.7-1.73a4.73,4.73,0,0,0,2.44,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M149.28,7a6.44,6.44,0,0,0-1.8-.39,4.74,4.74,0,0,1,1.6.31l.2.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M124.72,16.06a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M126.61,15.67a4.71,4.71,0,0,0,2.44-2.45c-.19.55-.43,1.13-.7,1.74-.61.27-1.19.52-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M129.44,11.47a.57.57,0,0,0,0-.13,4.73,4.73,0,0,0-2-3.86,4.73,4.73,0,0,1,2,3.86.57.57,0,0,1,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M122.84,7a4.71,4.71,0,0,1,1.8-.38,6,6,0,0,0-1.8.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M143.07,13.23a4.61,4.61,0,0,1-.4-1.89A4.73,4.73,0,0,1,145.52,7h0a4.75,4.75,0,0,0-2.85,4.34,6.11,6.11,0,0,0,.4,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M147.31,6.62h0m4.42,6.6a6.34,6.34,0,0,0,.39-1.75,4.66,4.66,0,0,1-.39,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M147.4,16.06h0a6,6,0,0,1-1.89-.39,4.78,4.78,0,0,1-2.45-2.44,6.07,6.07,0,0,1-.39-1.89A4.75,4.75,0,0,1,145.52,7a6,6,0,0,1,1.79-.38h.17a6.06,6.06,0,0,1,1.8.38,4.74,4.74,0,0,1,2.84,4.34v.13a6.34,6.34,0,0,1-.39,1.75,4.75,4.75,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M124.72,61.42h0a4.54,4.54,0,0,0,1.89-.4h0a4.62,4.62,0,0,1-1.9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M124.72,61.42a4.61,4.61,0,0,1-1.89-.4,5.83,5.83,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M126.62,61a4.73,4.73,0,0,0,2.83-4.33s0-.08,0-.13a.62.62,0,0,1,0,.13A4.73,4.73,0,0,1,126.62,61h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M125.6,45.39l-.79,0c.26,0,.53,0,.79,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M125.6,45.39l-.79,0,.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M123.84,45.39v-.07l.79,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M124.81,45.35h-.17c-.27,0-.54,0-.8,0,0-2.26-1.62-5.16-2.75-7.68.61.27,1.19.51,1.74.7a4.61,4.61,0,0,0,1.89.4h0a4.62,4.62,0,0,0,1.9-.4c.54-.19,1.12-.43,1.73-.7-1.14,2.51-2.74,5.4-2.75,7.68-.26,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M121.1,53.07c1.13-2.52,2.73-5.43,2.74-7.68l.79,0h.18l.79,0c0,2.27,1.61,5.16,2.74,7.67-.6-.27-1.19-.51-1.74-.7a4.73,4.73,0,0,0-3.76,0,18.26,18.26,0,0,0-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M124.72,38.74a4.77,4.77,0,0,1-1.89-.39h0a4.77,4.77,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M126.62,38.34a4.69,4.69,0,0,0,2.43-2.43c-.19.55-.43,1.13-.7,1.73-.61.27-1.19.52-1.73.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-217",
    x1: 124.72,
    y1: 38.74,
    x2: 124.72,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M122.83,38.34c-.55-.19-1.13-.43-1.74-.7-.27-.61-.51-1.19-.7-1.74a4.73,4.73,0,0,0,2.44,2.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-216",
    x1: 124.72,
    y1: 38.74,
    x2: 124.72,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M122.83,38.35h0a4.74,4.74,0,0,1-2.44-2.43h0a4.75,4.75,0,0,0,2.44,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M120,34h0a4.76,4.76,0,0,1,.39-1.88A6.07,6.07,0,0,0,120,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M129.45,34a.53.53,0,0,0,0-.13,4.66,4.66,0,0,0-.38-1.76h0a4.62,4.62,0,0,1,.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M129.44,33.89a6.06,6.06,0,0,0-.39-1.76,4.48,4.48,0,0,1,.39,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M124.72,38.74h0a4.7,4.7,0,0,0,1.89-.39h0a4.62,4.62,0,0,1-1.9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M126.61,29.68h0a4.68,4.68,0,0,0-1.88-.39,4.77,4.77,0,0,1,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M124.72,38.74a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M126.62,38.34a4.67,4.67,0,0,0,2.43-2.44h0a4.73,4.73,0,0,1-2.43,2.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M129.44,34.14a.49.49,0,0,0,0-.12.53.53,0,0,0,0-.13.53.53,0,0,1,0,.13.49.49,0,0,1,0,.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M129.05,32.13a4.73,4.73,0,0,0-2.45-2.45h0a4.71,4.71,0,0,1,2.45,2.44h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M122.84,29.68a4.72,4.72,0,0,1,1.88-.39,6,6,0,0,0-1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M126.6,29.68a6,6,0,0,0-1.88-.39,4.68,4.68,0,0,1,1.88.39m-1.88,9.06h0a6.07,6.07,0,0,0,1.89-.39,4.7,4.7,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M124.72,38.74h0a6.07,6.07,0,0,1-1.89-.39,4.75,4.75,0,0,1-2.44-2.45A6.07,6.07,0,0,1,120,34a6.07,6.07,0,0,1,.39-1.88,4.73,4.73,0,0,1,2.45-2.45,4.73,4.73,0,0,1,3.76,0,4.69,4.69,0,0,1,2.45,2.45,6.06,6.06,0,0,1,.39,1.76.53.53,0,0,1,0,.13.49.49,0,0,1,0,.12,6.06,6.06,0,0,1-.39,1.76,4.75,4.75,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M129.05,54.81a4.66,4.66,0,0,0-2.45-2.45c.55.19,1.14.43,1.74.7.28.61.52,1.2.71,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M122.84,52.36a4.72,4.72,0,0,1,1.88-.39,6,6,0,0,0-1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M124.72,61.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-236",
    x1: 124.72,
    y1: 61.42,
    x2: 124.72,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M102,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M102,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M102,61.42a4.61,4.61,0,0,1-1.89-.4h0a4.53,4.53,0,0,0,1.88.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M102,61.42a4.53,4.53,0,0,1-1.88-.4,5.73,5.73,0,0,0,1.88.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M113.38,56.63c0-.27,0-.55,0-.82h.07a7.5,7.5,0,0,0,0,.82m0,.94c0-.27,0-.55,0-.82a7.5,7.5,0,0,0,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M103.94,61a4.73,4.73,0,0,0,2.83-4.33v-.1a4.73,4.73,0,0,0-.39-1.78c-.19-.55-.44-1.14-.71-1.75,2.52,1.13,5.42,2.74,7.68,2.75,0,.28,0,.55,0,.82v.12c0,.27,0,.55,0,.82-2.82,0-6.6,2.47-9.41,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M122.83,61c-2.82-1-6.59-3.43-9.41-3.45,0-.27,0-.55,0-.82v-.11c0-.28,0-.56,0-.83,2.25,0,5.16-1.61,7.68-2.74-.28.6-.52,1.19-.71,1.73a4.77,4.77,0,0,0-.39,1.89A4.72,4.72,0,0,0,122.83,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M103.93,61a4.72,4.72,0,0,0,2.84-4.33v0A4.72,4.72,0,0,1,103.94,61h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M106.38,54.81a4.71,4.71,0,0,0-2.46-2.45c.55.18,1.14.43,1.75.7.27.61.52,1.2.71,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M100.17,52.36A4.67,4.67,0,0,1,102,52a6,6,0,0,0-1.87.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-238",
    x1: 102.05,
    y1: 51.97,
    x2: 102.04,
    y2: 51.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-240",
    x1: 102.04,
    y1: 61.42,
    x2: 102.04,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M100.15,61h0a4.74,4.74,0,0,1-2.44-6.22,6.07,6.07,0,0,0-.39,1.89A4.73,4.73,0,0,0,100.15,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M106.77,56.59a6.53,6.53,0,0,0-.39-1.78,4.73,4.73,0,0,1,.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M102,61.42h0a5.83,5.83,0,0,1-1.89-.4,4.73,4.73,0,0,1-2.83-4.33,6.07,6.07,0,0,1,.39-1.89,4.73,4.73,0,0,1,2.46-2.44A6,6,0,0,1,102,52h0a6,6,0,0,1,1.88.39,4.71,4.71,0,0,1,2.46,2.45,6.53,6.53,0,0,1,.39,1.78v.1A4.72,4.72,0,0,1,103.93,61a5.73,5.73,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M122.83,61h0A4.72,4.72,0,0,1,120,56.69a4.77,4.77,0,0,1,.39-1.89,6.07,6.07,0,0,0-.39,1.89A4.72,4.72,0,0,0,122.83,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M129.44,56.56a6,6,0,0,0-.39-1.75,4.47,4.47,0,0,1,.39,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M120.39,54.8c.19-.54.43-1.13.71-1.73a18.26,18.26,0,0,1,1.74-.71,4.71,4.71,0,0,0-2.45,2.44m4.33,6.62h0a6.11,6.11,0,0,0,1.89-.4,4.54,4.54,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M126.6,52.36a6,6,0,0,0-1.88-.39,4.68,4.68,0,0,1,1.88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M124.72,61.42h0a5.83,5.83,0,0,1-1.89-.4A4.72,4.72,0,0,1,120,56.69a6.07,6.07,0,0,1,.39-1.89,4.71,4.71,0,0,1,2.45-2.44,4.73,4.73,0,0,1,3.76,0,4.66,4.66,0,0,1,2.45,2.45,6,6,0,0,1,.39,1.75.62.62,0,0,1,0,.13A4.72,4.72,0,0,1,126.61,61a6.11,6.11,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M174.4,35.91h0a4.81,4.81,0,0,0,.39-1.78V34a4.62,4.62,0,0,1-.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M174.41,35.9a6.53,6.53,0,0,0,.39-1.78,4.77,4.77,0,0,1-.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M165.74,35.9a4.77,4.77,0,0,1-.39-1.89,6.07,6.07,0,0,0,.39,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M169.2,22.71v-.06l.77,0h-.16a6.08,6.08,0,0,0-.61,0m1.75,0c-.26,0-.52,0-.79,0,.27,0,.53,0,.79,0v.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M169.81,22.68h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M170.16,22.68H170c-.26,0-.52,0-.77,0,0-2.26-1.62-5.16-2.75-7.68a10,10,0,0,0,3.62,1.1,4.74,4.74,0,0,0,4.34-2.84c-1,2.82-3.44,6.6-3.46,9.42-.26,0-.52,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M174.4,32.12a4.7,4.7,0,0,0-4.32-2.83h0a4.76,4.76,0,0,0-1.88.39c-.54.19-1.13.44-1.74.71,1.13-2.52,2.73-5.42,2.75-7.68a6.08,6.08,0,0,1,.61,0h.35c.27,0,.53,0,.79,0,0,2.82,2.48,6.6,3.45,9.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M165.74,32.13c.19-.55.44-1.13.71-1.74.61-.27,1.19-.52,1.75-.71a4.78,4.78,0,0,0-2.46,2.45"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-210",
    x1: 170.07,
    y1: 29.29,
    x2: 170.07,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M174.8,11.45v-.11A4.73,4.73,0,0,0,171.9,7a4.73,4.73,0,0,1,2.9,4.36v.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M168.2,7A4.87,4.87,0,0,1,170,6.61,6.67,6.67,0,0,0,168.2,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M170.07,16.06a10,10,0,0,1-3.62-1.1,10,10,0,0,1-1.1-3.62A4.73,4.73,0,0,1,168.2,7,5.94,5.94,0,0,1,170,6.62h.09a4.75,4.75,0,0,1,1.81.36h0a4.73,4.73,0,0,1,2.9,4.36v.11a6.54,6.54,0,0,1-.39,1.77,4.72,4.72,0,0,1-4.34,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M147.4,61.42h0a4.61,4.61,0,0,0,1.89-.4h0a4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M147.4,61.42a5.83,5.83,0,0,0,1.89-.4,4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M148.28,45.39l-.8,0c.27,0,.53,0,.8,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M146.52,45.39v-.07c.26,0,.53,0,.79,0l-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M147.48,45.35h-.17c-.27,0-.53,0-.79,0,0-2.26-1.62-5.16-2.75-7.68.61.27,1.19.51,1.73.7a4.62,4.62,0,0,0,1.9.4h0a4.61,4.61,0,0,0,1.89-.4c.55-.19,1.13-.43,1.73-.7-1.13,2.51-2.73,5.4-2.75,7.68-.26,0-.52,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M143.77,53.07c1.13-2.52,2.73-5.43,2.75-7.68.26,0,.52,0,.79,0h.17c.27,0,.53,0,.8,0,0,2.27,1.61,5.16,2.74,7.67-.61-.27-1.19-.51-1.74-.7A4.72,4.72,0,0,0,147.4,52h0a4.68,4.68,0,0,0-1.88.39c-.55.19-1.14.43-1.75.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-210",
    x1: 147.4,
    y1: 38.74,
    x2: 147.4,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M145.5,38.34c-.54-.19-1.12-.43-1.73-.7-.27-.61-.51-1.19-.7-1.73a4.73,4.73,0,0,0,2.43,2.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M147.4,38.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M147.4,38.74a4.7,4.7,0,0,1-1.89-.39h0a4.73,4.73,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M149.29,38.34a4.74,4.74,0,0,0,2.44-2.43c-.19.55-.44,1.13-.71,1.73-.6.27-1.18.51-1.73.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-211",
    x1: 147.4,
    y1: 38.74,
    x2: 147.4,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M145.51,38.35h0a4.76,4.76,0,0,1-2.44-2.44h0a4.8,4.8,0,0,0,2.45,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M142.67,34h0a4.76,4.76,0,0,1,.39-1.88,6.07,6.07,0,0,0-.39,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M152.12,34v-.13a4.67,4.67,0,0,0-.39-1.76h0a4.78,4.78,0,0,1,.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M152.12,33.89a6.4,6.4,0,0,0-.39-1.76,4.67,4.67,0,0,1,.39,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M149.28,29.68h0a4.72,4.72,0,0,0-1.88-.39,4.72,4.72,0,0,1,1.88.39m-1.88,9.06h0a4.77,4.77,0,0,0,1.89-.39h0a4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M149.28,29.68a6,6,0,0,0-1.88-.39,4.72,4.72,0,0,1,1.88.39m-1.88,9.06a6.07,6.07,0,0,0,1.89-.39,4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-232",
    x1: 147.4,
    y1: 38.74,
    x2: 147.4,
    y2: 38.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M147.4,38.74a4.73,4.73,0,0,1-1.89-.39,6,6,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M149.29,38.35a4.75,4.75,0,0,0,2.44-2.45h0a4.71,4.71,0,0,1-2.44,2.43h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M152.12,34.14v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M151.73,32.13a4.76,4.76,0,0,0-2.45-2.45h0a4.78,4.78,0,0,1,2.45,2.44h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M145.52,29.68a4.67,4.67,0,0,1,1.87-.39,6,6,0,0,0-1.87.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-232",
    x1: 147.4,
    y1: 29.29,
    x2: 147.4,
    y2: 29.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M147.4,38.74h0a6,6,0,0,1-1.89-.39,4.8,4.8,0,0,1-2.45-2.45,6.07,6.07,0,0,1-.39-1.89,6.07,6.07,0,0,1,.39-1.88,4.75,4.75,0,0,1,2.46-2.45,6,6,0,0,1,1.88-.39h0a6,6,0,0,1,1.88.39,4.73,4.73,0,0,1,2.45,2.45,6.48,6.48,0,0,1,.39,1.76v.25a6.4,6.4,0,0,1-.39,1.76,4.78,4.78,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M143.07,54.8c.19-.54.43-1.13.7-1.74.61-.27,1.2-.51,1.75-.7a4.67,4.67,0,0,0-2.45,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M149.28,52.36A6,6,0,0,0,147.4,52a4.72,4.72,0,0,1,1.88.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "147.4 51.97 147.4 51.97 147.4 51.97 147.4 51.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-219",
    x1: 170.07,
    y1: 61.42,
    x2: 170.07,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M147.4,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M147.4,61.42a4.54,4.54,0,0,1-1.89-.4h0a4.54,4.54,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-246",
    x1: 147.4,
    y1: 61.42,
    x2: 147.4,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M145.51,61h0a4.74,4.74,0,0,1-2.44-6.22,6.37,6.37,0,0,0-.39,1.89A4.72,4.72,0,0,0,145.51,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M158.74,56.61a.66.66,0,0,1,0-.14q0-.33,0-.66h.07c0,.27,0,.53,0,.8m0,1c0-.27,0-.54,0-.81q0,.41,0,.81h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M158.74,56.63c0-.06,0-.1,0-.16s0,.09,0,.14v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M149.29,61a4.72,4.72,0,0,0,2.83-4.33v-.13a4.66,4.66,0,0,0-.39-1.75c-.19-.55-.43-1.14-.71-1.75,2.52,1.14,5.42,2.74,7.68,2.75,0,.22,0,.44,0,.67a.81.81,0,0,0,0,.15.13.13,0,0,0,0,.06.2.2,0,0,0,0,.07c0,.27,0,.54,0,.81-2.82,0-6.59,2.47-9.41,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M168.18,61c-2.81-1-6.59-3.43-9.41-3.45q0-.41,0-.81v-.15c0-.27,0-.53,0-.8,2.26,0,5.16-1.61,7.68-2.74a10,10,0,0,0-1.1,3.62A4.73,4.73,0,0,0,168.18,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M152.12,56.56a6.34,6.34,0,0,0-.39-1.75,4.66,4.66,0,0,1,.39,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M174.8,56.59a6.53,6.53,0,0,0-.39-1.78,4.93,4.93,0,0,1,.39,1.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-224",
    x1: 147.4,
    y1: 61.42,
    x2: 147.4,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M147.4,61.42a4.57,4.57,0,0,1-1.89-.4,5.73,5.73,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M149.29,61a4.72,4.72,0,0,0,2.83-4.33v0A4.72,4.72,0,0,1,149.29,61h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M151.73,54.81a4.69,4.69,0,0,0-2.45-2.45c.54.19,1.13.43,1.74.7.28.61.52,1.2.71,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M145.52,52.36A4.68,4.68,0,0,1,147.4,52a6,6,0,0,0-1.88.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-224",
    x1: 147.4,
    y1: 51.97,
    x2: 147.4,
    y2: 51.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M147.4,61.42h0a5.73,5.73,0,0,1-1.89-.4,4.72,4.72,0,0,1-2.84-4.33,5.83,5.83,0,0,1,.4-1.89,4.67,4.67,0,0,1,2.45-2.44A6,6,0,0,1,147.4,52h0a6,6,0,0,1,1.88.39,4.73,4.73,0,0,1,2.45,2.45,6.34,6.34,0,0,1,.39,1.75v.13A4.72,4.72,0,0,1,149.29,61a5.83,5.83,0,0,1-1.89.4h0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-250",
    x1: 102.04,
    y1: 16.06,
    x2: 102.04,
    y2: 16.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M102,16.06a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M113.38,11.28c0-.27,0-.55,0-.82h.07a7.5,7.5,0,0,0,0,.82m0,.94c0-.28,0-.55,0-.82a7.63,7.63,0,0,0,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M105.67,15c.27-.6.52-1.19.71-1.74a4.72,4.72,0,0,0,.39-1.77v-.11A4.73,4.73,0,0,0,103.92,7c2.83,1,6.62,3.44,9.43,3.46,0,.27,0,.55,0,.82v.12c0,.27,0,.55,0,.82-2.28,0-5.17,1.61-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M121.09,15c-2.51-1.13-5.4-2.73-7.67-2.74,0-.27,0-.55,0-.82v-.12c0-.27,0-.55,0-.82,2.8,0,6.59-2.48,9.42-3.46a4.75,4.75,0,0,0-2.45,6.23c.19.54.43,1.13.7,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M103.93,15.67a4.73,4.73,0,0,0,2.45-2.45c-.19.55-.44,1.14-.71,1.74-.61.28-1.19.52-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M106.77,11.45v-.11A4.73,4.73,0,0,0,103.92,7h0a4.73,4.73,0,0,1,2.85,4.34v.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M126.6,7h0a4.67,4.67,0,0,0-1.8-.38h0A4.83,4.83,0,0,1,126.6,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M100.16,7A4.87,4.87,0,0,1,102,6.61h0a4.87,4.87,0,0,0-1.79.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M100.17,7A4.87,4.87,0,0,1,102,6.61a6.3,6.3,0,0,0-1.79.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M97.71,13.23A4.75,4.75,0,0,1,100.16,7h0a4.75,4.75,0,0,0-2.85,4.34,6.07,6.07,0,0,0,.39,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M102,6.61h0m4.42,6.61a6.53,6.53,0,0,0,.39-1.78,4.73,4.73,0,0,1-.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M102,16.06h0a6.07,6.07,0,0,1-1.89-.39,4.76,4.76,0,0,1-2.44-2.44,6.07,6.07,0,0,1-.39-1.89A4.72,4.72,0,0,1,100.17,7,5.94,5.94,0,0,1,102,6.62h.16a6,6,0,0,1,1.8.38,4.73,4.73,0,0,1,2.85,4.34v.11a6.54,6.54,0,0,1-.39,1.77,4.76,4.76,0,0,1-2.45,2.45,6,6,0,0,1-1.88.39h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M124.72,16.06h0a6.07,6.07,0,0,0,1.89-.39,4.7,4.7,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M126.6,7a6.73,6.73,0,0,0-1.8-.39,4.68,4.68,0,0,1,1.8.39m-3.77,8.67c-.55-.19-1.13-.44-1.74-.71-.27-.6-.51-1.19-.7-1.73a4.73,4.73,0,0,0,2.44,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M120.39,13.23a4.77,4.77,0,0,1-.39-1.89A4.71,4.71,0,0,1,122.84,7h0A4.74,4.74,0,0,0,120,11.34a6.07,6.07,0,0,0,.39,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M127.44,7.48A4.35,4.35,0,0,0,126.6,7h0a4.35,4.35,0,0,1,.84.48m1.62,5.74a6.29,6.29,0,0,0,.38-1.75,4.65,4.65,0,0,1-.38,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M124.64,6.62h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M124.72,16.06a6.07,6.07,0,0,1-1.89-.39,4.76,4.76,0,0,1-2.44-2.44,6.07,6.07,0,0,1-.39-1.89A4.74,4.74,0,0,1,122.84,7a6,6,0,0,1,1.8-.38h.16a6,6,0,0,1,1.8.38,4.75,4.75,0,0,1,.85.48,4.7,4.7,0,0,1,2,3.86.57.57,0,0,1,0,.13,6,6,0,0,1-.39,1.75,4.75,4.75,0,0,1-2.44,2.45,6.07,6.07,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M170.07,61.42h0a4.73,4.73,0,0,0,4.73-4.73v0a4.73,4.73,0,0,1-4.73,4.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M170.07,61.42a4.61,4.61,0,0,1-1.89-.4,6.11,6.11,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M169.2,45.39v-.07c.26,0,.52,0,.79,0l-.79,0m1.75,0-.79,0c.27,0,.53,0,.79,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M170.16,45.35H170c-.27,0-.53,0-.79,0,0-2.26-1.62-5.16-2.75-7.68.6.27,1.19.52,1.73.7a4.61,4.61,0,0,0,1.89.4h0a4.71,4.71,0,0,0,4.32-2.83c-1,2.82-3.43,6.59-3.45,9.41-.26,0-.52,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M174.41,54.81A4.74,4.74,0,0,0,170.07,52a10,10,0,0,0-3.62,1.1c1.13-2.52,2.73-5.43,2.75-7.68l.79,0h.17l.79,0c0,2.82,2.48,6.6,3.46,9.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-210",
    points: "170.07 38.74 170.07 38.74 170.07 38.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M168.18,38.35c-.54-.19-1.13-.44-1.73-.71-.28-.61-.52-1.19-.71-1.74a4.78,4.78,0,0,0,2.44,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M165.35,34h0a4.76,4.76,0,0,1,.39-1.88,6.07,6.07,0,0,0-.39,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M174.8,34v-.11a5,5,0,0,0-.39-1.78h0a4.62,4.62,0,0,1,.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M174.8,33.91a6.53,6.53,0,0,0-.39-1.78,5,5,0,0,1,.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M170.07,38.74h0a4.74,4.74,0,0,0,4.34-2.84h0a4.72,4.72,0,0,1-4.33,2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M170.07,38.74a4.77,4.77,0,0,1-1.89-.39,6.07,6.07,0,0,0,1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M174.8,34.12v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M174.41,32.13a4.74,4.74,0,0,0-4.34-2.84,4.74,4.74,0,0,1,4.34,2.83h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M168.2,29.68a4.64,4.64,0,0,1,1.87-.39,6,6,0,0,0-1.87.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M170.07,38.74h0a6.07,6.07,0,0,1-1.89-.39,4.78,4.78,0,0,1-2.44-2.45,6.07,6.07,0,0,1-.39-1.89,6.07,6.07,0,0,1,.39-1.88,4.75,4.75,0,0,1,2.46-2.45,6,6,0,0,1,1.87-.39h0a4.74,4.74,0,0,1,4.34,2.84,6.53,6.53,0,0,1,.39,1.78v.21a6.53,6.53,0,0,1-.39,1.78,4.74,4.74,0,0,1-4.34,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M170.07,61.42h0a6.11,6.11,0,0,1-1.89-.4,4.73,4.73,0,0,1-2.83-4.33,9.92,9.92,0,0,1,1.1-3.62,10,10,0,0,1,3.62-1.1,4.74,4.74,0,0,1,4.34,2.84,6.53,6.53,0,0,1,.39,1.78v.1a4.73,4.73,0,0,1-4.73,4.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M11.34,61.42h0a6.11,6.11,0,0,0,1.89-.4,4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M10.46,45.39v-.07c.26,0,.53,0,.79,0l-.79,0m1.76,0-.79,0c.26,0,.53,0,.79,0v.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M11.43,45.35h-.18c-.26,0-.53,0-.79,0,0-2.8-2.48-6.59-3.45-9.42a4.72,4.72,0,0,0,4.33,2.84,4.61,4.61,0,0,0,1.89-.4c.55-.19,1.13-.43,1.73-.7-1.13,2.51-2.73,5.4-2.74,7.68-.26,0-.53,0-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M7,54.8c1-2.82,3.43-6.61,3.45-9.41l.79,0h.18l.79,0c0,2.27,1.61,5.16,2.74,7.67A9.93,9.93,0,0,0,11.34,52,4.72,4.72,0,0,0,7,54.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M13.22,29.68a6,6,0,0,0-1.88-.39,4.72,4.72,0,0,1,1.88.39m-1.88,9.06h0a6.07,6.07,0,0,0,1.89-.39,4.77,4.77,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M11.34,61.42a4.73,4.73,0,0,1-4.73-4.73A5.83,5.83,0,0,1,7,54.8,4.72,4.72,0,0,1,11.34,52,9.93,9.93,0,0,1,15,53.06a10,10,0,0,1,1.1,3.63A4.72,4.72,0,0,1,13.23,61a6.11,6.11,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M11.34,38.74A4.73,4.73,0,0,1,7,35.91H7a4.74,4.74,0,0,0,4.34,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M13.23,38.34a4.71,4.71,0,0,0,2.44-2.43c-.19.54-.44,1.12-.71,1.73-.6.27-1.18.51-1.73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M6.62,34h0A4.59,4.59,0,0,1,7,32.13,5.79,5.79,0,0,0,6.62,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M16.06,34a6.07,6.07,0,0,0-.39-1.9,4.78,4.78,0,0,1,.39,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M11.34,38.74A4.74,4.74,0,0,1,7,35.9,6.07,6.07,0,0,1,6.61,34,6.07,6.07,0,0,1,7,32.13a4.74,4.74,0,0,1,4.34-2.84,6,6,0,0,1,1.88.39,4.75,4.75,0,0,1,2.45,2.44A6.07,6.07,0,0,1,16.06,34a6.07,6.07,0,0,1-.39,1.9,4.76,4.76,0,0,1-2.44,2.44,6.07,6.07,0,0,1-1.89.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.77,66.83A11.33,11.33,0,0,0,68,57.57a11.34,11.34,0,0,1-6.22,9.26h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M56.69,68H56.2a11.18,11.18,0,0,1-4.54-1.17l0,0a11.34,11.34,0,0,1-6.22-9.26C48.21,57.59,52,60,54.8,61a4.61,4.61,0,0,0,1.89.4h0a4.62,4.62,0,0,0,1.9-.4c2.81-1,6.59-3.43,9.41-3.45a11.33,11.33,0,0,1-6.23,9.26l-.05,0A11.13,11.13,0,0,1,57.19,68h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M56.69,61.42h0a4.61,4.61,0,0,0,1.89-.4h0a4.62,4.62,0,0,1-1.9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.67,46.5h0a11.12,11.12,0,0,0-4.07-1.1h0a11.5,11.5,0,0,1,4.1,1.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68,55.81h0a11.38,11.38,0,0,0-1.14-4.15h0A11.44,11.44,0,0,1,68,55.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.86,51.66a11.44,11.44,0,0,0-5.21-5.17h0a11.43,11.43,0,0,1,5.18,5.15h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M68,55.81c-2.26,0-5.17-1.61-7.69-2.75-1.13-2.51-2.73-5.4-2.74-7.67a11.23,11.23,0,0,1,4.08,1.1A11.33,11.33,0,0,1,68,55.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.71,46.5a11.29,11.29,0,0,1,4.1-1.11,11.29,11.29,0,0,0-4.09,1.11h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.64,46.54l.07,0h0l-.06,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.21,50.47a11.35,11.35,0,0,1,4.43-3.93h0a11.36,11.36,0,0,0-4.45,3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M45.39,55.81a11.32,11.32,0,0,1,6.27-9.28l.06,0a11.23,11.23,0,0,1,4.1-1.11c0,2.25-1.62,5.16-2.75,7.68-2.52,1.13-5.42,2.73-7.68,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M57.57,45.39l-.79,0h0l.74,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M55.82,45.39h0l.74,0h0l-.79,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M56.78,45.35h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M53.07,53.07c1.13-2.52,2.73-5.43,2.75-7.68.26,0,.52,0,.78,0h.18c.26,0,.53,0,.79,0,0,2.27,1.61,5.16,2.75,7.67-.61-.27-1.2-.51-1.75-.7A4.68,4.68,0,0,0,56.69,52h0a4.72,4.72,0,0,0-1.88.39,18.26,18.26,0,0,0-1.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M79.37,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M79.37,61.42a5.83,5.83,0,0,0,1.89-.4,4.61,4.61,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M68,56.61v-.13l0-.67h.06c0,.27,0,.53,0,.8m0,1q0-.41,0-.81,0,.41,0,.81H68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M68,56.63v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M77.48,61c-2.82-1-6.59-3.43-9.42-3.45q0-.41,0-.81v-.15c0-.27,0-.53,0-.8,2.26,0,5.16-1.61,7.68-2.74-.27.6-.52,1.19-.71,1.74a4.71,4.71,0,0,0-.38,1.88h0a4.72,4.72,0,0,0,.94,2.84h0A4.76,4.76,0,0,0,77.48,61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-267",
    points: "75.59 59.53 75.59 59.53 75.59 59.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M75,54.81c.19-.55.44-1.14.71-1.74.61-.28,1.2-.52,1.75-.71A4.71,4.71,0,0,0,75,54.81m.56,4.72a4.73,4.73,0,0,1-1-2.84,4.73,4.73,0,0,0,1,2.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M81.25,52.36A6,6,0,0,0,79.37,52a4.72,4.72,0,0,1,1.88.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "79.37 51.97 79.37 51.97 79.37 51.97 79.37 51.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-268",
    x1: 79.37,
    y1: 61.42,
    x2: 79.37,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M77.48,61h0a4.76,4.76,0,0,1-1.89-1.49A4.76,4.76,0,0,0,77.48,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M75.59,59.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M74.64,56.69h0A4.72,4.72,0,0,1,75,54.81a6,6,0,0,0-.39,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M84.09,56.59a6.17,6.17,0,0,0-.39-1.78,4.54,4.54,0,0,1,.39,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M79.37,61.42h0a6.11,6.11,0,0,1-1.89-.4,4.76,4.76,0,0,1-1.89-1.49h0a4.72,4.72,0,0,1-.94-2.84A5.74,5.74,0,0,1,75,54.81a4.66,4.66,0,0,1,2.45-2.45A6,6,0,0,1,79.37,52h0a6,6,0,0,1,1.88.39,4.73,4.73,0,0,1,2.45,2.45,6.17,6.17,0,0,1,.39,1.78v.1A4.72,4.72,0,0,1,81.26,61a5.83,5.83,0,0,1-1.89.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M56.69,61.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-271",
    x1: 56.69,
    y1: 61.42,
    x2: 56.69,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M56.69,61.42A4.61,4.61,0,0,1,54.8,61h0a4.61,4.61,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M56.69,61.42A4.61,4.61,0,0,1,54.8,61a6.11,6.11,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M68,56.48v0l0-.63,0,.67m0,1.09c0-.27,0-.55,0-.82h0q0,.41,0,.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M68,56.63v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M58.59,61a4.73,4.73,0,0,0,2.83-4.33v-.1A4.92,4.92,0,0,0,61,54.8c-.19-.54-.43-1.13-.71-1.74,2.52,1.14,5.43,2.74,7.69,2.75l0,.63v.31c0,.27,0,.55,0,.82-2.83,0-6.6,2.47-9.41,3.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "68.03 56.76 68.03 56.75 68.03 56.69 68.03 56.63 68.03 56.63 68.03 56.69 68.03 56.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M58.58,61a4.72,4.72,0,0,0,2.84-4.33v0A4.73,4.73,0,0,1,58.59,61h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M61,54.81a4.66,4.66,0,0,0-2.45-2.45c.55.19,1.14.43,1.75.7.27.61.51,1.2.7,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M54.81,52.36A4.72,4.72,0,0,1,56.69,52a6,6,0,0,0-1.88.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-271",
    x1: 56.69,
    y1: 51.97,
    x2: 56.69,
    y2: 51.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M34,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M34,61.42a4.61,4.61,0,0,1-1.89-.4h0a4.61,4.61,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M45.35,56.61v-.17q0-.31,0-.63h.07c0,.27,0,.53,0,.8m0,1c0-.27,0-.55,0-.82,0,.27,0,.55,0,.82h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M45.35,56.63v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M35.91,61a4.72,4.72,0,0,0,2.83-4.33v-.13a4.66,4.66,0,0,0-.39-1.75c-.19-.55-.44-1.14-.71-1.75,2.52,1.14,5.42,2.74,7.68,2.75q0,.31,0,.63v.31c0,.27,0,.55,0,.82-2.82,0-6.59,2.47-9.41,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M45.39,57.57h0c0-.27,0-.55,0-.82v-.14c0-.27,0-.53,0-.8,0,.29,0,.59,0,.88s0,.59,0,.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-276",
    x1: 34.02,
    y1: 61.42,
    x2: 34.02,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M34,61.42a4.61,4.61,0,0,1-1.89-.4,5.83,5.83,0,0,0,1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M35.91,61a4.73,4.73,0,0,0,2.83-4.33v0A4.72,4.72,0,0,1,35.91,61h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M38.35,54.81a4.77,4.77,0,0,0-2.46-2.46c.55.2,1.14.44,1.75.71.27.61.52,1.2.71,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M32.14,52.36A4.67,4.67,0,0,1,34,52a6,6,0,0,0-1.87.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-276",
    x1: 34.02,
    y1: 51.97,
    x2: 34.01,
    y2: 51.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-277",
    x1: 34.02,
    y1: 61.42,
    x2: 34.01,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M32.12,61h0a4.73,4.73,0,0,1-2-1.73,4.73,4.73,0,0,0,2,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M29.29,56.69h0a4.72,4.72,0,0,1,.39-1.88,6,6,0,0,0-.39,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M38.74,56.56a6.34,6.34,0,0,0-.39-1.75,4.66,4.66,0,0,1,.39,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M34,61.42h0a5.83,5.83,0,0,1-1.89-.4,4.73,4.73,0,0,1-2-1.73h0a4.68,4.68,0,0,1-.78-2.59,6,6,0,0,1,.39-1.88,4.71,4.71,0,0,1,2.46-2.45A6,6,0,0,1,34,52h0a6,6,0,0,1,1.87.39,4.71,4.71,0,0,1,2.46,2.45,6.34,6.34,0,0,1,.39,1.75v.13A4.73,4.73,0,0,1,35.91,61a5.83,5.83,0,0,1-1.89.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M56.69,61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M56.69,61.42a5.83,5.83,0,0,0,1.89-.4,4.54,4.54,0,0,1-1.89.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M54.8,61c-2.82-1-6.59-3.43-9.41-3.45a8.51,8.51,0,0,1,0-.88,8.64,8.64,0,0,1,0-.88c2.26,0,5.16-1.61,7.68-2.74a18.26,18.26,0,0,0-.71,1.74A4.77,4.77,0,0,0,52,56.62v.07A4.71,4.71,0,0,0,54.8,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M53.56,60.23A4.69,4.69,0,0,1,52,56.69v0a4.69,4.69,0,0,0,1.59,3.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M52.36,54.81c.19-.55.43-1.13.71-1.75.61-.27,1.19-.51,1.74-.7a4.66,4.66,0,0,0-2.45,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M58.57,52.36A6,6,0,0,0,56.69,52a4.68,4.68,0,0,1,1.88.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "56.69 51.97 56.69 51.97 56.69 51.97 56.69 51.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-280",
    x1: 56.69,
    y1: 61.42,
    x2: 56.69,
    y2: 61.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M52,56.62a4.59,4.59,0,0,1,.39-1.81A6.16,6.16,0,0,0,52,56.62M54.8,61h0a5,5,0,0,1-1.24-.79A4.75,4.75,0,0,0,54.8,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M61.42,56.59a6.29,6.29,0,0,0-.4-1.78,4.82,4.82,0,0,1,.4,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M56.69,61.42h0A6.11,6.11,0,0,1,54.8,61a4.75,4.75,0,0,1-1.24-.79A4.69,4.69,0,0,1,52,56.69v-.07a6.16,6.16,0,0,1,.39-1.81,4.66,4.66,0,0,1,2.45-2.45A6,6,0,0,1,56.69,52h0a6,6,0,0,1,1.88.39A4.66,4.66,0,0,1,61,54.81a6.29,6.29,0,0,1,.4,1.78v.1A4.72,4.72,0,0,1,58.58,61a5.78,5.78,0,0,1-1.89.4h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M16.06,56.69A4.73,4.73,0,1,1,11.34,52a4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M38.74,56.69A4.73,4.73,0,1,1,34,52a4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M61.42,56.69A4.73,4.73,0,1,1,56.69,52a4.73,4.73,0,0,1,4.73,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M16.06,34a4.73,4.73,0,1,1-4.72-4.73A4.72,4.72,0,0,1,16.06,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M16.06,11.34a4.73,4.73,0,1,1-4.72-4.72,4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M38.74,11.34A4.73,4.73,0,1,1,34,6.62a4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M61.42,11.34a4.73,4.73,0,1,1-4.73-4.72,4.72,4.72,0,0,1,4.73,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M84.09,11.34a4.73,4.73,0,1,1-4.72-4.72,4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M106.77,11.34a4.73,4.73,0,1,1-4.72-4.72,4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M129.45,11.34a4.73,4.73,0,1,1-4.73-4.72,4.72,4.72,0,0,1,4.73,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M152.12,11.34a4.73,4.73,0,1,1-4.72-4.72,4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M174.8,11.34a4.73,4.73,0,1,1-4.72-4.72,4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M174.8,34a4.73,4.73,0,1,1-4.72-4.73A4.73,4.73,0,0,1,174.8,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M174.8,56.69A4.73,4.73,0,1,1,170.08,52a4.73,4.73,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M152.12,34a4.73,4.73,0,1,1-4.72-4.73A4.72,4.72,0,0,1,152.12,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M152.12,56.69A4.73,4.73,0,1,1,147.4,52a4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M129.45,56.69A4.73,4.73,0,1,1,124.72,52a4.73,4.73,0,0,1,4.73,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M129.45,34a4.73,4.73,0,1,1-4.73-4.73A4.73,4.73,0,0,1,129.45,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M106.77,34a4.73,4.73,0,1,1-4.72-4.73A4.73,4.73,0,0,1,106.77,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M84.09,34a4.73,4.73,0,1,1-4.72-4.73A4.72,4.72,0,0,1,84.09,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M61.42,34a4.73,4.73,0,1,1-4.73-4.73A4.73,4.73,0,0,1,61.42,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M38.74,34A4.73,4.73,0,1,1,34,29.29,4.72,4.72,0,0,1,38.74,34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M84.09,56.69A4.73,4.73,0,1,1,79.37,52a4.72,4.72,0,0,1,4.72,4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M106.77,56.69A4.73,4.73,0,1,1,102.05,52a4.73,4.73,0,0,1,4.72,4.72"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Full_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("use", {
    width: 374.32,
    height: 68.03,
    xlinkHref: "#LOGO"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "204.26 75.74 204.26 78.8 207.66 78.8 207.66 96.16 211.16 96.16 211.16 78.8 214.56 78.8 214.56 75.74 204.26 75.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M233.89,84.9h1.25c1.89,0,2.6-.7,2.6-3.14s-.71-3.14-2.6-3.14h-1.25Zm0,11.26h-3.51V75.74h4.93c3.93,0,5.93,1.67,5.93,6,0,3.29-1.27,4.61-2.46,5.15l3,9.25h-3.56L235.7,87.7a15.82,15.82,0,0,1-1.81.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M262.7,79.81h.06l1.38,8.77h-2.83Zm-2.15-4.07-3.76,20.42h3.39l.63-4.53h3.84l.62,4.53h3.4L264.9,75.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M287.52,93.27h1.22c1.86,0,2.51-.7,2.51-2.85V81.48c0-2.15-.65-2.86-2.51-2.86h-1.22ZM284,75.74h5.2c3.62,0,5.55,2,5.55,6.17V90c0,4.19-1.93,6.17-5.55,6.17H284Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-302",
    x: 314.29,
    y: 75.74,
    width: 3.5,
    height: 20.42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "344.91 75.74 344.91 87.42 344.85 87.42 340.58 75.74 337.33 75.74 337.33 96.16 340.5 96.16 340.5 83.4 340.55 83.4 345.02 96.16 348.07 96.16 348.07 75.74 344.91 75.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M368.23,85.81H374V96.16h-1.69l-.65-1.53a4.07,4.07,0,0,1-3.54,1.81c-2.77,0-4.69-2-4.69-5.23V80.69c0-2.89,1.69-5.23,5.14-5.23s5.26,2.54,5.26,5.6v1.3h-3.33c0-3.06-.62-3.85-2-3.85-.85,0-1.55.51-1.55,2.23v10.5c0,1.3.42,2.15,1.63,2.15,1.42,0,1.93-.79,1.93-2.83v-2h-2.24Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImc);
export default __webpack_public_path__ + "static/media/IMC.0602026d0c6b7f64646d3411529b9abe.svg";
export { ForwardRef as ReactComponent };